var _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpticaImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-32",
    d: "M75.39,432.14C-21,376.46-21,286.19,75.39,230.51s252.79-55.67,349.22,0,96.44,146,0,201.63S171.83,487.81,75.39,432.14Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-32",
    points: "38.2 342.65 111.23 384.81 267 294.87 193.98 252.71 38.2 342.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-32",
    cx: 58.32,
    cy: 394.12,
    rx: 22.39,
    ry: 12.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-32",
    cx: 271.27,
    cy: 406.51,
    rx: 52.5,
    ry: 30.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-32",
    d: "M277.2,237.8l-17.95,10.38L470.68,370.24l17.95-10.39Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Poster--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--poster--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165.79 151.67 131.47 171.48 131.47 85.89 165.79 66.08 165.79 151.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.94 152.43 132.62 172.24 132.62 86.66 166.94 66.84 166.94 152.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,152.53l-34.52,19.93V86.56L167,66.63ZM132.72,172l34.11-19.7V67.06L132.72,86.75Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.89,84.78,148.8,86v2.71l2-1.15.05-1.16.94-.54v2.59l-4.87,2.81V90.1l.66-.58V82.73l-.66.18V81.76l.66-.37,4.2-2.43v2.59l-.94.55-.06-1.1-2,1.14v2.38l2.09-1.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,103.38l.53-.46V97.48l-.53.15v-.92l3.93-2.26v2.07l-.76.44,0-.88-1.6.93V99.1l1.72-1v1.17l-1.72,1v2.08l.52-.15v.91l-2,1.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87,90.44c.56-.33,1-.36,1.33-.1a1.76,1.76,0,0,1,.49,1.47,4.32,4.32,0,0,1-.49,2,3.36,3.36,0,0,1-1.33,1.43l-.83.48v1.68l.52-.15v.92l-2,1.17v-.91l.53-.46V92.56l-.53.15v-.92l.53-.3ZM153,94.58l.83-.48a1.54,1.54,0,0,0,.62-.71,2.39,2.39,0,0,0,.21-1,1.14,1.14,0,0,0-.21-.78c-.14-.16-.35-.16-.62,0l-.83.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,106.91v1.62l-.61.35,0-.66-.73.42v4.29l.42-.11v.73l-1.64,1v-.74l.43-.37V109.1l-.73.42,0,.7-.61.35v-1.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,105.78a6.34,6.34,0,0,1-.5,2.5,3.3,3.3,0,0,1-1.3,1.62.92.92,0,0,1-1.3-.12,3,3,0,0,1-.49-1.93v-.09a6.33,6.33,0,0,1,.49-2.5,3.24,3.24,0,0,1,1.29-1.62.94.94,0,0,1,1.31.12,3,3,0,0,1,.5,1.92Zm-.79.35a2.9,2.9,0,0,0-.26-1.39c-.17-.29-.42-.34-.76-.15a1.73,1.73,0,0,0-.74,1,5,5,0,0,0-.25,1.68v.1a3,3,0,0,0,.25,1.41c.17.29.41.35.75.15a1.79,1.79,0,0,0,.75-1,5.19,5.19,0,0,0,.26-1.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.92,99v.61L156,105.26l1.38-.79.06-.78.6-.34-.06,1.7-3,1.71v-.64l1.93-5.63-1.26.73-.06.77-.61.35.06-1.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,123.39v-.55l.31-.27v-3.24l-.31.09v-.55l.31-.18.59-.34.31-.18v.55l-.31.27v3.18l.83-.47,0-.59.45-.26v1.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,115c.34-.2.6-.22.8-.06a1.07,1.07,0,0,1,.29.87,2.63,2.63,0,0,1-.29,1.21,2,2,0,0,1-.8.85l-.49.29v1l.31-.09v.55l-1.21.7v-.55l.31-.27V116.3l-.31.09v-.55l.31-.18Zm-.49,2.46.49-.28a.89.89,0,0,0,.37-.42,1.38,1.38,0,0,0,.13-.6.68.68,0,0,0-.13-.47c-.08-.09-.2-.09-.37,0l-.49.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.48,108.77a.69.69,0,0,1,.89,0,1.53,1.53,0,0,1,.35,1.15v.75a3.56,3.56,0,0,1-.35,1.55,2.27,2.27,0,0,1-.89,1l-1.32.76v-.54l.32-.27V110l-.32.08v-.54l.32-.18Zm-.42.94v3.12l.39-.23a1.2,1.2,0,0,0,.5-.61,2.49,2.49,0,0,0,.18-1v-.76a1.2,1.2,0,0,0-.18-.74.35.35,0,0,0-.5,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.71,114.05l-1,.58v1.29l.94-.55,0-.56.45-.25v1.23l-2.32,1.34v-.54l.31-.28v-3.24l-.31.09v-.54l.31-.18,2-1.16v1.24l-.45.26,0-.53-.94.54v1.14l1-.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.21,126.26c.25-.15.46-.17.6-.05a.82.82,0,0,1,.23.67,2,2,0,0,1-.23.93,1.46,1.46,0,0,1-.6.65l-.39.22v.77l.25-.06v.41l-.94.54v-.42l.24-.21v-2.48l-.24.06v-.42l.24-.13Zm-.39,1.89.39-.22a.68.68,0,0,0,.28-.32,1.23,1.23,0,0,0,.1-.46.55.55,0,0,0-.1-.36c-.06-.07-.16-.07-.28,0l-.39.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.73,125.59,145,126v1l.73-.42,0-.43.34-.2v1l-1.78,1v-.42l.24-.21v-2.48l-.24.06v-.42l.24-.13,1.54-.89v1l-.35.2,0-.4-.72.41v.87l.77-.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,116.78a.52.52,0,0,1,.68,0,1.16,1.16,0,0,1,.27.88v.58a2.69,2.69,0,0,1-.27,1.19,1.71,1.71,0,0,1-.68.8l-1,.58v-.41l.24-.21v-2.49l-.24.07v-.42l.24-.14Zm-.32.72v2.4l.3-.17a1,1,0,0,0,.38-.47,2,2,0,0,0,.14-.74v-.58a1,1,0,0,0-.14-.58c-.09-.11-.22-.12-.38,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,122.63l.24-.21v-2.49l-.24.07v-.42l1.79-1v.95l-.34.2,0-.4-.74.43v1l.79-.46v.54l-.79.46v1l.24-.07v.42l-.93.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,122.13l-.33.19-.05-.43a.21.21,0,0,0-.17-.07.56.56,0,0,0-.24.08,1.12,1.12,0,0,0-.45.59,2.78,2.78,0,0,0-.16,1v.12a1.5,1.5,0,0,0,.16.77c.11.16.25.18.45.07a1.11,1.11,0,0,0,.24-.2,1.06,1.06,0,0,0,.17-.26l.05-.49.33-.19v.68a2.19,2.19,0,0,1-.35.59,1.55,1.55,0,0,1-.47.42.54.54,0,0,1-.74-.06,1.59,1.59,0,0,1-.29-1.07v-.12a3.44,3.44,0,0,1,.29-1.4,1.9,1.9,0,0,1,.74-.92.75.75,0,0,1,.47-.12.48.48,0,0,1,.35.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,135l-.64.37v.83l.61-.35,0-.36.29-.16v.79l-1.5.87v-.35l.2-.18v-2.09l-.2.06V134l.2-.11,1.29-.75v.8l-.29.17v-.34l-.61.35v.73l.64-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,131.58a.45.45,0,0,1,.57,0,1,1,0,0,1,.23.75v.48a2.26,2.26,0,0,1-.23,1,1.43,1.43,0,0,1-.57.67l-.85.49v-.35l.2-.17v-2.09l-.2,0v-.35l.2-.11Zm-.27.61v2l.25-.14a.77.77,0,0,0,.32-.4,1.56,1.56,0,0,0,.12-.62v-.49a.77.77,0,0,0-.12-.48c-.08-.1-.18-.11-.32,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,125.17v.29l-.93,2.71.66-.38,0-.37.29-.17,0,.82-1.41.81v-.3l.92-2.69-.6.35,0,.36-.29.17,0-.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.17,128l-.28.17,0-.37a.16.16,0,0,0-.14,0,.49.49,0,0,0-.2.06,1,1,0,0,0-.38.5,2.18,2.18,0,0,0-.13.79v.11a1.18,1.18,0,0,0,.13.64.24.24,0,0,0,.37.06.68.68,0,0,0,.21-.17.7.7,0,0,0,.14-.21l0-.41.28-.17v.58a1.86,1.86,0,0,1-.29.49,1.41,1.41,0,0,1-.39.35.47.47,0,0,1-.63,0,1.36,1.36,0,0,1-.24-.91v-.09a2.86,2.86,0,0,1,.24-1.18,1.51,1.51,0,0,1,.63-.77.62.62,0,0,1,.39-.11.41.41,0,0,1,.29.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,123.71a.44.44,0,0,1,.51,0,.68.68,0,0,1,.19.56,1.73,1.73,0,0,1-.19.78,1.43,1.43,0,0,1-.51.55l-.32.18v.65l.2-.06v.35l-.78.45v-.35l.2-.17v-2.09l-.2.06v-.36l.2-.11Zm-.32,1.59.32-.18a.64.64,0,0,0,.24-.27,1,1,0,0,0,.08-.39.47.47,0,0,0-.08-.3q-.09-.09-.24,0l-.32.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,132.5l.2-.17v-2.09l-.2,0v-.35l1.5-.87v.8l-.29.17v-.34l-.62.36v.8l.66-.38v.45l-.66.38v.8l.2-.06v.35l-.78.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.09,144.06l.15-.13v-1.61l-.15.05v-.27l1.15-.67V142l-.22.13v-.26l-.48.27v.62l.51-.29v.34l-.51.29v.62l.16,0V144l-.6.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,132.91a.34.34,0,0,1,.44,0,.79.79,0,0,1,.17.57v.37a1.84,1.84,0,0,1-.17.77,1.12,1.12,0,0,1-.44.51l-.65.38v-.27l.15-.13v-1.61l-.15.05v-.27l.15-.09Zm-.21.46v1.55l.19-.11a.57.57,0,0,0,.25-.31,1.19,1.19,0,0,0,.09-.47v-.38a.61.61,0,0,0-.09-.37c-.06-.07-.14-.08-.25,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,141.28l-.49.29v.64l.47-.27v-.28l.22-.13v.61l-1.15.67v-.27l.16-.14v-1.6l-.16,0v-.27l.16-.09,1-.57v.61l-.22.13,0-.26-.46.27v.56l.49-.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,135.57q.25-.15.39,0a.51.51,0,0,1,.15.43,1.27,1.27,0,0,1-.15.6,1,1,0,0,1-.39.42l-.25.14v.49l.16,0v.27l-.6.35v-.27l.15-.14v-1.6l-.15,0V136l.15-.09Zm-.25,1.21.25-.14a.38.38,0,0,0,.18-.21.73.73,0,0,0,.07-.29.33.33,0,0,0-.07-.23s-.1,0-.18,0l-.25.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43,137.83a2.32,2.32,0,0,1-.18.92,1.24,1.24,0,0,1-.48.6.34.34,0,0,1-.47,0,1.1,1.1,0,0,1-.18-.71v0a2.27,2.27,0,0,1,.18-.91,1.19,1.19,0,0,1,.47-.6c.2-.11.36-.1.48,0a1.07,1.07,0,0,1,.18.7Zm-.29.13a1,1,0,0,0-.09-.5.18.18,0,0,0-.28-.06.63.63,0,0,0-.27.37,1.93,1.93,0,0,0-.09.62v0a1.13,1.13,0,0,0,.09.52q.09.17.27.06a.63.63,0,0,0,.28-.38,1.93,1.93,0,0,0,.09-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,133.94v.22l-.71,2.08.5-.29,0-.29.23-.13,0,.63-1.08.63v-.24l.71-2.06-.46.27,0,.28-.22.13,0-.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,141.18v-.27l.16-.13v-1.6l-.16,0V139l.16-.09.29-.17.16-.09v.27L147,139v1.57l.41-.23v-.29l.23-.13v.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,146.65a.27.27,0,0,1,.35,0,.6.6,0,0,1,.14.47v.3a1.31,1.31,0,0,1-.14.62.88.88,0,0,1-.35.42l-.53.31v-.22l.12-.11v-1.3l-.12,0V147l.12-.07Zm-.17.38v1.26l.15-.09a.43.43,0,0,0,.2-.25,1,1,0,0,0,.08-.39v-.3a.47.47,0,0,0-.08-.3c0-.06-.11-.07-.2,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.06,140.11l-.4.23v.52l.38-.22v-.22l.18-.11v.5l-.93.54v-.22l.13-.11v-1.3l-.13,0v-.22l.13-.07.8-.46v.49l-.18.11v-.21l-.38.22v.45l.4-.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.26,138.44l-.18.1,0-.23a.12.12,0,0,0-.09,0,.24.24,0,0,0-.12,0,.56.56,0,0,0-.24.31,1.26,1.26,0,0,0-.08.49v.07a.7.7,0,0,0,.08.4.15.15,0,0,0,.23,0,.45.45,0,0,0,.13-.11.51.51,0,0,0,.09-.13l0-.26.18-.1v.36a1.92,1.92,0,0,1-.18.31,1,1,0,0,1-.25.21.28.28,0,0,1-.39,0,.85.85,0,0,1-.15-.57v-.06a1.77,1.77,0,0,1,.15-.73,1,1,0,0,1,.39-.48.36.36,0,0,1,.25-.07.27.27,0,0,1,.18.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,146.27l-.4.23V147l.38-.22v-.23l.18-.1v.5l-.93.53v-.21l.13-.11v-1.31l-.13,0v-.22l.13-.07.8-.47v.5l-.18.1v-.21l-.38.22v.46l.4-.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.16,142.27a2,2,0,0,1-.14.74,1,1,0,0,1-.39.49.28.28,0,0,1-.39,0,.9.9,0,0,1-.15-.58v0a1.86,1.86,0,0,1,.15-.75,1,1,0,0,1,.39-.48.28.28,0,0,1,.39,0,.91.91,0,0,1,.14.57Zm-.23.1a.84.84,0,0,0-.08-.41c0-.09-.12-.1-.22-.05a.54.54,0,0,0-.23.31,1.83,1.83,0,0,0-.07.5v0a.89.89,0,0,0,.08.42c0,.08.12.1.22,0a.51.51,0,0,0,.22-.3,1.6,1.6,0,0,0,.08-.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,142.81c.13-.08.24-.09.32,0a.43.43,0,0,1,.12.36,1,1,0,0,1-.12.48.81.81,0,0,1-.32.34l-.2.12v.4l.13,0v.22l-.49.28v-.22l.12-.11v-1.3l-.12,0v-.22l.12-.07Zm-.2,1,.2-.12a.28.28,0,0,0,.15-.17.6.6,0,0,0,.05-.24.28.28,0,0,0-.05-.18s-.08,0-.15,0l-.2.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,140.11v.48l-.19.11v-.2l-.21.12v1.28l.12,0v.22l-.49.28v-.22l.13-.11v-1.28l-.22.13v.2l-.19.11v-.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.9,146l.13-.11v-1.3l-.13,0v-.22l.94-.54v.5l-.18.1v-.21l-.39.22V145l.42-.24V145l-.42.24v.49l.13,0v.22l-.49.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5,155.81v-.21l.12-.11v-1.3l-.12,0V154l.12-.08.24-.13.12-.07v.21l-.12.11v1.28l.33-.19v-.24l.18-.1v.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,147a1.81,1.81,0,0,1-.15.74,1,1,0,0,1-.38.49.28.28,0,0,1-.39,0,1,1,0,0,1-.14-.57v0a2,2,0,0,1,.14-.74,1,1,0,0,1,.39-.48c.16-.09.28-.08.38,0a.85.85,0,0,1,.15.57Zm-.23.11a.82.82,0,0,0-.08-.41c-.05-.09-.12-.11-.22-.05a.5.5,0,0,0-.22.3,1.54,1.54,0,0,0-.08.5v0a.89.89,0,0,0,.08.42c0,.09.12.1.22,0a.48.48,0,0,0,.22-.3,1.5,1.5,0,0,0,.08-.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,144.94v.48l-.18.11v-.2l-.22.12v1.28l.13,0v.22l-.49.28V147l.13-.11v-1.27l-.22.12v.21l-.18.11v-.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,153.36l-.4.23v.52l.38-.22v-.22l.18-.1v.49l-.93.54v-.22l.13-.11V153l-.13,0v-.22l.13-.07.8-.46v.49l-.18.1v-.21l-.38.22v.46l.4-.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.56,148.78a.27.27,0,0,1,.35,0,.63.63,0,0,1,.14.46v.3a1.49,1.49,0,0,1-.14.63.9.9,0,0,1-.35.41l-.53.31v-.22l.12-.11v-1.3l-.12,0v-.22l.12-.07Zm-.17.37v1.25l.15-.09a.48.48,0,0,0,.2-.24,1,1,0,0,0,.07-.39v-.3a.47.47,0,0,0-.07-.3c-.05-.06-.11-.07-.2,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,150.57a1.78,1.78,0,0,1-.15.74,1,1,0,0,1-.38.49.28.28,0,0,1-.39,0,1,1,0,0,1-.14-.57v0a2,2,0,0,1,.14-.74,1,1,0,0,1,.39-.48.27.27,0,0,1,.38,0,.85.85,0,0,1,.15.57Zm-.23.11a.84.84,0,0,0-.08-.41.14.14,0,0,0-.22-.05.55.55,0,0,0-.23.3,1.89,1.89,0,0,0-.07.5v0a.89.89,0,0,0,.08.42c0,.09.12.1.22.05a.53.53,0,0,0,.22-.31,1.5,1.5,0,0,0,.08-.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.75,147.51c.14-.08.24-.09.32,0a.43.43,0,0,1,.12.35,1,1,0,0,1-.12.49.81.81,0,0,1-.32.34l-.2.11v.4l.13,0v.22l-.49.28v-.22l.13-.11V148l-.13,0v-.22l.13-.07Zm-.2,1,.2-.11a.31.31,0,0,0,.15-.17.6.6,0,0,0,0-.24.28.28,0,0,0,0-.18s-.08,0-.15,0l-.2.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.32,151.22c.13-.08.24-.09.31,0a.36.36,0,0,1,.12.32.81.81,0,0,1-.05.27.84.84,0,0,1-.14.24.14.14,0,0,1,.15.07.55.55,0,0,1,0,.25v.09s0,.07,0,.08,0,0,0,0h0v.22l-.12.07c-.08.05-.13.05-.16,0a.42.42,0,0,1,0-.22v-.1a.26.26,0,0,0-.05-.18s-.07,0-.12,0l-.2.11v.48l.13,0v.22l-.49.28v-.22l.13-.1v-1.3l-.13,0v-.21l.13-.08Zm-.17.89.17-.09a.4.4,0,0,0,.14-.15.36.36,0,0,0,0-.21c0-.09,0-.14,0-.17s-.08,0-.14,0l-.17.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,158.82l.1-.09v-1l-.1,0v-.18l.76-.43v.39l-.15.09v-.17l-.31.18v.4l.34-.19V158l-.34.19v.41l.11,0v.17l-.4.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,152l-.32.19v.41l.31-.17v-.18l.14-.09v.4l-.75.43v-.17l.1-.09v-1l-.1,0v-.17l.1-.06.65-.38v.4l-.15.09v-.17l-.3.17V152l.32-.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7,150.94a1.46,1.46,0,0,1-.12.6.74.74,0,0,1-.31.39.23.23,0,0,1-.31,0,.7.7,0,0,1-.12-.46v0a1.5,1.5,0,0,1,.12-.6.74.74,0,0,1,.31-.39.23.23,0,0,1,.31,0,.72.72,0,0,1,.12.46Zm-.19.09a.69.69,0,0,0-.06-.33.11.11,0,0,0-.18,0,.45.45,0,0,0-.18.24,1.25,1.25,0,0,0-.06.4v0a.77.77,0,0,0,.06.34q.06.11.18,0a.39.39,0,0,0,.18-.24,1.27,1.27,0,0,0,.06-.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,156.32a.21.21,0,0,1,.28,0,.51.51,0,0,1,.12.38v.24a1.06,1.06,0,0,1-.12.5.75.75,0,0,1-.28.34l-.43.24v-.17l.1-.09v-1l-.1,0v-.17l.1-.06Zm-.14.3v1l.13-.07a.41.41,0,0,0,.16-.2.78.78,0,0,0,.06-.31v-.24a.4.4,0,0,0-.06-.25.12.12,0,0,0-.16,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,154.81l.1-.09v-1.05l-.1,0v-.18l.75-.43v.4l-.14.08v-.17l-.31.18v.4l.33-.19V154l-.33.19v.4l.1,0v.18L150,155Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31,155.93v-.18l.1-.09v-1l-.1,0v-.18l.1-.06.19-.11.1-.06v.18l-.1.09v1l.27-.16v-.19l.14-.08v.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,152.59l-.14.08,0-.19-.07,0-.11,0a.5.5,0,0,0-.19.25,1.25,1.25,0,0,0-.06.4v.05a.65.65,0,0,0,.06.32.12.12,0,0,0,.19,0,.39.39,0,0,0,.1-.08.38.38,0,0,0,.08-.11l0-.21.14-.08v.29a1.28,1.28,0,0,1-.15.25.65.65,0,0,1-.2.17.22.22,0,0,1-.31,0,.67.67,0,0,1-.12-.45v-.05a1.45,1.45,0,0,1,.12-.59.78.78,0,0,1,.31-.39.33.33,0,0,1,.2-.05.22.22,0,0,1,.15.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53,156.78l.1-.09v-1l-.1,0v-.17l.75-.44v.4l-.14.09v-.17l-.31.18v.4l.33-.19V156l-.33.19v.4l.1,0v.18l-.39.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,161.11c.1-.06.17-.07.23,0a.32.32,0,0,1,.08.25.82.82,0,0,1-.08.35.62.62,0,0,1-.23.25l-.15.08v.29l.1,0v.16l-.36.2v-.16l.09-.08v-.94l-.09,0v-.16l.09-.05Zm-.15.71.15-.08a.32.32,0,0,0,.11-.12.57.57,0,0,0,0-.18.21.21,0,0,0,0-.13s-.06,0-.11,0l-.15.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,157.11l.09-.08v-.94l-.09,0V156l.67-.39v.35l-.13.08v-.15l-.27.16v.36l.29-.17v.2l-.29.17v.36l.09,0v.15l-.35.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,154.68V155l-.13.08V155l-.15.09V156l.09,0v.16l-.35.2v-.15l.09-.08v-.93l-.16.09v.15l-.13.08v-.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,154.1a.21.21,0,0,1,.26,0,.42.42,0,0,1,.1.33v.22a1,1,0,0,1-.1.45.65.65,0,0,1-.26.3l-.38.22v-.15l.09-.08v-.94l-.09,0v-.16l.09,0Zm-.12.28v.9l.12-.06a.37.37,0,0,0,.14-.18.87.87,0,0,0,.05-.28v-.22a.42.42,0,0,0-.05-.22s-.08,0-.14,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,160.85l-.29.17v.37l.27-.16v-.16l.13-.07v.36l-.67.39v-.16l.09-.08v-.94l-.09,0v-.15l.09-.06.58-.33v.36l-.13.07v-.15l-.27.16v.33l.29-.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.19,159v-.16l.09-.08v-.94l-.09,0v-.16l.09-.05.17-.1.09-.05v.16l-.09.07v.93l.24-.14v-.17l.13-.08v.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.4,158.83a1.4,1.4,0,0,1-.1.54.85.85,0,0,1-.28.35.21.21,0,0,1-.28,0,.66.66,0,0,1-.11-.42v0a1.32,1.32,0,0,1,.11-.53.64.64,0,0,1,.28-.35.19.19,0,0,1,.28,0,.63.63,0,0,1,.1.41Zm-.17.07a.69.69,0,0,0,0-.29.1.1,0,0,0-.16,0,.43.43,0,0,0-.17.22,1.36,1.36,0,0,0,0,.36v0a.61.61,0,0,0,.06.3c0,.06.08.07.16,0a.39.39,0,0,0,.16-.22,1.3,1.3,0,0,0,0-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,156.88l-.12.07,0-.16a.09.09,0,0,0-.07,0l-.09,0a.46.46,0,0,0-.17.23,1,1,0,0,0-.06.35v0a.55.55,0,0,0,.06.29.12.12,0,0,0,.17,0,.24.24,0,0,0,.09-.08.36.36,0,0,0,.07-.1l0-.18.12-.07v.26a1,1,0,0,1-.13.22.52.52,0,0,1-.18.15.2.2,0,0,1-.28,0,.6.6,0,0,1-.11-.4v-.05a1.36,1.36,0,0,1,.11-.53.7.7,0,0,1,.28-.34.28.28,0,0,1,.18,0,.21.21,0,0,1,.13.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.74,159.12v.13l-.41,1.22.29-.17,0-.17.13-.07,0,.36-.63.37v-.14l.41-1.21-.27.16v.17l-.13.07v-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.42 129.26 139.28 140.89 139.28 139.74 159.42 128.11 159.42 129.26",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.42 129.26 139.28 140.89 139.28 139.74 159.42 128.11 159.42 129.26",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.23 142.65 141.47 151.75 141.47 150.59 157.23 141.5 157.23 142.65",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.94,77.71l-.15.09V76.38l-.21.14v-.15l.36-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.15,88.67l-.6.35v-.16l.29-.76a1.76,1.76,0,0,0,.1-.31.89.89,0,0,0,0-.22.44.44,0,0,0,0-.19.07.07,0,0,0-.1,0,.34.34,0,0,0-.12.16.77.77,0,0,0,0,.27l-.14.09h0a.78.78,0,0,1,.08-.4.49.49,0,0,1,.22-.28c.09-.05.16-.05.21,0a.42.42,0,0,1,.07.29,1.2,1.2,0,0,1,0,.31c0,.11-.08.23-.14.38l-.2.57.41-.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,98.05l.1-.06a.31.31,0,0,0,.11-.14.8.8,0,0,0,0-.23.44.44,0,0,0,0-.19s-.06,0-.11,0a.32.32,0,0,0-.1.14.54.54,0,0,0,0,.22l-.14.09h0a.9.9,0,0,1,.08-.36.6.6,0,0,1,.21-.25q.13-.08.21,0a.43.43,0,0,1,.08.3.66.66,0,0,1,0,.23.68.68,0,0,1-.1.21.14.14,0,0,1,.12.08.69.69,0,0,1,0,.22.87.87,0,0,1-.08.4.64.64,0,0,1-.22.26.2.2,0,0,1-.21,0,.37.37,0,0,1-.09-.29h0l.14-.09a.32.32,0,0,0,0,.19.07.07,0,0,0,.11,0,.26.26,0,0,0,.11-.14.62.62,0,0,0,.05-.25.4.4,0,0,0,0-.2s-.07,0-.12,0l-.1.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06,107.12l.11-.06v.17l-.11.07v.38l-.15.09v-.39l-.39.23v-.13l.39-1.36.15-.08Zm-.4.23.25-.14v-.76h0l0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.58,114.48l0-.94.48-.28v.19l-.35.21,0,.5.06-.1a.2.2,0,0,1,.08-.08c.09,0,.15,0,.2,0a.65.65,0,0,1,.07.36,1.23,1.23,0,0,1-.07.44.58.58,0,0,1-.22.28.2.2,0,0,1-.21,0,.39.39,0,0,1-.07-.3h0l.14-.09a.33.33,0,0,0,0,.2.07.07,0,0,0,.1,0c.05,0,.08-.08.11-.16a1.23,1.23,0,0,0,0-.29.77.77,0,0,0,0-.25s-.07-.06-.11,0a.18.18,0,0,0-.1.09.54.54,0,0,0,0,.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.9,120.48l.1,0a.22.22,0,0,1,.08,0l0,.19H165l-.08,0a.38.38,0,0,0-.14.22,1.12,1.12,0,0,0-.06.38v0a1,1,0,0,1,.09-.15.35.35,0,0,1,.11-.1.13.13,0,0,1,.19,0,.63.63,0,0,1,.07.35,1.34,1.34,0,0,1-.08.46.52.52,0,0,1-.21.28.16.16,0,0,1-.23,0,.82.82,0,0,1-.08-.44v-.35a1.64,1.64,0,0,1,.09-.56A.69.69,0,0,1,164.9,120.48Zm0,.77a.29.29,0,0,0-.09.1.52.52,0,0,0-.07.15v.15a.78.78,0,0,0,.05.32c0,.06.07.08.12,0a.25.25,0,0,0,.1-.17,1,1,0,0,0,0-.3.59.59,0,0,0,0-.26A.07.07,0,0,0,164.86,121.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.15,128.62a4.38,4.38,0,0,0-.21.73,4.93,4.93,0,0,0-.08.75v.17l-.15.08v-.16a5.76,5.76,0,0,1,.1-.77,3.67,3.67,0,0,1,.2-.72l-.49.28v-.17l.63-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12,133.88a.69.69,0,0,1,0,.25.53.53,0,0,1-.11.21.15.15,0,0,1,.13.09.41.41,0,0,1,.05.21.82.82,0,0,1-.09.4.6.6,0,0,1-.22.25q-.14.08-.21,0a.38.38,0,0,1-.09-.3.86.86,0,0,1,.05-.27.84.84,0,0,1,.12-.23.11.11,0,0,1-.1-.08.41.41,0,0,1,0-.21.84.84,0,0,1,.07-.37.54.54,0,0,1,.2-.24c.09-.05.15-.05.21,0A.42.42,0,0,1,165.12,133.88Zm-.12.84a.31.31,0,0,0-.05-.19.08.08,0,0,0-.11,0,.37.37,0,0,0-.11.15,1,1,0,0,0,0,.25.35.35,0,0,0,0,.2.08.08,0,0,0,.11,0A.2.2,0,0,0,165,135,.62.62,0,0,0,165,134.72Zm0-.75a.42.42,0,0,0,0-.18.07.07,0,0,0-.1,0,.24.24,0,0,0-.09.14.72.72,0,0,0,0,.22.41.41,0,0,0,0,.19.07.07,0,0,0,.09,0,.28.28,0,0,0,.1-.13A.8.8,0,0,0,165,134Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,142a.31.31,0,0,0,.13-.19,1,1,0,0,0,0-.37v-.08a.67.67,0,0,1-.07.17.32.32,0,0,1-.1.1.13.13,0,0,1-.2,0,.65.65,0,0,1-.08-.37,1.23,1.23,0,0,1,.09-.47.46.46,0,0,1,.21-.28.14.14,0,0,1,.22,0,.74.74,0,0,1,.08.42v.43a1.35,1.35,0,0,1-.09.52.6.6,0,0,1-.24.31l-.09,0h-.1l0-.18h.08Zm0-.56a.22.22,0,0,0,.09-.1.49.49,0,0,0,.06-.17v-.19a.74.74,0,0,0,0-.3c0-.06-.06-.07-.11,0a.29.29,0,0,0-.11.18,1.46,1.46,0,0,0,0,.31.85.85,0,0,0,0,.27C164.75,141.4,164.78,141.42,164.83,141.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,146.56l-.15.09v-1.42l-.21.14v-.15l.36-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.51,145.38a1.62,1.62,0,0,1-.08.54.59.59,0,0,1-.22.3.15.15,0,0,1-.22-.05.9.9,0,0,1-.08-.44v-.38a1.6,1.6,0,0,1,.08-.53.56.56,0,0,1,.22-.3.15.15,0,0,1,.22,0,.9.9,0,0,1,.08.44Zm-.15-.32a.85.85,0,0,0,0-.32.07.07,0,0,0-.11-.05.31.31,0,0,0-.11.18,1.63,1.63,0,0,0,0,.36v.44a1.08,1.08,0,0,0,0,.32c0,.06.06.08.11,0a.27.27,0,0,0,.11-.18,1.19,1.19,0,0,0,0-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,150.16l-.15.08v-1.42l-.21.15v-.15l.36-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,149.73l-.15.09V148.4l-.21.14v-.15l.36-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,78.48l-.23.13v-.06l.11-.28s0-.09,0-.12a.25.25,0,0,0,0-.08s0-.06,0-.07,0,0,0,0a.09.09,0,0,0,0,.06.25.25,0,0,0,0,.1l-.05,0h0a.41.41,0,0,1,0-.16.2.2,0,0,1,.08-.1.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11.5.5,0,0,1,0,.12,1.21,1.21,0,0,1-.05.14l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,78.08a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11s-.06,0-.08,0a.34.34,0,0,1,0-.17v-.14a1.12,1.12,0,0,1,0-.2c0-.05.05-.09.09-.11a.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.31.31,0,0,0,0-.11s0,0,0,0a.1.1,0,0,0-.05.06s0,.08,0,.14v.16a.29.29,0,0,0,0,.12s0,0,0,0a.14.14,0,0,0,0-.07.49.49,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,77.93a.6.6,0,0,1,0,.2.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.64.64,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.29.29,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.45.45,0,0,0,0,.13V78a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,77.66l-.14.09V78l-.06,0v-.61l.23-.13v.06l-.17.1v.21l.14-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,77.21l-.11.06v.55l0,0V77.3l-.1.06v-.07l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.83,78.86h.07v.07h-.06a.12.12,0,0,0-.05.08.32.32,0,0,0,0,.14v0a.09.09,0,0,1,0,0l0,0s0,0,.07,0a.21.21,0,0,1,0,.13.47.47,0,0,1,0,.17.21.21,0,0,1-.08.1s-.06,0-.09,0a.32.32,0,0,1,0-.16v-.14a.45.45,0,0,1,0-.2A.22.22,0,0,1,161.83,78.86Zm0,.29a.08.08,0,0,0,0,0,.08.08,0,0,0,0,0v.06a.41.41,0,0,0,0,.12,0,0,0,0,0,0,0,.14.14,0,0,0,0-.07.37.37,0,0,0,0-.11.22.22,0,0,0,0-.09S161.83,79.14,161.82,79.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,79.32l-.06,0v-.53l-.08.06v-.06l.14-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45,78.51l.09.45h0l.09-.56.07,0V79l-.05,0v-.48h0l-.1.53,0,0-.1-.41h0v.47l-.05,0v-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.93 78.07 161.44 78.93 161.44 78.81 162.93 77.95 162.93 78.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,89.75l-.06,0v-.53l-.08.06v-.06l.14-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,89.31a.56.56,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16V89.3a1,1,0,0,1,0-.2.21.21,0,0,1,.09-.11.05.05,0,0,1,.08,0,.37.37,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0a.13.13,0,0,0-.05.07s0,.08,0,.13v.17a.37.37,0,0,0,0,.12s0,0,0,0a.43.43,0,0,0,0-.07.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,89.15a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16ZM162.2,89a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.53.53,0,0,0,0,.14v.16a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,88.89l-.14.08v.28l-.06,0v-.61l.23-.14v.07l-.17.1v.21l.14-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,88.43l-.11.06V89l0,0v-.55l-.1.06v-.06l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,90.52l0,0a.1.1,0,0,0,0,0,.22.22,0,0,0,0-.09.15.15,0,0,0,0-.07,0,0,0,0,0,0,0,.07.07,0,0,0,0,0,.19.19,0,0,0,0,.08l0,0h0a.28.28,0,0,1,0-.13.21.21,0,0,1,.08-.1.06.06,0,0,1,.08,0,.16.16,0,0,1,0,.11.29.29,0,0,1,0,.09.2.2,0,0,1,0,.08.05.05,0,0,1,0,0,.19.19,0,0,1,0,.08.33.33,0,0,1,0,.15.21.21,0,0,1-.08.1.11.11,0,0,1-.08,0,.16.16,0,0,1,0-.11h0l0,0a.1.1,0,0,0,0,.07s0,0,0,0a.1.1,0,0,0,0-.05.3.3,0,0,0,0-.1.12.12,0,0,0,0-.07h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,90.38a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11s-.06,0-.08,0a.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.19.19,0,0,1,.08-.11.05.05,0,0,1,.08,0,.32.32,0,0,1,0,.16Zm-.06-.12a.31.31,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.52.52,0,0,0,0,.14v.16a.29.29,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.49.49,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,90.55l-.06,0V90.5l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,90.23l0-.35.18-.1v.07l-.13.07,0,.19,0,0,0,0a0,0,0,0,1,.07,0,.24.24,0,0,1,0,.14.41.41,0,0,1,0,.16.19.19,0,0,1-.08.11.11.11,0,0,1-.08,0,.16.16,0,0,1,0-.11h0l.06,0s0,.06,0,.07,0,0,0,0a.09.09,0,0,0,0-.06.37.37,0,0,0,0-.11.22.22,0,0,0,0-.09s0,0,0,0,0,0,0,0,0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,89.62l.09.45h0l.1-.56.07,0v.61l-.06,0v-.48h0l-.1.53,0,0-.09-.42h0v.46l0,0v-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.93 89.29 161.44 90.16 161.44 90.04 162.93 89.18 162.93 89.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,99a1.14,1.14,0,0,0-.08.27c0,.08,0,.18,0,.29v.06l-.06,0v-.06a2.54,2.54,0,0,1,0-.29,2.68,2.68,0,0,1,.07-.27l-.17.11v-.07l.23-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,99.16a.6.6,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.2.2,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.44.44,0,0,0,0,.13v.17a.27.27,0,0,0,0,.11s0,0,0,0a.09.09,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,98.9l-.15.08v.28l-.05,0v-.62l.23-.13v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,98.44l-.1.06v.55l-.05,0v-.55l-.11.06v-.07l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,100.71l-.22.12v0l.11-.29,0-.12s0-.05,0-.07a.15.15,0,0,0,0-.08s0,0,0,0,0,0-.05.06a.34.34,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.27.27,0,0,1,0,.12.6.6,0,0,1-.05.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,100.59l-.06,0v-.53l-.08.05v-.06l.14-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,100.48l-.05,0v-.08l.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,100.06l0,0a.07.07,0,0,0,0,0,.19.19,0,0,0,0-.08s0-.06,0-.07,0,0,0,0a.1.1,0,0,0,0,.05.22.22,0,0,0,0,.08l-.06,0h0a.31.31,0,0,1,0-.13.15.15,0,0,1,.08-.09.06.06,0,0,1,.08,0s0,0,0,.11a.31.31,0,0,1,0,.08.2.2,0,0,1,0,.08.05.05,0,0,1,0,0,.19.19,0,0,1,0,.08.33.33,0,0,1,0,.15.21.21,0,0,1-.08.1.06.06,0,0,1-.08,0,.16.16,0,0,1,0-.11h0l0,0a.14.14,0,0,0,0,.07s0,0,0,0a.1.1,0,0,0,0,0,.29.29,0,0,0,0-.09.13.13,0,0,0,0-.08h0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,99.55l.1.45h0l.09-.56.07,0V100l0,0v-.47h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 99.22 161.45 100.08 161.45 99.97 162.94 99.11 162.94 99.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,108.28l0-.35.18-.1v.07l-.13.07v.19s0,0,0,0l0,0a.06.06,0,0,1,.08,0,.28.28,0,0,1,0,.14.78.78,0,0,1,0,.16.2.2,0,0,1-.09.11h-.07a.16.16,0,0,1,0-.11h0l0,0a.15.15,0,0,0,0,.08,0,0,0,0,0,0,0,.07.07,0,0,0,0-.06.31.31,0,0,0,0-.11.2.2,0,0,0,0-.09s0,0,0,0l0,0s0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,108a.56.56,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16V108a.56.56,0,0,1,0-.2.16.16,0,0,1,.08-.11.05.05,0,0,1,.08,0,.37.37,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.44.44,0,0,0,0,.13v.17a.37.37,0,0,0,0,.12s0,0,0,0a.09.09,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.5,107.78l-.15.08v.28l0,0v-.62l.22-.13v.07l-.17.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,107.32l-.1.06v.55l-.06,0v-.55l-.1.06v-.06l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49,109.71l-.05,0v-.53l-.08.06v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,109.35l0-.35.18-.1V109l-.13.08v.19s0,0,0,0,0,0,0,0,.06,0,.08,0a.21.21,0,0,1,0,.13.47.47,0,0,1,0,.17.21.21,0,0,1-.08.1s-.06,0-.08,0a.14.14,0,0,1,0-.11h0l.05,0a.12.12,0,0,0,0,.07s0,0,0,0a.15.15,0,0,0,0-.06s0-.07,0-.11,0-.08,0-.1,0,0-.05,0l0,0s0,0,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,109.44l-.05,0v-.08l.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,109.27l-.23.13v-.06l.11-.28s0-.09,0-.12a.25.25,0,0,0,0-.08s0-.06,0-.07,0,0,0,0a.09.09,0,0,0,0,.06.3.3,0,0,0,0,.1l-.05,0h0a.37.37,0,0,1,0-.15.24.24,0,0,1,.08-.11.06.06,0,0,1,.08,0,.14.14,0,0,1,0,.11.52.52,0,0,1,0,.11,1.21,1.21,0,0,1,0,.14l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.53,109.11l-.22.13v-.06l.11-.28,0-.12s0,0,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0,0,.06.31.31,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.24.24,0,0,1,.09-.11s.06,0,.07,0a.14.14,0,0,1,0,.11.45.45,0,0,1,0,.11s0,.09-.06.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79,108.35l.09.45h0l.1-.56.07,0v.61l-.06,0v-.48h0l-.1.53,0,0-.09-.42h0V109l-.05,0v-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.93 108.1 161.44 108.96 161.44 108.85 162.93 107.99 162.93 108.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.82,115.53l0,0v.07l0,0v.15l-.06,0v-.15l-.15.09v0l.15-.51.06,0Zm-.15.08.09,0v-.28h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,115.32a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2A.24.24,0,0,1,162,115a.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.06-.12a.41.41,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.46.46,0,0,0,0,.14v.16a.37.37,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.53.53,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,115.06l-.15.08v.28l-.05,0v-.61l.23-.14v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,114.6l-.1.06v.55l-.05,0v-.55l-.11.06v-.06l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64,116.91l0,0v-.53l-.08,0v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,116.71l-.23.13v-.06l.11-.28s0-.09,0-.12a.25.25,0,0,0,0-.08s0-.06,0-.07,0,0,0,0a.09.09,0,0,0,0,.06.3.3,0,0,0,0,.1l0,0h0a.37.37,0,0,1,0-.15.24.24,0,0,1,.08-.11.06.06,0,0,1,.08,0,.14.14,0,0,1,0,.11.52.52,0,0,1,0,.11,1.21,1.21,0,0,1-.05.14l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.11,116.64l-.05,0v-.09l.05,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,116.47l-.23.13v0l.11-.29,0-.12a.22.22,0,0,0,0-.08.15.15,0,0,0,0-.07s0,0,0,0a.09.09,0,0,0,0,.06.3.3,0,0,0,0,.1l0,0h0a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1.06.06,0,0,1,.08,0,.16.16,0,0,1,0,.11.52.52,0,0,1,0,.11s0,.09,0,.15l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,115.71l.1.45h0l.09-.56.07,0v.62l0,0v-.48h0l-.1.53,0,0-.1-.41h0v.47l-.06,0v-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 115.39 161.45 116.25 161.45 116.13 162.94 115.27 162.94 115.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,122.61l0,0a.07.07,0,0,0,0,0,.19.19,0,0,0,0-.08s0-.06,0-.07,0,0,0,0a.1.1,0,0,0,0,0,.25.25,0,0,0,0,.09l-.06,0h0a.31.31,0,0,1,0-.13.15.15,0,0,1,.08-.09.06.06,0,0,1,.08,0s0,0,0,.11a.31.31,0,0,1,0,.08.2.2,0,0,1,0,.08.05.05,0,0,1,.05,0,.19.19,0,0,1,0,.08.33.33,0,0,1,0,.15.21.21,0,0,1-.08.1.06.06,0,0,1-.08,0,.16.16,0,0,1,0-.11h0l0,0a.14.14,0,0,0,0,.07h0a.1.1,0,0,0,0-.05.29.29,0,0,0,0-.09.13.13,0,0,0,0-.08s0,0,0,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,122.47a.6.6,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.13a.56.56,0,0,1,0-.2.23.23,0,0,1,.08-.12.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.39.39,0,0,0,0,.13v.16a.29.29,0,0,0,0,.12s0,0,0,0a.09.09,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,122.2l-.15.09v.27l-.05,0V122l.23-.13v.06l-.18.1v.21l.15-.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,121.75l-.1.06v.55l-.05,0v-.55l-.11.06v-.07l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,124a.1.1,0,0,0,0-.07.52.52,0,0,0,0-.14v0l0,.07s0,0,0,0-.06,0-.08,0a.24.24,0,0,1,0-.14.47.47,0,0,1,0-.17.26.26,0,0,1,.08-.11s.06,0,.09,0a.3.3,0,0,1,0,.16v.16a.38.38,0,0,1,0,.19.19.19,0,0,1-.09.12h-.07v-.06h0Zm0-.21s0,0,0,0a.14.14,0,0,0,0-.07v-.07a.31.31,0,0,0,0-.11,0,0,0,0,0-.05,0,.21.21,0,0,0,0,.07.49.49,0,0,0,0,.12.28.28,0,0,0,0,.1A0,0,0,0,0,161.6,123.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,124l-.06,0v-.09l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,123.82l-.06,0v-.53l-.08.06v-.06l.14-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.37,123.43l0,0v.07l0,0v.15l-.05,0v-.15l-.15.09v0l.15-.5.05,0Zm-.14.08.09-.05v-.28h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,122.86l.1.44h0l.09-.55.07,0v.61l0,0v-.47h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 122.53 161.45 123.39 161.45 123.28 162.94 122.42 162.94 122.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,131l-.22.12v0l.11-.29a1,1,0,0,0,0-.12.17.17,0,0,0,0-.07.17.17,0,0,0,0-.08s0,0,0,0a.13.13,0,0,0,0,.06.36.36,0,0,0,0,.1l0,0h0a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1s.06,0,.08,0a.16.16,0,0,1,0,.11.43.43,0,0,1,0,.11,1.31,1.31,0,0,1,0,.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,130.63l0-.35.18-.1v.07l-.13.08v.19a.05.05,0,0,1,0,0s0,0,0,0,.06,0,.07,0a.21.21,0,0,1,0,.13.47.47,0,0,1,0,.17.16.16,0,0,1-.08.1.06.06,0,0,1-.08,0s0-.05,0-.11h0l.05,0s0,.06,0,.07,0,0,0,0a.09.09,0,0,0,0-.06.36.36,0,0,0,0-.11.22.22,0,0,0,0-.1s0,0,0,0a.08.08,0,0,0,0,0,.43.43,0,0,0,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,130.29l-.15.08v.28l-.05,0v-.61l.23-.14V130l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,129.83l-.1.06v.55l-.05,0v-.55l-.11.06v-.06l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.72,131.55a2,2,0,0,0-.08.27c0,.08,0,.17,0,.28v.06l-.05,0v-.07a2.4,2.4,0,0,1,0-.28,2.76,2.76,0,0,1,.08-.27l-.18.1v-.06l.23-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,132l-.06,0V132l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,131.29h.07v.07H162a.12.12,0,0,0,0,.08.32.32,0,0,0,0,.14v0l0-.06,0,0s.05,0,.07,0a.26.26,0,0,1,0,.14.51.51,0,0,1,0,.17.21.21,0,0,1-.08.1s-.06,0-.09,0a.3.3,0,0,1,0-.16v-.13a.49.49,0,0,1,0-.21A.19.19,0,0,1,162,131.29Zm0,.29,0,0a.14.14,0,0,0,0,.06v.06a.41.41,0,0,0,0,.12s0,0,.05,0,0,0,0-.07a.37.37,0,0,0,0-.11.28.28,0,0,0,0-.1A0,0,0,0,0,162,131.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,131.7l-.23.13v-.05l.11-.29,0-.12a.22.22,0,0,0,0-.08.15.15,0,0,0,0-.07s0,0,0,0a.09.09,0,0,0,0,.06.3.3,0,0,0,0,.1l0,0h0a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1.06.06,0,0,1,.08,0,.16.16,0,0,1,0,.11.52.52,0,0,1,0,.11s0,.09,0,.15l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,130.94l.1.45h0l.09-.56.07,0v.62l0,0V131h0l-.1.53,0,0-.1-.41h0v.47l-.06,0V131Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 130.62 161.45 131.48 161.45 131.36 162.94 130.5 162.94 130.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.85,136.05l-.22.13v-.06l.1-.28,0-.12a.22.22,0,0,0,0-.08.15.15,0,0,0,0-.07s0,0,0,0a.09.09,0,0,0,0,.06.3.3,0,0,0,0,.1l0,0h0a.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1s.06,0,.08,0a.16.16,0,0,1,0,.11.52.52,0,0,1,0,.11s0,.09,0,.15l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,135.66a.6.6,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.16.16,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.44.44,0,0,0,0,.13v.17a.27.27,0,0,0,0,.11s0,0,0,0a.09.09,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,135.4l-.15.08v.28l-.05,0v-.62l.23-.13v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,134.94l-.1.06v.55l-.05,0V135l-.11.06V135l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,136.63h.07l0,.07h-.05a.12.12,0,0,0,0,.08.34.34,0,0,0,0,.15h0a.09.09,0,0,1,0-.05l0,0s.05,0,.07,0a.23.23,0,0,1,0,.13.47.47,0,0,1,0,.17.17.17,0,0,1-.08.1s-.06,0-.09,0a.32.32,0,0,1,0-.16V137a.45.45,0,0,1,0-.2A.25.25,0,0,1,161.63,136.63Zm0,.29a.08.08,0,0,0,0,0,.08.08,0,0,0,0,0v.06a.35.35,0,0,0,0,.12,0,0,0,0,0,.05,0,.14.14,0,0,0,0-.07.37.37,0,0,0,0-.11.22.22,0,0,0,0-.09S161.63,136.91,161.62,136.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,137.14l-.06,0v-.09l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,137l-.05,0v-.53l-.08,0v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,136.57a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.32.32,0,0,1,0,.16Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.15.15,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0a.07.07,0,0,0,0-.07.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,136.05l.1.45h0l.09-.55.07,0v.61l0,0v-.47h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 135.72 161.45 136.58 161.45 136.47 162.94 135.61 162.94 135.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,142.84l-.05,0v-.53l-.08,0v0l.13-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,142.48l0-.35.18-.1v.07l-.13.08v.18s0,0,0,0l0,0s.06,0,.07,0a.21.21,0,0,1,0,.13.38.38,0,0,1,0,.16.19.19,0,0,1-.08.11.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11h0l.05,0a.15.15,0,0,0,0,.07s0,0,0,0a.09.09,0,0,0,0-.06.31.31,0,0,0,0-.11.2.2,0,0,0,0-.09s0,0,0,0l0,0s0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,142.14l-.15.08v.28l-.05,0v-.62l.23-.13v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,141.68l-.1.06v.55l-.05,0v-.55l-.11.06v-.06l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,143.76l0,0v.07l0,0V144l-.06,0v-.15l-.14.09v-.05l.14-.51.06,0Zm-.15.08.09-.05v-.28h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,143.88l-.06,0v-.08l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,143.56l0-.35.18-.11v.07l-.13.08v.19a.05.05,0,0,1,0,0l0,0s.06,0,.07,0a.23.23,0,0,1,0,.13.43.43,0,0,1,0,.17.16.16,0,0,1-.08.1.06.06,0,0,1-.08,0s0-.05,0-.11h0l.05,0s0,.06,0,.07,0,0,0,0a.09.09,0,0,0,0-.06.36.36,0,0,0,0-.11.2.2,0,0,0,0-.09s0,0,0,0l0,0a.35.35,0,0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,143a1.14,1.14,0,0,0-.08.27c0,.08,0,.18,0,.29v.06l-.06,0v-.06a2.26,2.26,0,0,1,0-.29,2.68,2.68,0,0,1,.07-.27l-.18.11v-.07l.24-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,142.79l.1.45h0l.09-.56.07,0v.61l0,0v-.48h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 142.46 161.45 143.32 161.45 143.21 162.94 142.35 162.94 142.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,147.1l-.05,0v-.53l-.08.05v-.05l.13-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,146.64l0,0a.07.07,0,0,0,0-.05.29.29,0,0,0,0-.09.12.12,0,0,0,0-.07s0,0,0,0l0,0a.29.29,0,0,0,0,.09l0,0h0a.35.35,0,0,1,0-.14.22.22,0,0,1,.07-.09s.06,0,.08,0a.16.16,0,0,1,0,.11.28.28,0,0,1,0,.09.3.3,0,0,1,0,.08s0,0,0,0a.15.15,0,0,1,0,.08.4.4,0,0,1,0,.15.26.26,0,0,1-.09.09s-.05,0-.07,0,0-.05,0-.11h0l.06,0s0,.06,0,.07,0,0,0,0a.1.1,0,0,0,.05-.06.22.22,0,0,0,0-.09.17.17,0,0,0,0-.08,0,0,0,0,0-.05,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,146.4l-.15.08v.28l-.05,0v-.62l.23-.13v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,145.94l-.1.06v.55l-.05,0V146l-.11.06V146l.26-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,148l0,0a.1.1,0,0,0,0-.05.24.24,0,0,0,0-.09.14.14,0,0,0,0-.07h0s0,0,0,.05a.19.19,0,0,0,0,.08l-.05,0h0a.35.35,0,0,1,0-.14.22.22,0,0,1,.07-.09s.06,0,.08,0a.16.16,0,0,1,0,.11.28.28,0,0,1,0,.09.59.59,0,0,1,0,.08s0,0,0,0a.19.19,0,0,1,0,.08.24.24,0,0,1,0,.15.18.18,0,0,1-.08.09.06.06,0,0,1-.08,0s0-.05,0-.1h0l.06,0s0,.06,0,.07a0,0,0,0,0,0,0,.1.1,0,0,0,.05-.06.22.22,0,0,0,0-.09s0-.06,0-.07,0,0-.05,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,148.14l-.06,0v-.08l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,148a.13.13,0,0,0,.05-.07.32.32,0,0,0,0-.14v0l0,.06,0,0a.06.06,0,0,1-.08,0,.26.26,0,0,1,0-.14.52.52,0,0,1,0-.18.35.35,0,0,1,.08-.11s.06,0,.09,0a.28.28,0,0,1,0,.15v.16a.42.42,0,0,1,0,.2.2.2,0,0,1-.09.11l0,0h0V148H162Zm0-.21a.08.08,0,0,0,0,0,.14.14,0,0,0,0-.06v-.07a.28.28,0,0,0,0-.11s0,0-.05,0l0,.07a.37.37,0,0,0,0,.11.25.25,0,0,0,0,.1S162,147.79,162,147.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.32,147.24h.06v.07h0l0,0s0,0-.06.08a.59.59,0,0,0,0,.14v0l0-.06,0,0a.05.05,0,0,1,.08,0,.39.39,0,0,1,0,.13.43.43,0,0,1,0,.17.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.13a.66.66,0,0,1,0-.21A.25.25,0,0,1,162.32,147.24Zm0,.29,0,0,0,.06v.06a.27.27,0,0,0,0,.11s0,0,0,0,0,0,0-.06a.36.36,0,0,0,0-.11.22.22,0,0,0,0-.1S162.32,147.52,162.3,147.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,147.05l.1.45h0l.09-.56.07,0v.61l0,0v-.48h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 146.72 161.45 147.58 161.45 147.47 162.94 146.61 162.94 146.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,150.62l-.06,0v-.53l-.07,0v0l.13-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12,150.18a.6.6,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.16.16,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.44.44,0,0,0,0,.13v.17a.27.27,0,0,0,0,.11s0,0,0,0a.09.09,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,149.92l-.15.08v.28l-.05,0v-.62l.23-.13v.07l-.18.1v.21l.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.82,149.46l-.1.06v.55l-.05,0v-.55l-.11.06v-.07l.26-.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,151.47l0,0a.1.1,0,0,0,0,0,.24.24,0,0,0,0-.09.14.14,0,0,0,0-.07s0,0,0,0,0,0,0,0a.19.19,0,0,0,0,.08l-.05,0h0a.35.35,0,0,1,0-.14.22.22,0,0,1,.07-.09s.06,0,.08,0a.16.16,0,0,1,0,.11.28.28,0,0,1,0,.09.59.59,0,0,1,0,.08s0,0,0,0a.19.19,0,0,1,0,.08.28.28,0,0,1,0,.15.18.18,0,0,1-.08.09.06.06,0,0,1-.08,0s0-.05,0-.1h0l.06,0s0,.06,0,.07a0,0,0,0,0,0,0,.1.1,0,0,0,.05-.06.22.22,0,0,0,0-.09s0-.06,0-.07,0,0-.05,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.84,151.66l-.06,0v-.09l.06,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.13,151.25a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.19.19,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.06-.12a.41.41,0,0,0,0-.12s0,0,0,0a.09.09,0,0,0,0,.06.52.52,0,0,0,0,.14v.16a.29.29,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.49.49,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.19,151.18l0-.35.18-.11v.07l-.13.08v.19s0,0,0,0l0,0s.06,0,.08,0a.23.23,0,0,1,0,.13.43.43,0,0,1,0,.17.21.21,0,0,1-.08.1.06.06,0,0,1-.08,0s0-.05,0-.11h0l.05,0a.12.12,0,0,0,0,.07s0,0,0,0a.15.15,0,0,0,0-.06.37.37,0,0,0,0-.11s0-.07,0-.09a0,0,0,0,0-.05,0l0,0s0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,150.57l.1.45h0l.09-.55.07,0V151l0,0v-.47h0l-.1.53,0,0-.1-.42h0v.47l-.06,0v-.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.94 150.24 161.45 151.1 161.45 150.99 162.94 150.13 162.94 150.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,93.1l-.22.13v-.06l.11-.28,0-.12s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.28.28,0,0,0,0,.1l-.06,0h0a.33.33,0,0,1,0-.15.2.2,0,0,1,.09-.11s0,0,.07,0a.18.18,0,0,1,0,.11.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,92.7a.56.56,0,0,1,0,.2c0,.06,0,.1-.08.11a.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,94.26l-.23.13v-.06l.11-.29a.76.76,0,0,0,0-.11.25.25,0,0,0,0-.08.56.56,0,0,0,0-.07,0,0,0,0,0,0,0,.1.1,0,0,0,0,.06s0,.06,0,.1l0,0h0a.41.41,0,0,1,0-.16.2.2,0,0,1,.08-.1.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11.49.49,0,0,1,0,.12,1.21,1.21,0,0,1-.05.14l-.08.21.16-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52,93.86a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11s-.07,0-.09,0a.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.2.2,0,0,1,.09-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.06-.12a.31.31,0,0,0,0-.11s0,0,0,0a.1.1,0,0,0,0,.06.57.57,0,0,0,0,.14V94a.35.35,0,0,0,0,.12,0,0,0,0,0,0,0,.14.14,0,0,0,0-.07.49.49,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,93.71a.64.64,0,0,1,0,.2.24.24,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.64.64,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm0-.12a.29.29,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.45.45,0,0,0,0,.13v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 93.09 135.96 93.64 135.96 93.53 136.91 92.98 136.91 93.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,104.32l-.22.13v0l.11-.29,0-.12s0,0,0-.08a.14.14,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.31.31,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.23.23,0,0,1,0,.11.65.65,0,0,1,0,.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,103.93a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.2.2,0,0,1,.08-.11s.06,0,.08,0a.3.3,0,0,1,0,.16Zm-.05-.12a.29.29,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.49.49,0,0,0,0,.13V104a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.52.52,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,105.53l-.06,0V105l-.08.06V105l.14-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.52,105.09a.56.56,0,0,1,0,.2.24.24,0,0,1-.08.11.06.06,0,0,1-.09,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.17.17,0,0,1,.09-.11.05.05,0,0,1,.08,0,.37.37,0,0,1,0,.17Zm-.06-.12a.35.35,0,0,0,0-.12s0,0,0,0a.1.1,0,0,0,0,.07.49.49,0,0,0,0,.13v.17a.41.41,0,0,0,0,.12s0,0,0,0a.15.15,0,0,0,0-.06.57.57,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,104.93a.56.56,0,0,1,0,.2.2.2,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm0-.12a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.53.53,0,0,0,0,.14V105a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 104.32 135.96 104.87 135.96 104.75 136.91 104.2 136.91 104.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,114.26l-.22.12v0l.11-.29,0-.12s0,0,0-.07a.15.15,0,0,0,0-.08s0,0,0,0,0,0-.05.06a.34.34,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.27.27,0,0,1,0,.12.6.6,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,113.86a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.05-.12a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.53.53,0,0,0,0,.14V114a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,114.79a2,2,0,0,0-.08.27c0,.08,0,.17,0,.28v.06l-.06,0v-.06a2.58,2.58,0,0,1,0-.29,2,2,0,0,1,.08-.26l-.18.1v-.06l.23-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,114.94a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.05-.12a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.53.53,0,0,0,0,.14v.16a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 114.25 135.96 114.8 135.96 114.69 136.91 114.13 136.91 114.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,123.13l-.22.13v-.06l.11-.28,0-.12s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.31.31,0,0,0,0,.1l-.06,0h0a.33.33,0,0,1,0-.15.2.2,0,0,1,.09-.11s0,0,.07,0a.13.13,0,0,1,0,.1.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,122.73a.66.66,0,0,1,0,.21.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.11a.29.29,0,0,0,0-.12s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,124.06l0-.35.18-.11v.07l-.13.08,0,.19,0,0,0,0s.06,0,.07,0a.23.23,0,0,1,0,.13.43.43,0,0,1,0,.17.16.16,0,0,1-.08.1.06.06,0,0,1-.08,0s0,0,0-.11h0l.06,0s0,.06,0,.07,0,0,0,0a.09.09,0,0,0,0-.06.37.37,0,0,0,0-.11.22.22,0,0,0,0-.09s0,0,0,0a.08.08,0,0,0,0,0,.35.35,0,0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,123.82a.64.64,0,0,1,0,.2.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.64.64,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.29.29,0,0,0,0-.12s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 123.12 135.96 123.67 135.96 123.56 136.91 123.01 136.91 123.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,130.42l-.22.13v-.06l.11-.28,0-.12s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.28.28,0,0,0,0,.1l-.06,0h0a.41.41,0,0,1,0-.16.22.22,0,0,1,.09-.1s0,0,.07,0a.18.18,0,0,1,0,.11.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,130a.56.56,0,0,1,0,.2c0,.06,0,.1-.08.11a.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17V130a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,131.31l0,0v.07l0,0v.15l-.06,0v-.14l-.14.08v-.05l.14-.5.06,0Zm-.15.08.09,0v-.28h0v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,131.1a.56.56,0,0,1,0,.2c0,.06,0,.1-.08.11a.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 130.41 135.96 130.96 135.96 130.85 136.91 130.3 136.91 130.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,137.56l-.22.13v-.05l.11-.29,0-.12s0,0,0-.08a.14.14,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.31.31,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.23.23,0,0,1,0,.11.65.65,0,0,1,0,.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,137.17a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.2.2,0,0,1,.08-.11s.06,0,.08,0a.37.37,0,0,1,0,.17Zm-.05-.12a.29.29,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.49.49,0,0,0,0,.13v.17a.41.41,0,0,0,0,.12,0,0,0,0,0,0,0,.09.09,0,0,0,0-.06.52.52,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.22,138.39l0,0a.1.1,0,0,0,0-.05.29.29,0,0,0,0-.09.12.12,0,0,0,0-.07s0,0,0,0l0,0a.29.29,0,0,0,0,.09l-.05,0h0a.32.32,0,0,1,0-.14.22.22,0,0,1,.07-.09s.06,0,.08,0a.14.14,0,0,1,0,.11.28.28,0,0,1,0,.09l0,.08s0,0,0,0a.15.15,0,0,1,0,.08.28.28,0,0,1,0,.15.18.18,0,0,1-.08.09.06.06,0,0,1-.08,0,.14.14,0,0,1,0-.11h0l.06,0s0,.06,0,.07,0,0,0,0a.1.1,0,0,0,.05-.06.22.22,0,0,0,0-.09.17.17,0,0,0,0-.08,0,0,0,0,0-.05,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,138.25a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11.05.05,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.2.2,0,0,1,.08-.11s.06,0,.08,0a.37.37,0,0,1,0,.17Zm-.05-.12a.29.29,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.49.49,0,0,0,0,.13v.17a.41.41,0,0,0,0,.12,0,0,0,0,0,0,0,.09.09,0,0,0,0-.06.52.52,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 137.56 135.96 138.11 135.96 137.99 136.91 137.44 136.91 137.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,145.65l-.22.13v-.06l.11-.28,0-.12s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.28.28,0,0,0,0,.1l-.06,0h0a.41.41,0,0,1,0-.16.22.22,0,0,1,.09-.1s0,0,.07,0a.18.18,0,0,1,0,.11.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,145.25a.56.56,0,0,1,0,.2c0,.06,0,.1-.08.11a.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,146.73l-.22.13v-.06l.11-.28,0-.12s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.28.28,0,0,0,0,.1l-.06,0h0a.41.41,0,0,1,0-.16.22.22,0,0,1,.09-.1s.06,0,.07,0a.18.18,0,0,1,0,.11.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,146.42l0-.35.18-.11V146l-.13.08v.19s0,0,0,0l0,0a.06.06,0,0,1,.08,0,.26.26,0,0,1,0,.14.41.41,0,0,1,0,.16.18.18,0,0,1-.09.1s0,0-.07,0,0,0,0-.11h0l.05,0a.1.1,0,0,0,0,.07s0,0,0,0a.1.1,0,0,0,.05-.06s0-.07,0-.11a.2.2,0,0,0,0-.09s0,0,0,0l0,0s0,0,0,.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 145.64 135.96 146.19 135.96 146.08 136.91 145.53 136.91 145.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,150.75l-.22.13v0l.11-.29,0-.12s0,0,0-.08a.14.14,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.31.31,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.22.22,0,0,1,0,.11.53.53,0,0,1,0,.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,150.36a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11s.06,0,.08,0a.3.3,0,0,1,0,.16Zm-.05-.12a.33.33,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.49.49,0,0,0,0,.13v.17a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,151.83l-.22.13v-.05l.11-.29,0-.12s0-.05,0-.08a.14.14,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.31.31,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.22.22,0,0,1,0,.11.53.53,0,0,1,0,.15l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,151.44a.56.56,0,0,1,0,.2.19.19,0,0,1-.08.11,0,0,0,0,1-.08,0,.3.3,0,0,1,0-.16v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11s.06,0,.08,0a.3.3,0,0,1,0,.16Zm-.05-.12a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.53.53,0,0,0,0,.14v.16a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.46.46,0,0,0,0-.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 150.75 135.96 151.3 135.96 151.19 136.91 150.63 136.91 150.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,157.5l-.22.13v-.06l.11-.29,0-.11s0-.06,0-.08a.15.15,0,0,0,0-.08h0l-.05.06a.37.37,0,0,0,0,.11l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.25.25,0,0,1,0,.12.6.6,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,157.1a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.37.37,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.05-.12a.37.37,0,0,0,0-.12s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.38.38,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,158.62l-.05,0v-.53l-.08.06v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.44,158.26l0-.35.18-.1v.07l-.13.08v.19s0,0,0,0l0,0s.06,0,.08,0a.24.24,0,0,1,0,.13.47.47,0,0,1,0,.17.18.18,0,0,1-.09.1s0,0-.07,0a.14.14,0,0,1,0-.11h0l.05,0a.12.12,0,0,0,0,.07s0,0,0,0a.1.1,0,0,0,.05-.06s0-.07,0-.11a.14.14,0,0,0,0-.09s0,0,0,0l0,0s0,0,0,.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 157.49 135.96 158.04 135.96 157.93 136.91 157.38 136.91 157.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,161.76l-.22.13v-.06l.11-.29,0-.11s0-.06,0-.08a.15.15,0,0,0,0-.08h0l-.05.06a.34.34,0,0,0,0,.1l-.06,0h0a.4.4,0,0,1,0-.15.18.18,0,0,1,.09-.1s0,0,.07,0a.16.16,0,0,1,0,.11.27.27,0,0,1,0,.12.6.6,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,161.36a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.37.37,0,0,1,0-.17v-.14a.56.56,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.3.3,0,0,1,0,.16Zm-.05-.12a.37.37,0,0,0,0-.12s0,0,0,0,0,0,0,.07a.57.57,0,0,0,0,.14v.16a.41.41,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,162.88l-.05,0v-.53l-.08.06v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,162.42l0,0a.1.1,0,0,0,0-.05.22.22,0,0,0,0-.09.15.15,0,0,0,0-.07h0a.07.07,0,0,0,0,.05.19.19,0,0,0,0,.08l-.06,0h0a.35.35,0,0,1,0-.14.24.24,0,0,1,.08-.09.06.06,0,0,1,.08,0,.16.16,0,0,1,0,.11.29.29,0,0,1,0,.09.2.2,0,0,1,0,.08.05.05,0,0,1,0,0,.19.19,0,0,1,0,.08.33.33,0,0,1,0,.15.27.27,0,0,1-.08.1.11.11,0,0,1-.08,0,.16.16,0,0,1,0-.11h0l0,0a.1.1,0,0,0,0,.07s0,0,0,0a.1.1,0,0,0,0-.05.3.3,0,0,0,0-.1.12.12,0,0,0,0-.07s0,0,0,0l0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 161.75 135.96 162.3 135.96 162.19 136.91 161.63 136.91 161.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,165.22l-.22.13v-.06l.11-.29a.76.76,0,0,0,0-.11s0-.06,0-.08a.12.12,0,0,0,0-.07s0,0,0,0a.1.1,0,0,0-.05.06.28.28,0,0,0,0,.1l-.06,0h0a.41.41,0,0,1,0-.16.22.22,0,0,1,.09-.1s0,0,.07,0a.18.18,0,0,1,0,.11.25.25,0,0,1,0,.12.48.48,0,0,1,0,.14l-.07.21.15-.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,164.82a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.32.32,0,0,1,0,.16Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14v.16a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,166.34l-.05,0v-.53l-.08.05v-.06l.13-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.65,165.9a.56.56,0,0,1,0,.2.16.16,0,0,1-.08.11.05.05,0,0,1-.08,0,.34.34,0,0,1,0-.17v-.14a.6.6,0,0,1,0-.2.24.24,0,0,1,.08-.11.05.05,0,0,1,.08,0,.34.34,0,0,1,0,.17Zm-.05-.12a.27.27,0,0,0,0-.11s0,0,0,0a.09.09,0,0,0,0,.06.57.57,0,0,0,0,.14V166a.35.35,0,0,0,0,.12s0,0,0,0,0,0,0-.07a.44.44,0,0,0,0-.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.91 165.21 135.96 165.76 135.96 165.65 136.91 165.1 136.91 165.21",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--TV--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "35.94 276.07 29.16 272.16 29.16 80.75 35.94 84.66 35.94 276.07",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.94 276.07 29.16 272.16 29.16 80.75 35.94 84.66 35.94 276.07",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.94 84.66 101.44 46.85 101.44 238.19 35.94 276.07 35.94 84.66",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.94 84.66 101.44 46.85 101.44 238.19 35.94 276.07 35.94 84.66",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.16 80.75 94.66 42.93 101.44 46.85 35.94 84.66 29.16 80.75",
    style: {
      fill: "#26A695"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tv--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3,189.37l-.18-.11a2.7,2.7,0,0,1-1.22-2.11V114.54a2.7,2.7,0,0,1,1.23-2.12l93.32-53.66a2.71,2.71,0,0,1,2.45,0h0a2.72,2.72,0,0,1,1.22,2.12v72.61a2.72,2.72,0,0,1-1.22,2.12L23.75,189.37A2.71,2.71,0,0,1,21.3,189.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.16,115.59l-3.9-2.26a2.52,2.52,0,0,0-.36,1.21v72.61a2.7,2.7,0,0,0,1.22,2.11l.18.11a2.71,2.71,0,0,0,2.45,0l.41-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.52,188.66V116.05a2.7,2.7,0,0,1,1.23-2.12l93.13-53.76c.67-.39,1.22-.08,1.22.7v72.61a2.72,2.72,0,0,1-1.22,2.12L23.75,189.37C23.07,189.76,22.52,189.44,22.52,188.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,60.87l.12,22.84,0,22.83,0,22.84v2.85c0,.49,0,.94,0,1.45a3,3,0,0,1-.57,1.42,2.81,2.81,0,0,1-.54.55c-.23.16-.42.26-.63.38l-1.24.72-2.47,1.43L103,143.91,63.39,166.68l-19.8,11.38L23.75,189.37l19.71-11.53,19.75-11.46,39.52-22.9,9.9-5.69,2.47-1.42,1.24-.71c.2-.12.43-.24.59-.36a2,2,0,0,0,.45-.46,2.59,2.59,0,0,0,.5-1.2c0-.43,0-.94,0-1.41v-2.85l0-22.84,0-22.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.44,160.11,72,158c.27-.15.49,0,.49.25a1,1,0,0,1-.49.81l-3.6,2.08c-.27.15-.48,0-.48-.25A1,1,0,0,1,68.44,160.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.66,115.64l89.17-51.59c.38-.22.7,0,.7.41V129.9a1.58,1.58,0,0,1-.7,1.21L25.66,182.59c-.39.22-.7,0-.7-.4V116.85A1.54,1.54,0,0,1,25.66,115.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.34,182.81a.5.5,0,0,1-.24-.06.62.62,0,0,1-.27-.56V116.85a1.69,1.69,0,0,1,.76-1.32l89.18-51.59a.61.61,0,0,1,.62,0,.59.59,0,0,1,.26.56V129.9a1.66,1.66,0,0,1-.76,1.32L25.72,182.7A.82.82,0,0,1,25.34,182.81Zm.38-67.06a1.46,1.46,0,0,0-.64,1.1v65.34a.31.31,0,0,0,.51.29L114.77,131a1.45,1.45,0,0,0,.63-1.1V64.46a.31.31,0,0,0-.51-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,140.2a17.78,17.78,0,0,1,.38-3.06,13.07,13.07,0,0,1,1-2.87,11.4,11.4,0,0,1,1.58-2.47,8.27,8.27,0,0,1,2.24-1.87,4.47,4.47,0,0,1,2.22-.72,2.2,2.2,0,0,1,1.58.65,4.1,4.1,0,0,1,1,1.77,11,11,0,0,1,.39,2.63c0,.34,0,.71,0,1.12s0,.83,0,1.27,0,.87,0,1.29,0,.8,0,1.15a17.78,17.78,0,0,1-.38,3.06,13.61,13.61,0,0,1-1,2.87,10.79,10.79,0,0,1-1.59,2.46,8.47,8.47,0,0,1-2.23,1.85,4.42,4.42,0,0,1-2.24.73,2.2,2.2,0,0,1-1.58-.64,3.84,3.84,0,0,1-1-1.76,11.24,11.24,0,0,1-.38-2.63c0-.34,0-.71,0-1.12s0-.83,0-1.27,0-.87,0-1.29S34.5,140.55,34.51,140.2Zm7.93-4.44a3.44,3.44,0,0,0-.81-2.53c-.5-.43-1.15-.4-2,.07a5,5,0,0,0-2,2.2,8.21,8.21,0,0,0-.81,3.47c0,.7,0,1.47,0,2.3s0,1.59,0,2.26a3.35,3.35,0,0,0,.81,2.52c.5.42,1.15.39,2-.08a5.15,5.15,0,0,0,2-2.19,8.28,8.28,0,0,0,.81-3.46c0-.7,0-1.47,0-2.3S42.47,136.43,42.44,135.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.28,122.91c1.41-.81,2.51-.94,3.29-.36s1.18,1.84,1.18,3.82a11.12,11.12,0,0,1-1.18,5.21A8.45,8.45,0,0,1,52.28,135l-2.8,1.62v6a1.45,1.45,0,0,1-.14.59.88.88,0,0,1-.33.41l-1.42.82a.25.25,0,0,1-.33,0,.54.54,0,0,1-.14-.43V126.62a1.25,1.25,0,0,1,.14-.59.83.83,0,0,1,.33-.41Zm-2.8,10.38,2.71-1.57a4.43,4.43,0,0,0,1.6-1.53,4.62,4.62,0,0,0,.59-2.46c0-1-.2-1.58-.59-1.74a1.93,1.93,0,0,0-1.6.34l-2.71,1.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,114.52a.25.25,0,0,1,.33,0,.57.57,0,0,1,.14.44v1.91a1.25,1.25,0,0,1-.14.59.83.83,0,0,1-.33.41l-3.15,1.82v14.77a1.38,1.38,0,0,1-.14.59.83.83,0,0,1-.33.41l-1.42.82a.25.25,0,0,1-.33,0,.57.57,0,0,1-.14-.44V121.07l-3.15,1.82a.26.26,0,0,1-.34,0,.58.58,0,0,1-.14-.43v-1.92a1.45,1.45,0,0,1,.14-.59,1,1,0,0,1,.34-.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.51,131.83a.24.24,0,0,1-.33,0,.56.56,0,0,1-.14-.43V114a1.31,1.31,0,0,1,.14-.59.88.88,0,0,1,.33-.41l1.42-.81a.24.24,0,0,1,.33,0,.58.58,0,0,1,.14.43V130a1.38,1.38,0,0,1-.14.59.89.89,0,0,1-.33.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,118.83a1.55,1.55,0,0,1,.18-.63,1,1,0,0,1,.32-.36l1.42-.82a.28.28,0,0,1,.34,0c.1.07.15.22.14.45a13.8,13.8,0,0,1-.36,2.41,12,12,0,0,1-.94,2.54,11.7,11.7,0,0,1-1.59,2.37,8.73,8.73,0,0,1-2.33,1.91,4.13,4.13,0,0,1-2.14.68,2.23,2.23,0,0,1-1.57-.62,4,4,0,0,1-1-1.78,11.17,11.17,0,0,1-.43-2.74q0-1,0-2.25t0-2.28a18.18,18.18,0,0,1,.43-3.24,13.58,13.58,0,0,1,1-2.94,11,11,0,0,1,1.57-2.45,8.1,8.1,0,0,1,2.14-1.78,4.72,4.72,0,0,1,2.33-.78,2.46,2.46,0,0,1,1.59.54,3.17,3.17,0,0,1,.94,1.46,8.05,8.05,0,0,1,.36,2,1.15,1.15,0,0,1-.14.6.87.87,0,0,1-.34.4l-1.42.82a.33.33,0,0,1-.33,0,.52.52,0,0,1-.19-.42,2.6,2.6,0,0,0-.25-.91,1.42,1.42,0,0,0-.52-.61,1.31,1.31,0,0,0-.84-.17,2.7,2.7,0,0,0-1.19.43,4.27,4.27,0,0,0-1.19,1A6.28,6.28,0,0,0,76.8,113a7.7,7.7,0,0,0-.53,1.6,10,10,0,0,0-.21,1.71c0,.7,0,1.46,0,2.29s0,1.57,0,2.24a6.27,6.27,0,0,0,.21,1.48,2.34,2.34,0,0,0,.53,1,1.26,1.26,0,0,0,.85.37,2.22,2.22,0,0,0,1.19-.36A5.29,5.29,0,0,0,80,122.4a6.09,6.09,0,0,0,.85-1.15,6.18,6.18,0,0,0,.53-1.22A6.27,6.27,0,0,0,81.66,118.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,100.13c.19-.11.33-.11.42,0a1.42,1.42,0,0,1,.25.55l4.28,14.56a.5.5,0,0,1,0,.18,1.31,1.31,0,0,1-.14.59.88.88,0,0,1-.33.41l-1.26.73c-.23.13-.4.15-.49.05a.79.79,0,0,1-.19-.33l-.76-2.56L88,117.48l-.75,3.43a3.29,3.29,0,0,1-.19.55,1.22,1.22,0,0,1-.49.52l-1.26.73a.27.27,0,0,1-.34,0,.58.58,0,0,1-.14-.43,1.23,1.23,0,0,1,0-.2l4.29-19.51a3.6,3.6,0,0,1,.25-.83,1,1,0,0,1,.42-.47Zm1,11.27-1.92-6.56-1.93,8.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,107.14a.24.24,0,0,1,.33,0,.58.58,0,0,1,.14.43v1.91a1.46,1.46,0,0,1-.14.6.94.94,0,0,1-.33.41l-7.67,4.42a.24.24,0,0,1-.33,0,.56.56,0,0,1-.14-.43V97.07a1.32,1.32,0,0,1,.14-.6.8.8,0,0,1,.33-.4l1.42-.82a.24.24,0,0,1,.33,0,.58.58,0,0,1,.14.43v14.77Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--counter--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 278.55 111.23 315.09 257.27 230.77 193.93 194.19 157.41 215.27 181.81 229.37 108.79 271.53 84.45 257.48 47.94 278.55",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 278.55 111.23 315.09 257.27 230.77 193.93 194.19 157.41 215.27 181.81 229.37 108.79 271.53 84.45 257.48 47.94 278.55",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 261.69 47.94 270.12 111.23 306.66 111.23 298.23 47.94 261.69",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 261.69 47.94 270.12 111.23 306.66 111.23 298.23 47.94 261.69",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.27 213.91 257.27 222.34 111.23 306.66 111.23 298.23 257.27 213.91",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.27 213.91 257.27 222.34 111.23 306.66 111.23 298.23 257.27 213.91",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.41 198.41 157.41 206.84 174.51 216.72 181.81 212.5 157.41 198.41",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.41 198.41 157.41 206.84 174.51 216.72 181.81 212.5 157.41 198.41",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.37 271.53 50.37 277.15 111.23 312.28 111.23 306.66 50.37 271.53",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.37 271.53 50.37 277.15 111.23 312.28 111.23 306.66 50.37 271.53",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.83 223.75 254.83 229.37 111.23 312.28 111.23 306.66 254.83 223.75",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 278.55 47.94 342.65 111.23 379.19 111.23 315.09 47.94 278.55",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 278.55 47.94 342.65 111.23 379.19 111.23 315.09 47.94 278.55",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.41 215.27 157.41 226.59 167.21 220.94 157.41 215.27",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.41 215.27 157.41 226.59 167.21 220.94 157.41 215.27",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.27 230.77 257.27 294.87 111.23 379.19 111.23 315.09 257.27 230.77",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.27 230.77 257.27 294.87 111.23 379.19 111.23 315.09 257.27 230.77",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.85 208.25 159.85 213.87 169.64 219.53 174.51 216.72 159.85 208.25",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.85 208.25 159.85 213.87 169.64 219.53 174.51 216.72 159.85 208.25",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 261.69 111.23 298.23 257.27 213.91 193.93 177.33 157.41 198.41 181.81 212.5 108.79 254.66 84.45 240.61 47.94 261.69",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.94 261.69 111.23 298.23 257.27 213.91 193.93 177.33 157.41 198.41 181.81 212.5 108.79 254.66 84.45 240.61 47.94 261.69",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,272.78c-8.72,7.87-11.79,12.84-16.62,15.64s-7.9,1.35-16.62,3.54c-7,1.77-18.5,8.79-27.34,15-2,1.39-3.85,2.75-5.47,4a23.09,23.09,0,0,0,.19,8.7,4.51,4.51,0,0,1,.32.72c.42-.29,1.91-1.06,2.73,2.1.94,3.69,1.55,11.47,3.38,14.92a11.1,11.1,0,0,0,2.42,3.23c.13,0,.24.09.36.12h0a10.44,10.44,0,0,0,1,.2h0a10.12,10.12,0,0,0,3.07-.1l.51-.1c.27-.06.54-.12.82-.2s.56-.16.85-.25a20.82,20.82,0,0,0,2.72-1.09c.37-.16.76-.36,1.16-.56s1-.51,1.45-.8c11.23-6.48,15.9-15.4,18.68-23.42s2-16.63,7.21-19.62l.49-.25a2.71,2.71,0,0,1,.46-.18c1.35-.43,2.2.17,2.84,1.34,3.81-.8,3.43,7.43,6,11.81a12.77,12.77,0,0,0,2.85,3.5h0l.52.16.48.11.16,0,.36.06.41.05.29,0a13.32,13.32,0,0,0,4.78-.66l.45-.15a30.88,30.88,0,0,0,5.85-2.71,36.66,36.66,0,0,0,16.92-21.41c1.82-5.56,2.43-14,3.39-18.83s2.83-5.3,2.83-5.3a28.9,28.9,0,0,0,.7-7.62c-1,.43-2.12.9-3.25,1.42C222.34,260.19,210.79,266.51,203.83,272.78Zm-26.76,38.7a35.61,35.61,0,0,1-3.87,11.17h0A31.31,31.31,0,0,1,161,334.86c-5.84,3.3-9.34,2.63-11.51.62a6.24,6.24,0,0,1-2.8-1.69,4.83,4.83,0,0,1-.37-.42,3.37,3.37,0,0,1-.34-.43,4.15,4.15,0,0,1-.3-.43l-.24-.4-.18-.32a2,2,0,0,1-.15-.29c-.09-.17-.17-.34-.24-.5h0a13.83,13.83,0,0,1-.6-1.53.08.08,0,0,0,0,0c-.11-.32-.2-.64-.29-.95-.16-.56-.29-1.1-.39-1.58,0-.1-.05-.21-.07-.3s0-.2-.07-.3c-.87-4-1.92-12.14,0-15.24s7-8.13,15.39-12.05c.28-.15.58-.28.89-.42a36.78,36.78,0,0,1,3.82-1.46c.5-.16,1-.3,1.49-.44a26.18,26.18,0,0,1,3.72-.76c.4-.06.78-.09,1.14-.12s.84,0,1.23,0h.25a3.19,3.19,0,0,1,.45,0,3.87,3.87,0,0,1,2.51.89,2.33,2.33,0,0,1,.39.59,3.48,3.48,0,0,1,2.13.83C178.5,299.88,178,306,177.07,311.48Zm51.43-31.43c-.68,3.88-2.15,12.26-8.4,19.13a28.09,28.09,0,0,1-6.65,5.38c-6.8,4-10.77,3.36-13.09,1.23a6.47,6.47,0,0,1-2.81-1.69l0-.05a2.91,2.91,0,0,1-.24-.27,3.82,3.82,0,0,1-.27-.32c-.05,0-.09-.11-.14-.17s-.24-.34-.34-.51-.25-.41-.36-.62l-.17-.31-.08-.18-.12-.27c0-.08-.07-.14-.09-.21a16,16,0,0,1-.87-2.84c-.93-4.44-1.43-10,.25-13.66s8.26-10.48,14.61-15c1.46-1,2.83-1.93,4.1-2.68l.49-.29.52-.3,1.43-.77.51-.26c.24-.11.46-.23.68-.32.38-.19.76-.35,1.11-.5a21.14,21.14,0,0,1,2.07-.78,4.42,4.42,0,0,1,.48-.15l.13,0,.33-.09.49-.13.6-.13a9.66,9.66,0,0,1,1-.13l.17,0a4.67,4.67,0,0,1,2.21.25,1.73,1.73,0,0,1,.74,1.16,4.16,4.16,0,0,1,1.78.27C230.43,265.67,229.36,275.08,228.5,280.05Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,272.78c-8.72,7.87-11.79,12.84-16.62,15.64s-7.9,1.35-16.62,3.54c-7,1.77-18.5,8.79-27.34,15-2,1.39-3.85,2.75-5.47,4a23.09,23.09,0,0,0,.19,8.7,4.51,4.51,0,0,1,.32.72c.42-.29,1.91-1.06,2.73,2.1.94,3.69,1.55,11.47,3.38,14.92a11.1,11.1,0,0,0,2.42,3.23c.13,0,.24.09.36.12h0a10.44,10.44,0,0,0,1,.2h0a10.12,10.12,0,0,0,3.07-.1l.51-.1c.27-.06.54-.12.82-.2s.56-.16.85-.25a20.82,20.82,0,0,0,2.72-1.09c.37-.16.76-.36,1.16-.56s1-.51,1.45-.8c11.23-6.48,15.9-15.4,18.68-23.42s2-16.63,7.21-19.62l.49-.25a2.71,2.71,0,0,1,.46-.18c1.35-.43,2.2.17,2.84,1.34,3.81-.8,3.43,7.43,6,11.81a12.77,12.77,0,0,0,2.85,3.5h0l.52.16.48.11.16,0,.36.06.41.05.29,0a13.32,13.32,0,0,0,4.78-.66l.45-.15a30.88,30.88,0,0,0,5.85-2.71,36.66,36.66,0,0,0,16.92-21.41c1.82-5.56,2.43-14,3.39-18.83s2.83-5.3,2.83-5.3a28.9,28.9,0,0,0,.7-7.62c-1,.43-2.12.9-3.25,1.42C222.34,260.19,210.79,266.51,203.83,272.78Zm-26.76,38.7a35.61,35.61,0,0,1-3.87,11.17h0A31.31,31.31,0,0,1,161,334.86c-5.84,3.3-9.34,2.63-11.51.62a6.24,6.24,0,0,1-2.8-1.69,4.83,4.83,0,0,1-.37-.42,3.37,3.37,0,0,1-.34-.43,4.15,4.15,0,0,1-.3-.43l-.24-.4-.18-.32a2,2,0,0,1-.15-.29c-.09-.17-.17-.34-.24-.5h0a13.83,13.83,0,0,1-.6-1.53.08.08,0,0,0,0,0c-.11-.32-.2-.64-.29-.95-.16-.56-.29-1.1-.39-1.58,0-.1-.05-.21-.07-.3s0-.2-.07-.3c-.87-4-1.92-12.14,0-15.24s7-8.13,15.39-12.05c.28-.15.58-.28.89-.42a36.78,36.78,0,0,1,3.82-1.46c.5-.16,1-.3,1.49-.44a26.18,26.18,0,0,1,3.72-.76c.4-.06.78-.09,1.14-.12s.84,0,1.23,0h.25a3.19,3.19,0,0,1,.45,0,3.87,3.87,0,0,1,2.51.89,2.33,2.33,0,0,1,.39.59,3.48,3.48,0,0,1,2.13.83C178.5,299.88,178,306,177.07,311.48Zm51.43-31.43c-.68,3.88-2.15,12.26-8.4,19.13a28.09,28.09,0,0,1-6.65,5.38c-6.8,4-10.77,3.36-13.09,1.23a6.47,6.47,0,0,1-2.81-1.69l0-.05a2.91,2.91,0,0,1-.24-.27,3.82,3.82,0,0,1-.27-.32c-.05,0-.09-.11-.14-.17s-.24-.34-.34-.51-.25-.41-.36-.62l-.17-.31-.08-.18-.12-.27c0-.08-.07-.14-.09-.21a16,16,0,0,1-.87-2.84c-.93-4.44-1.43-10,.25-13.66s8.26-10.48,14.61-15c1.46-1,2.83-1.93,4.1-2.68l.49-.29.52-.3,1.43-.77.51-.26c.24-.11.46-.23.68-.32.38-.19.76-.35,1.11-.5a21.14,21.14,0,0,1,2.07-.78,4.42,4.42,0,0,1,.48-.15l.13,0,.33-.09.49-.13.6-.13a9.66,9.66,0,0,1,1-.13l.17,0a4.67,4.67,0,0,1,2.21.25,1.73,1.73,0,0,1,.74,1.16,4.16,4.16,0,0,1,1.78.27C230.43,265.67,229.36,275.08,228.5,280.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,253.82l-2.24.92a28.38,28.38,0,0,1-.69,7.62s-1.89.51-2.83,5.3-1.57,13.27-3.39,18.83-5.68,14.93-16.93,21.42a30.94,30.94,0,0,1-5.85,2.71l-.44.13a13.16,13.16,0,0,1-4.78.67l-.28,0a2.72,2.72,0,0,1-.42,0l-.36-.06a.45.45,0,0,1-.16,0l-.48-.11a5.16,5.16,0,0,1-.52-.16h0a7.91,7.91,0,0,0,1.09.76h0a9,9,0,0,0,.93.47l.5.18a5.52,5.52,0,0,0,.54.16,3.37,3.37,0,0,0,.48.12.37.37,0,0,0,.15,0l.36.06.41,0,.28,0a13.12,13.12,0,0,0,4.79-.66l.45-.14a31.17,31.17,0,0,0,5.85-2.71c11.23-6.49,15.09-15.85,16.92-21.41s2.44-14.05,3.39-18.83,2.84-5.3,2.84-5.3C237.6,257.55,236.66,253.82,236.66,253.82Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,302.78c.1.17.22.34.34.51s.09.12.14.17a3.82,3.82,0,0,0,.27.32,3.08,3.08,0,0,0,.25.27.07.07,0,0,0,0,.05,6.35,6.35,0,0,0,2.79,1.68,2.21,2.21,0,0,1-.28-.26l0,0-.24-.27a3.92,3.92,0,0,1-.27-.33c-.05-.05-.09-.11-.14-.17s-.23-.34-.34-.51a6.27,6.27,0,0,1-.36-.62c-.06-.09-.11-.2-.17-.31l-.08-.18q-.06-.12-.12-.27a1.89,1.89,0,0,1-.09-.21,16.16,16.16,0,0,1-.87-2.83c-.92-4.45-1.43-9.95.25-13.66s8.26-10.48,14.6-15c1.47-1,2.84-1.93,4.11-2.68l.49-.29c.18-.09.35-.19.52-.29.49-.28,1-.53,1.42-.78l.52-.25.68-.33,1.11-.5c.74-.31,1.42-.58,2.06-.78l.49-.15.13,0,.32-.09.5-.12.59-.13c.36-.07.68-.11,1-.14h.17l.43,0a4,4,0,0,1,1.86.31l-2.52-1.42-.08-.05a4.56,4.56,0,0,0-2.21-.24h-.17c-.3,0-.63.07-1,.13l-.59.13-.49.13a3.18,3.18,0,0,0-.33.09l-.13,0-.48.14c-.64.21-1.33.47-2.06.79-.37.15-.74.31-1.12.5l-.68.32-.51.26c-.46.25-.94.5-1.42.78l-.53.29-.49.28c-1.27.76-2.65,1.65-4.1,2.69-6.35,4.49-12.93,11.27-14.61,15s-1.18,9.21-.24,13.65a15.14,15.14,0,0,0,.86,2.84,1.89,1.89,0,0,0,.09.21l.12.27.09.18a1.73,1.73,0,0,0,.16.3A6.44,6.44,0,0,0,196.52,302.78Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,302.78c.1.17.22.34.34.51s.09.12.14.17a3.82,3.82,0,0,0,.27.32,3.08,3.08,0,0,0,.25.27.07.07,0,0,0,0,.05,6.35,6.35,0,0,0,2.79,1.68,2.21,2.21,0,0,1-.28-.26l0,0-.24-.27a3.92,3.92,0,0,1-.27-.33c-.05-.05-.09-.11-.14-.17s-.23-.34-.34-.51a6.27,6.27,0,0,1-.36-.62c-.06-.09-.11-.2-.17-.31l-.08-.18q-.06-.12-.12-.27a1.89,1.89,0,0,1-.09-.21,16.16,16.16,0,0,1-.87-2.83c-.92-4.45-1.43-9.95.25-13.66s8.26-10.48,14.6-15c1.47-1,2.84-1.93,4.11-2.68l.49-.29c.18-.09.35-.19.52-.29.49-.28,1-.53,1.42-.78l.52-.25.68-.33,1.11-.5c.74-.31,1.42-.58,2.06-.78l.49-.15.13,0,.32-.09.5-.12.59-.13c.36-.07.68-.11,1-.14h.17l.43,0a4,4,0,0,1,1.86.31l-2.52-1.42-.08-.05a4.56,4.56,0,0,0-2.21-.24h-.17c-.3,0-.63.07-1,.13l-.59.13-.49.13a3.18,3.18,0,0,0-.33.09l-.13,0-.48.14c-.64.21-1.33.47-2.06.79-.37.15-.74.31-1.12.5l-.68.32-.51.26c-.46.25-.94.5-1.42.78l-.53.29-.49.28c-1.27.76-2.65,1.65-4.1,2.69-6.35,4.49-12.93,11.27-14.61,15s-1.18,9.21-.24,13.65a15.14,15.14,0,0,0,.86,2.84,1.89,1.89,0,0,0,.09.21l.12.27.09.18a1.73,1.73,0,0,0,.16.3A6.44,6.44,0,0,0,196.52,302.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.64,294.33l-.45.17a4.81,4.81,0,0,0-.5.26c-5.18,3-4.43,11.61-7.21,19.63S170,331.32,158.8,337.8c-.5.29-1,.55-1.46.8s-.78.4-1.15.56a19.77,19.77,0,0,1-2.71,1.08c-.3.1-.58.19-.86.26s-.56.14-.81.2a5.27,5.27,0,0,1-.52.1,10.12,10.12,0,0,1-3.07.1h0c-.35-.06-.69-.12-1-.2h0c-.12,0-.22-.08-.34-.12a6.58,6.58,0,0,0,1.07.79l.05,0a6.14,6.14,0,0,0,1.75.73,7.81,7.81,0,0,0,1,.21h0a10.74,10.74,0,0,0,3.06-.1,4.64,4.64,0,0,0,.51-.11c.27-.06.54-.12.81-.2s.57-.15.86-.24a24.07,24.07,0,0,0,2.72-1.09l1.16-.56c.46-.26.95-.51,1.45-.81,11.23-6.48,15.9-15.4,18.67-23.41s2-16.63,7.22-19.63c.18-.09.33-.18.49-.25l.46-.18a1.36,1.36,0,0,1,.32-.08,2.45,2.45,0,0,1,1.41.18l-2.47-1.41A2.08,2.08,0,0,0,185.64,294.33Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.19,335.22a4.81,4.81,0,0,1-.38-.42,3.46,3.46,0,0,1-.34-.44,2.74,2.74,0,0,1-.3-.43l-.24-.39c-.06-.11-.13-.22-.18-.32a2.1,2.1,0,0,1-.15-.3c-.08-.17-.17-.33-.24-.5h0a13,13,0,0,1-.6-1.52.06.06,0,0,0,0,0c-.11-.32-.21-.65-.29-1-.16-.56-.29-1.1-.4-1.58L146,328l-.06-.29c-.89-4-1.93-12.15,0-15.25s7-8.13,15.38-12.05l.89-.42a35.32,35.32,0,0,1,3.82-1.45c.5-.17,1-.31,1.48-.44a25.59,25.59,0,0,1,3.73-.77l1.13-.12c.45,0,.85,0,1.24,0h.25l.45,0,.38.06a4.88,4.88,0,0,1,1.73.51l-2.55-1.47a5.05,5.05,0,0,0-2.08-.52,3.19,3.19,0,0,0-.45,0h-.25c-.38,0-.8,0-1.23,0s-.74.06-1.14.12a26.58,26.58,0,0,0-3.73.76c-.48.13-1,.28-1.48.45a35.32,35.32,0,0,0-3.82,1.45c-.3.14-.61.27-.89.42-8.36,3.92-13.53,9.06-15.39,12.05s-.87,11.28,0,15.24c0,.1.05.2.07.3s0,.19.07.3c.1.48.23,1,.38,1.58q.15.46.3,1l0,0a11.47,11.47,0,0,0,.59,1.53h0l.23.5.16.29c.06.11.12.22.19.33a4,4,0,0,0,.23.39,4.15,4.15,0,0,0,.3.43,3.37,3.37,0,0,0,.34.43,4.83,4.83,0,0,0,.37.42,6.28,6.28,0,0,0,1.37,1.08c.32.19,2.14,1.29,2.52,1.42a8.57,8.57,0,0,1-1.09-.81A2.23,2.23,0,0,1,149.19,335.22Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.19,335.22a4.81,4.81,0,0,1-.38-.42,3.46,3.46,0,0,1-.34-.44,2.74,2.74,0,0,1-.3-.43l-.24-.39c-.06-.11-.13-.22-.18-.32a2.1,2.1,0,0,1-.15-.3c-.08-.17-.17-.33-.24-.5h0a13,13,0,0,1-.6-1.52.06.06,0,0,0,0,0c-.11-.32-.21-.65-.29-1-.16-.56-.29-1.1-.4-1.58L146,328l-.06-.29c-.89-4-1.93-12.15,0-15.25s7-8.13,15.38-12.05l.89-.42a35.32,35.32,0,0,1,3.82-1.45c.5-.17,1-.31,1.48-.44a25.59,25.59,0,0,1,3.73-.77l1.13-.12c.45,0,.85,0,1.24,0h.25l.45,0,.38.06a4.88,4.88,0,0,1,1.73.51l-2.55-1.47a5.05,5.05,0,0,0-2.08-.52,3.19,3.19,0,0,0-.45,0h-.25c-.38,0-.8,0-1.23,0s-.74.06-1.14.12a26.58,26.58,0,0,0-3.73.76c-.48.13-1,.28-1.48.45a35.32,35.32,0,0,0-3.82,1.45c-.3.14-.61.27-.89.42-8.36,3.92-13.53,9.06-15.39,12.05s-.87,11.28,0,15.24c0,.1.05.2.07.3s0,.19.07.3c.1.48.23,1,.38,1.58q.15.46.3,1l0,0a11.47,11.47,0,0,0,.59,1.53h0l.23.5.16.29c.06.11.12.22.19.33a4,4,0,0,0,.23.39,4.15,4.15,0,0,0,.3.43,3.37,3.37,0,0,0,.34.43,4.83,4.83,0,0,0,.37.42,6.28,6.28,0,0,0,1.37,1.08c.32.19,2.14,1.29,2.52,1.42a8.57,8.57,0,0,1-1.09-.81A2.23,2.23,0,0,1,149.19,335.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.37,281.54c3.19,1.85,3.19,4.83,0,6.68a12.77,12.77,0,0,1-11.55,0c-3.2-1.85-3.2-4.83,0-6.68A12.77,12.77,0,0,1,117.37,281.54Z",
    style: {
      fill: "#26A695"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,285.29c-2.78-2.83-4.41-9.92-1.7-12.16H118.6c2.71,2.24,1.08,9.32-1.7,12.16l-.07.08-.1.09-.25.22-.07.06-.21.15a1.92,1.92,0,0,1-.35.23,9.15,9.15,0,0,1-8.28,0h0a1.69,1.69,0,0,1-.36-.23l-.2-.15-.08-.06a1.7,1.7,0,0,1-.24-.22l-.11-.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,272.22c3.15,1.82,3.15,4.76,0,6.58a12.56,12.56,0,0,1-11.39,0c-3.15-1.82-3.15-4.76,0-6.58A12.56,12.56,0,0,1,117.4,272.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.17,273.51c1.92,1.1,1.92,2.9,0,4a7.63,7.63,0,0,1-6.93,0c-1.91-1.1-1.91-2.9,0-4A7.63,7.63,0,0,1,115.17,273.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24,275.41a7.63,7.63,0,0,1,6.93,0,3.2,3.2,0,0,1,1.15,1,3.3,3.3,0,0,1-1.15,1.05,7.63,7.63,0,0,1-6.93,0,3.3,3.3,0,0,1-1.15-1.05A3.2,3.2,0,0,1,108.24,275.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75,276.46a15.93,15.93,0,0,0,2.51-3.33c1.16-2.05,2.15-4.65,1.55-5s-3.81,2.25-3.81,2.25a15.15,15.15,0,0,0,.25-3.49c-.1-1.83-.54-3.48-1.07-3.82s-1.69,2-2.19,3.64-.7,2.7-.7,2.7-.44-1.92-1-3.5c-.61-1.73-1.16-2.12-1.58-1.95s-.71,1-.84,3.28a22.64,22.64,0,0,0,.1,3.3s-.86-.94-1.81-1.86-1.79-1-2.09-.81-.09,1.61,1.54,4.55a16.33,16.33,0,0,0,3.06,4S110.91,277.91,114.75,276.46Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.75,276.46a15.93,15.93,0,0,0,2.51-3.33c1.16-2.05,2.15-4.65,1.55-5s-3.81,2.25-3.81,2.25a15.15,15.15,0,0,0,.25-3.49c-.1-1.83-.54-3.48-1.07-3.82s-1.69,2-2.19,3.64-.7,2.7-.7,2.7-.44-1.92-1-3.5c-.61-1.73-1.16-2.12-1.58-1.95s-.71,1-.84,3.28a22.64,22.64,0,0,0,.1,3.3s-.86-.94-1.81-1.86-1.79-1-2.09-.81-.09,1.61,1.54,4.55a16.33,16.33,0,0,0,3.06,4S110.91,277.91,114.75,276.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M112,266.72c-.5,1.66-.7,2.7-.7,2.7h0l.3,1.44s.32-3.14.76-5.17C112.21,266,112.09,266.39,112,266.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,269.23a20.9,20.9,0,0,1-.44-4,17.07,17.07,0,0,0-.21,2,22.64,22.64,0,0,0,.1,3.3l2.22,2.32A20.16,20.16,0,0,1,108.52,269.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.6,271.76l1.4-1.37h0a15.15,15.15,0,0,0,.25-3.49,12.34,12.34,0,0,0-.28-2.07,9.66,9.66,0,0,1-.16,3.35A31.56,31.56,0,0,1,113.6,271.76Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154,252.33v-.19c-.17-4.41-5.93-8.54-10.81-9.36s-7.89,2.73-7.89,5h0c-.11,1.66,1.46,3.59,4.46,5.09,4.62,2.31,10.41,3,12.92,1.56a2.38,2.38,0,0,0,1.3-2.1Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.71,251.32v-.19c-.16-4.2-5.65-8.14-10.31-8.92s-7.52,2.6-7.52,4.76l0,0c-.11,1.58,1.39,3.41,4.25,4.85,4.41,2.2,9.92,2.87,12.32,1.48a2.22,2.22,0,0,0,1.23-2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,245.87a10.26,10.26,0,0,0-7.23,7.31l.47.14a9.76,9.76,0,0,1,7.19-7Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,252.92a6.49,6.49,0,0,0-4.32-6.13l-.17.47a5.94,5.94,0,0,1,4,6A2.82,2.82,0,0,0,153,252.92Z",
    style: {
      fill: "#26A695"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-32",
    d: "M152.19,242.11,165.86,250a1.63,1.63,0,0,0,1.49,0l39.23-22.62a.45.45,0,0,0,0-.86l-13.67-7.93a1.64,1.64,0,0,0-1.48,0l-39.24,22.62A.45.45,0,0,0,152.19,242.11Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205,225.39a.51.51,0,0,0-.31-.42l-12.23-7.06a1.63,1.63,0,0,0-1.46,0l-37.31,21.58a.52.52,0,0,0-.3.42v1.28a.49.49,0,0,0,.3.42l12.22,7.06a1.57,1.57,0,0,0,1.46,0l37.32-21.54a.56.56,0,0,0,.31-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9,247.36l-12.22-7a.44.44,0,0,1,0-.84L191,217.91a1.63,1.63,0,0,1,1.46,0L204.68,225a.44.44,0,0,1,0,.84l-37.32,21.55A1.63,1.63,0,0,1,165.9,247.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59,247.53v1.31a1.53,1.53,0,0,1-.69-.16l-12.22-7.06a.52.52,0,0,1-.3-.42v-1.29a.52.52,0,0,0,.3.42l12.22,7A1.41,1.41,0,0,0,166.59,247.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,219h0l1.21.7-1.64.94L190,220l1.64-.95Zm1.89,1.1h0l1.21.7-1.29.75-1.25-.71,1.28-.74Zm-4.19.23h0l1.21.7-1.29.75-1.25-.71,1.29-.74Zm6.08.86h0l1.21.69-2.08,1.21-1.25-.71,2.08-1.2Zm-3.83,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.19.23h0l1.21.7-1.29.75-1.25-.71,1.28-.74Zm2.51.74h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.41.1h0l1.21.7-1.65,1-1.25-.71,1.64-.94Zm-11.86.28h0l1.21.7-9.32,5.38-1.25-.7,9.31-5.38Zm7.23.2h0l1.21.69-1,.6-1.25-.71,1-.59Zm-4.45.38h0l1.21.7-1,.59-1.25-.7,1-.59Zm11,.23h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.19.23h0l1.21.7-1,.6-1.25-.71,1-.59Zm-4,.13h0l1.21.7-1,.59-1.26-.7,1-.59Zm-4.45.38h0l1.21.7-1,.59-1.25-.71,1-.59Zm11,.23h0l1.2.7-1,.59-1.25-.7,1-.59Zm-4.19.23h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4,.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm12.17,0h0l1.21.7-1.29.74-1.25-.7,1.29-.74Zm-16.63.38h0l1.21.7-1,.59-1.26-.7,1-.59Zm11,.23h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.19.23h0l1.21.7-1,.59-1.26-.7,1-.59Zm-4,.12h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.45.39h0l1.21.7-1,.59-1.25-.7,1-.59Zm15.63.19h0l1.21.7-1,.59-1.26-.7,1-.59Zm-4.66,0h0l1.21.7-1,.59-1.25-.71,1-.59Zm-4.18.23h0l1.21.7-1,.59-1.25-.7,1-.6Zm-4,.13h0l1.21.7-1,.59-1.26-.71,1-.59Zm-4.45.39h0l1.21.7-1,.59-1.25-.7,1-.59Zm15.64.19h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.66,0h0l1.22.69-1,.6-1.25-.71,1-.59Zm-4.19.23h0l1.21.69-1,.6-1.25-.71,1-.59Zm-4,.13h0l1.21.7-1,.6-1.25-.71,1-.59Zm-4.46.38h0l1.21.7-1,.59-1.25-.7,1-.6Zm15.64.19h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.66,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-15.34.11h0l1.22.7-1.29.74-1.26-.7,1.29-.74Zm11.15.12h0l1.21.7-1,.59-1.26-.7,1-.59Zm-4,.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.45.38s0,0,0,0l1.21.7-1,.59-1.25-.71,1-.59Zm15.63.19h0l1.21.7-1,.59-1.26-.71,1-.59Zm-4.66,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.18.23h0l1.21.7-1,.59-1.25-.7,1-.59Zm-11.42,0h0l1.21.7-1.28.74-1.26-.7,1.29-.74Zm7.4.1h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.45.38h0l1.21.7-1,.59-1.25-.7,1-.59Zm11,.22h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4.19.24h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4,.12h0l1.22.7-1,.59-1.25-.7,1-.6Zm12.13,0h0l1.22.69-1,.6-1.25-.71,1-.59Zm-19.8,0h0l1.21.7-1.29.75-1.25-.71,1.29-.74Zm3.21.33h0l1.21.7-1,.59-1.25-.7,1-.59Zm11,.22h0l1.21.7-1,.59-1.26-.71,1-.59Zm-4.19.23h0l1.21.7-1,.59-1.26-.71,1-.59Zm-4,.13h0l1.21.7-1,.59-1.25-.71,1-.59Zm12.13,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-20.07.18h0l1.21.7-1.64,1-1.25-.7,1.64-.95Zm3.49.17h0l1.22.7-3.24,1.86-1.25-.7,3.23-1.86Zm11,.23h0l1.21.7-1,.6-1.25-.71,1-.59Zm-4.19.23h0l1.21.69-1,.6-1.25-.71,1-.59Zm-4,.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm12.12,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-5.6.58h0l1.21.7-1,.59-1.25-.7,1-.59Zm-15.43.16h0l1.22.7-1,.59-1.25-.7,1-.59Zm11.24.07h0l1.21.7-1,.59-1.25-.7,1-.59Zm-4,.13h0l1.22.7-.94.54a.2.2,0,0,0-.11.17.2.2,0,0,0,.12.18l1.59.92-1.21.69-3.14-1.8,2.43-1.4Zm12.13,0h0l1.21.7-1,.59-1.25-.7,1-.59Zm-5.61.58h0l1.21.7-1,.59-1.26-.7,1-.59Zm-15.43.15h0l1.21.7-1,.59-1.25-.7,1-.59Zm11.24.08h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.39.57h0l1.21.7-1,.59-1.26-.7,1-.59Zm-4.87.16h0l1.21.7-1,.59-1.25-.7,1-.59Zm-15.44.16s0,0,0,0l1.21.7-1,.59-1.25-.71,1-.59Zm3.58.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm15.06.52h0l1.21.7-1,.59-1.25-.71,1-.59Zm-4.88.16h0l1.21.7-1.82,1.05-1.25-.71L177.4,236Zm-15.78.36h0l1.21.7-2.7,1.56-1.25-.71,2.7-1.56Zm11.06.18h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.92.27h0l1.21.69-1,.59-1.25-.7,1-.59Zm-17.09.65h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.5.05h0l1.21.7-1,.59-1.25-.7,1-.59Zm3.57.12h0l1.21.7-1,.59-1.25-.71,1-.59Zm4.34.15h0l1.21.7-1,.59-1.26-.7,1-.59Zm-20.66.52h0l1.21.7-1,.59-1.26-.7,1-.59Zm3.57.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.5,0h0l1.21.7-1,.59-1.25-.7,1-.6Zm-3.93.08h0l1.21.7-1,.59-1.25-.71,1-.59Zm7.5.05h0l1.21.7-1,.6-1.25-.71,1-.59Zm4,.36h0l1.21.7-1,.59-1.25-.7,1-.59Zm-20.29.31h0l3.11,1.8-1,.59-3.14-1.8,1-.59Zm3.57.12h0l1.21.7-1,.59-1.25-.7,1-.6Zm3.57.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.49.05h0l1.21.7-1,.59-1.25-.7,1-.59Zm-3.92.08h0l1.21.7-1,.59-1.25-.7,1-.59Zm7.9.28h0l1.21.7-1,.59-1.25-.7,1-.59Zm-13.15.56h0l1.21.7-1,.59-1.25-.7,1-.59Zm3.57.12h0l1.21.7-1,.59-1.26-.71,1-.59Zm3.57.13h0l1.21.7-1,.59-1.25-.7,1-.59Zm4.33.16h0l1.21.7-1,.59-1.26-.7,1-.59Zm-13.14.56h0l3.11,1.79-1,.59L159.36,242l1-.59Zm3.57.12h0l1.21.7-1,.59-1.25-.71,1-.59Zm3.57.13h0l1.22.7-1,.59-1.25-.7,1-.59Zm4.46.64h0l.52.3-1,.59-.56-.3,1-.59Zm-6.14.32h0l1.21.7-1,.59-1.25-.7,1-.59Zm4.46.65h0l.53.3-1,.59-.56-.3,1-.59Zm-6.13.32h0l1.21.7-1,.59-1.25-.71,1-.59Zm4.46.64h0l.52.3-1,.59-.57-.31,1-.58Zm-1.68,1h0l.52.29-1,.6-.56-.31,1-.59Z",
    style: {
      fill: "#26A695"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M243.11,213.48,241,212.27a2.67,2.67,0,0,0-2.46,0l-10.79,6.23-1.42-.83a2.39,2.39,0,0,0-2.18,0L211,225.25a.67.67,0,0,0,0,1.27l1.39.79-15.6,9a.76.76,0,0,0,0,1.44L199,239a2.75,2.75,0,0,0,2.47,0L217,230a2.42,2.42,0,0,0,2.19,0l13-7.59a.66.66,0,0,0,.05-1.24L243.09,215A.78.78,0,0,0,243.11,213.48Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12,202.34l2.76-32.8a2.78,2.78,0,0,0-1.22-2.46,3.12,3.12,0,0,0-2.82,0l-41.23,23.8a3.63,3.63,0,0,0-1.59,2.51l-2.76,32.81a2.81,2.81,0,0,0,1.22,2.46,3.15,3.15,0,0,0,2.82-.05l41.23-23.81A3.58,3.58,0,0,0,238.12,202.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12,202.34l2.76-32.8a2.78,2.78,0,0,0-1.22-2.46,3.12,3.12,0,0,0-2.82,0l-41.23,23.8a3.26,3.26,0,0,0-1.05,1.07l5.05,2.92-.31,31.43,37.23-21.5A3.58,3.58,0,0,0,238.12,202.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,227.82l2.77-32.8a3.52,3.52,0,0,1,1.59-2.51L239.06,169c.8-.46,1.14-.11,1.06.81l-2,32.56a3.58,3.58,0,0,1-1.59,2.51L195.3,228.66C194.5,229.12,193.91,228.75,194,227.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.41,198.94a5.62,5.62,0,0,1,2.38-4c1.18-.69,2.05,0,1.92,1.5a5.62,5.62,0,0,1-2.38,4C217.14,201.13,216.28,200.46,216.41,198.94Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.13 211.6 224.94 206.48 223.44 205.61 214.63 210.73 216.13 211.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,221.5l-10.73,6.2a1.32,1.32,0,0,1-.69.15,1.22,1.22,0,0,1-.58-.15h0L212.29,225l0,0a1.38,1.38,0,0,1-.61-1.09v-.25c0-.41.28-.58.64-.37l2.85,1.64.64.37-.14-.72-1-13.8,1.5.87,8.81-5.12,4.59,13.93A1.12,1.12,0,0,1,229,221.5Z",
    style: {
      fill: "#37474f"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "211.85 223.19 215.51 221.07 216.25 226 211.85 223.19"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.13,211.6l-1.5-.87,1,13.8c.08.39-.15.56-.5.35l-2.85-1.64c-.36-.21-.64,0-.64.37v.25a1.38,1.38,0,0,0,.61,1.09l0,0L217,227.7h0a1.22,1.22,0,0,0,.58.15Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Glasses--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Display--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 362.16 264.2 242.96 277.19 235.46 483.68 354.66 470.69 362.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 362.16 470.69 367.16 483.68 359.66 483.68 354.66 470.69 362.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.2 242.96 470.69 362.16 470.69 367.16 264.2 247.96 264.2 242.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.86 202.95 277.2 190.44 277.2 115.44 298.86 127.94 298.86 202.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.87 185.44 285.87 120.44 277.2 115.44 277.2 190.44 285.87 185.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 190.44 285.87 185.44 298.86 192.94 298.86 202.95 277.2 190.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.92,194.11l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,194.11l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,190.42a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.61l.46.27a.88.88,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,303.6,190.42Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,190.42a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.61l.46.27a.88.88,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,303.6,190.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,194.39l6.65-3.84a.86.86,0,0,1,.56-.13.76.76,0,0,1,.65.69l.05.27a.88.88,0,0,0,.42.61h0a.86.86,0,0,0,.44.12.88.88,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.12-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,191.65a1,1,0,0,0,.33.34l-.46-.27a.83.83,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,185.48l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11L281,184Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,185.48l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11L281,184Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,181.79a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.61l0-.27A.77.77,0,0,0,288.65,181.79Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,181.79a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.61l0-.27A.77.77,0,0,0,288.65,181.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.44,185.76l6.65-3.84a.86.86,0,0,1,.56-.13.77.77,0,0,1,.66.69l0,.27a.85.85,0,0,0,.43.61h0a.86.86,0,0,0,.44.12.88.88,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.12-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.44,183a.92.92,0,0,0,.34.34l-.47-.26a1.12,1.12,0,0,1-.28-.25l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.62,185.83s.3.08.44.83a28.18,28.18,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,4.42,4.42,0,0,0,.91.42l.07,0a2.39,2.39,0,0,0,.75.1h.26l.09,0,.07,0,.15-.07a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09.42.17.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,13.19,13.19,0,0,0,.52-2.32c.15-.58.45-.32.45-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,280.62,185.83Zm9.27,5.35a.62.62,0,0,1,.39-.14h.3l.18,0a4.62,4.62,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.24h0l0,.08,0,0s0,0,0,.05a.21.21,0,0,0,0,.06l-.05.07-.05.06-.06.07c-.33.34-.89.48-1.84-.06a4.73,4.73,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C289.71,192.41,289.63,191.46,289.89,191.18ZM281.83,186a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.05,0h0l.08,0,.32.12.18.08.1.05.08,0a1.19,1.19,0,0,1,.22.12l.09,0,.07.05c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0,0,0,0,0v0l0,0-.05.09-.06.08,0,0,0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.44,4.44,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C281.7,187.59,281.53,186.12,281.83,186Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.53,193.31h0l.46-.26a1.8,1.8,0,0,0,.63-.68,14.68,14.68,0,0,0,.5-1.56c-.65-.2-.57,1.13-1,1.83A1.65,1.65,0,0,1,286.53,193.31Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295,197.3a13.19,13.19,0,0,0,.52-2.32c.15-.58.45-.32.45-.32l.05,0s0,.05,0,.07a13.12,13.12,0,0,1-.53,2.33,1.48,1.48,0,0,1-.55.63l-.47.27A1.55,1.55,0,0,0,295,197.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296,193.18l.48-.27a3.63,3.63,0,0,1-.07,1.48l-.42.24-.05,0A3.54,3.54,0,0,0,296,193.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281,184c.26.1.55.23.86.37a18,18,0,0,1,4.26,2.59,25.71,25.71,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.33l.86.63-.48.27-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,185.83s.3.08.44.83a28.18,28.18,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,4.42,4.42,0,0,0,.91.42l.07,0a2.39,2.39,0,0,0,.75.1h.26l.09,0,.07,0,.15-.07h0a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09.42.17.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,13.19,13.19,0,0,0,.52-2.32c.15-.58.45-.32.45-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,280.62,185.83Zm9.27,5.35a.62.62,0,0,1,.39-.14h.3l.18,0a4.62,4.62,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.24h0l0,.08,0,0s0,0,0,.05a.21.21,0,0,0,0,.06l-.05.07-.05.06-.06.07c-.33.34-.89.48-1.84-.06a4.73,4.73,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C289.71,192.41,289.63,191.46,289.89,191.18ZM281.83,186a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.05,0h0l.08,0,.32.12.18.08.1.05.08,0a1.19,1.19,0,0,1,.22.12l.09,0,.07.05c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0,0,0,0,0v0l0,0-.05.09-.06.08,0,0,0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.44,4.44,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C281.7,187.59,281.53,186.12,281.83,186Z",
    style: {
      fill: "#37474f"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.85,193.27a5.59,5.59,0,0,0,.61,1.74h0a4.73,4.73,0,0,0,1.9,1.9c.95.54,1.51.4,1.84.06a1.88,1.88,0,0,1-1.36-.33,5,5,0,0,1-1.91-1.9h0a5.48,5.48,0,0,1-.6-1.75,4.48,4.48,0,0,1-.05-2,.62.62,0,0,0-.39.14C289.63,191.46,289.71,192.41,289.85,193.27Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M281.83,188.37a5.84,5.84,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.08.15a2.27,2.27,0,0,1-1.61-.42,4.89,4.89,0,0,1-1-.84,5.81,5.81,0,0,1-1.32-3,7.6,7.6,0,0,1-.12-2.14.7.7,0,0,0-.35,0C281.53,186.12,281.7,187.59,281.83,188.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,193.27a5.59,5.59,0,0,0,.61,1.74h0a4.73,4.73,0,0,0,1.9,1.9c.95.54,1.51.4,1.84.06l.06-.07.05-.06.05-.07a.21.21,0,0,1,0-.06s0,0,0-.05l0,0,0-.08h0l.09-.24h0s0-.1.05-.15l.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a4.92,4.92,0,0,0-.6-.23l-.23-.07a4.62,4.62,0,0,0-.58-.12l-.18,0h-.3a.62.62,0,0,0-.39.14C289.63,191.46,289.71,192.41,289.85,193.27Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,188.37a5.84,5.84,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.08.15h0l0,0,0,0,0,0,.06-.08.05-.09,0,0v0s0,0,0,0,0,0,0,0a2.3,2.3,0,0,0,.14-.45,3.83,3.83,0,0,0,0-2.13,8,8,0,0,0-2.28-2.33c-.23-.16-.44-.3-.64-.42l-.07-.05-.09,0a1.19,1.19,0,0,0-.22-.12l-.08,0-.1-.05-.18-.08-.32-.12-.08,0h0l-.05,0-.07,0-.1,0-.15,0h0a.7.7,0,0,0-.35,0C281.53,186.12,281.7,187.59,281.83,188.37Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,177.94l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 175.44 298.86 187.94 298.86 189.55 277.2 177.05 277.2 175.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.42,177a.39.39,0,0,0,.21-.06l7.59-4.38a1.78,1.78,0,0,1,2.67,1.54v.19a.43.43,0,0,0,.85,0v-.19a2.63,2.63,0,0,0-3.94-2.28l-7.59,4.38a.43.43,0,0,0-.16.59A.44.44,0,0,0,294.42,177Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.29,169.39a.39.39,0,0,0,.21-.06l7.59-4.38a1.78,1.78,0,0,1,2.67,1.54v.19a.43.43,0,0,0,.85,0v-.19a2.63,2.63,0,0,0-3.94-2.28l-7.59,4.38a.43.43,0,0,0-.16.59A.44.44,0,0,0,281.29,169.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.89,168.11a13.37,13.37,0,0,0,.19,3.88c.41,2.41,1.75,4.78,3.43,5.75a2.24,2.24,0,0,0,1.47.35l0,.11.51-.3h0a2.69,2.69,0,0,0,1.05-2.46s.21-.76.68-.49.69,1.28.69,1.28a7.3,7.3,0,0,0,3,5.82,2.45,2.45,0,0,0,1.74.37l0,.1.53-.3h0a2.86,2.86,0,0,0,1.2-2c.24-1.1.46-3.28,0-4.29-.28-.61-2.54-1.94-3.44-2.32a2.27,2.27,0,0,0-2-.06h0l-.51.3.12,0a2.45,2.45,0,0,0-.52,1.06h0a2.7,2.7,0,0,0-.82-.93.77.77,0,0,0-.82,0h0a7.55,7.55,0,0,0-2.91-4.68c-.87-.65-3.05-1.88-3.41-1.67h0l-.49.28Zm8.73,8.52c0-1.74,1.05-2.53,2.35-1.78a5.63,5.63,0,0,1,2.36,4.49c0,1.74-1.06,2.53-2.36,1.78A5.62,5.62,0,0,1,289.62,176.63Zm-7.46-4.31c0-1.73,1-2.53,2.35-1.78a5.65,5.65,0,0,1,2.36,4.5c0,1.73-1.06,2.53-2.36,1.78A5.64,5.64,0,0,1,282.16,172.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61,168c.36-.2,2.53,1,3.41,1.67a7.2,7.2,0,0,1,1,.9l.5-.28a7.22,7.22,0,0,0-1-.9c-.87-.65-3.06-1.88-3.41-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.46,173.89h0a2.21,2.21,0,0,1,2,.05c.89.37,3.16,1.71,3.44,2.32l.49-.29c-.28-.61-2.54-1.94-3.44-2.32a2.27,2.27,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,174.27a.8.8,0,0,1,.76.06,1.21,1.21,0,0,1,.26.2l.49-.29a1.28,1.28,0,0,0-.26-.2.77.77,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,174.53a3.5,3.5,0,0,1,.56.72h0a2.59,2.59,0,0,1,.25-.66,2.6,2.6,0,0,0-.32-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,182.5l.48-.28h0a2.86,2.86,0,0,0,1.2-2c.24-1.1.46-3.28,0-4.29l-.49.29c.46,1,.23,3.19,0,4.29A2.91,2.91,0,0,1,293.74,182.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.05,178.16l.46-.26a2.69,2.69,0,0,0,1.05-2.46,1,1,0,0,1,.1-.24c-.41-.14-.59.53-.59.53A2.7,2.7,0,0,1,286.05,178.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,170.53a7.75,7.75,0,0,1,1.91,3.78h0l0,0,.43-.25a7.65,7.65,0,0,0-1.9-3.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.58,172.27c.41,2.41,1.76,4.79,3.44,5.76s3.05-.06,3.05-2.31c0,0,.21-.75.68-.48s.68,1.27.68,1.27a7.29,7.29,0,0,0,3.05,5.82c1.68,1,3,.15,3.44-1.78.23-1.1.46-3.28,0-4.29-.28-.61-2.55-1.95-3.44-2.32-1.3-.54-2.19-.24-2.66.65a2.59,2.59,0,0,0-.25.66h0a2.71,2.71,0,0,0-.82-.92.77.77,0,0,0-.82,0h0a7.66,7.66,0,0,0-2.91-4.68c-.9-.66-3.16-1.94-3.44-1.65C280.12,168.46,280.35,170.9,280.58,172.27Zm8.54,4.64c0-1.73,1.06-2.53,2.36-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.64,5.64,0,0,1,289.12,176.91Zm-7.45-4.3c0-1.74,1.05-2.53,2.35-1.78a5.62,5.62,0,0,1,2.35,4.49c0,1.74-1.05,2.53-2.35,1.78A5.62,5.62,0,0,1,281.67,172.61Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,176.71a.69.69,0,0,0-.29-.55c-.16-.09-.29,0-.29.22a.67.67,0,0,0,.29.54C294.58,177,294.71,176.92,294.71,176.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,168.8c0-.21.13-.31.29-.22a.69.69,0,0,1,.29.55c0,.21-.13.3-.29.21A.67.67,0,0,1,281,168.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.12,176.91a5.64,5.64,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77,0,1.65,1.65,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C289.55,175.09,289.12,175.81,289.12,176.91Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67,172.61A5.62,5.62,0,0,0,284,177.1a1.41,1.41,0,0,0,1.77,0,1.61,1.61,0,0,1-1.27-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C282.09,170.78,281.67,171.5,281.67,172.61Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.12,176.91a5.64,5.64,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77,0,1.65,1.65,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C289.55,175.09,289.12,175.81,289.12,176.91Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.67,172.61A5.62,5.62,0,0,0,284,177.1a1.41,1.41,0,0,0,1.77,0,1.61,1.61,0,0,1-1.27-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C282.09,170.78,281.67,171.5,281.67,172.61Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.48,181.41c1.3.75,2.35,0,2.35-1.78a5.64,5.64,0,0,0-2.35-4.5c-1.3-.75-2.36.05-2.36,1.78A5.64,5.64,0,0,0,291.48,181.41Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,177.1c1.3.75,2.35,0,2.35-1.78a5.62,5.62,0,0,0-2.35-4.49c-1.3-.75-2.35,0-2.35,1.78A5.62,5.62,0,0,0,284,177.1Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,161.34l-13-7.51-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 158.83 298.86 171.34 298.86 172.94 277.2 160.44 277.2 158.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.92,162.64l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,162.64l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,159a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1.12,1.12,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,303.6,159Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,159a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1.12,1.12,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,303.6,159Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,162.92l6.65-3.84a.92.92,0,0,1,.56-.13.77.77,0,0,1,.65.7l.05.27a.86.86,0,0,0,.42.6h0a.86.86,0,0,0,.44.12.88.88,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.12-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,160.18a1,1,0,0,0,.33.34l-.46-.26A1.12,1.12,0,0,1,304,160l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,154l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,154l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,150.32a.9.9,0,0,1,.18.42l.05.27a1.11,1.11,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.26a.85.85,0,0,1-.43-.6l0-.27A.78.78,0,0,0,288.65,150.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,150.32a.9.9,0,0,1,.18.42l.05.27a1.11,1.11,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.26a.85.85,0,0,1-.43-.6l0-.27A.78.78,0,0,0,288.65,150.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.44,154.29l6.65-3.84a.92.92,0,0,1,.56-.13.78.78,0,0,1,.66.7l0,.27a.85.85,0,0,0,.43.6v0a1,1,0,0,0,.44.11.88.88,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.12-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.44,151.55a.86.86,0,0,0,.34.34l-.47-.26a1,1,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.62,154.36s.3.08.44.83a27.72,27.72,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,5.14,5.14,0,0,0,.91.43l.07,0a1.92,1.92,0,0,0,.75.1h.19l.07,0,.09,0a.11.11,0,0,0,.07,0l.15-.07a1.68,1.68,0,0,0,.61-.66c.41-.71.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.82,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.13,0,.13,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,13,13,0,0,0,.52-2.32c.15-.58.45-.32.45-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.84-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.93,18.93,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,280.62,154.36Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.07a6,6,0,0,1,2.4,1.87,4.37,4.37,0,0,1,0,2.38v.1q0,.1-.06.24c0,.05,0,.1-.05.15h0l-.09.23h0a.25.25,0,0,0,0,.07l0,.05s0,0,0,.05a.21.21,0,0,0,0,.06.18.18,0,0,1-.05.07l-.05.07-.06.06c-.33.35-.89.48-1.84-.05a4.81,4.81,0,0,1-1.9-1.91h0a5.5,5.5,0,0,1-.61-1.74C289.71,160.94,289.63,160,289.89,159.71Zm-8.06-5.19a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.05,0h0l.08,0,.32.12.18.08.1.05.08,0,.22.12.09.05.07,0c.2.12.41.26.64.42a8.15,8.15,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0,0,0,0,0v0l0,0-.05.09-.06.08,0,0,0,0s0,0,0,0h0c-.35.37-1,.5-2.08-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C281.7,156.12,281.53,154.66,281.83,154.52Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M286.53,161.84h0l.46-.26a1.73,1.73,0,0,0,.63-.68,15.31,15.31,0,0,0,.5-1.55c-.65-.21-.57,1.12-1,1.83A1.68,1.68,0,0,1,286.53,161.84Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295,165.83a13,13,0,0,0,.52-2.32c.15-.58.45-.32.45-.32l.05,0s0,.05,0,.07a13.12,13.12,0,0,1-.53,2.33,1.48,1.48,0,0,1-.55.63l-.47.27A1.55,1.55,0,0,0,295,165.83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M296,161.71l.48-.27a3.63,3.63,0,0,1-.07,1.48l-.42.24-.05,0A3.54,3.54,0,0,0,296,161.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281,152.53c.26.1.55.23.86.37a18.3,18.3,0,0,1,4.26,2.59,24.56,24.56,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.34c.31.21.6.43.86.62l-.48.27-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.84-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.93,18.93,0,0,0-4.27-2.59l-.85-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,154.36s.3.08.44.83a27.72,27.72,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,5.14,5.14,0,0,0,.91.43l.07,0a1.92,1.92,0,0,0,.75.1h.19l.07,0,.09,0a.11.11,0,0,0,.07,0l.15-.07h0a1.68,1.68,0,0,0,.61-.66c.41-.71.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.82,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.13,0,.13,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.69,1.69,0,0,0,.27-.11h0a1.55,1.55,0,0,0,.55-.63,13,13,0,0,0,.52-2.32c.15-.58.45-.32.45-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.84-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.93,18.93,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,280.62,154.36Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.07a6,6,0,0,1,2.4,1.87,4.37,4.37,0,0,1,0,2.38v.1q0,.1-.06.24c0,.05,0,.1-.05.15h0l-.09.23h0a.25.25,0,0,0,0,.07l0,.05s0,0,0,.05a.21.21,0,0,0,0,.06.18.18,0,0,1-.05.07l-.05.07-.06.06c-.33.35-.89.48-1.84-.05a4.81,4.81,0,0,1-1.9-1.91h0a5.5,5.5,0,0,1-.61-1.74C289.71,160.94,289.63,160,289.89,159.71Zm-8.06-5.19a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.05,0h0l.08,0,.32.12.18.08.1.05.08,0,.22.12.09.05.07,0c.2.12.41.26.64.42a8.15,8.15,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0,0,0,0,0v0l0,0-.05.09-.06.08,0,0,0,0s0,0,0,0h0c-.35.37-1,.5-2.08-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C281.7,156.12,281.53,154.66,281.83,154.52Z",
    style: {
      fill: "#37474f"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.85,161.8a5.5,5.5,0,0,0,.61,1.74h0a4.81,4.81,0,0,0,1.9,1.91c.95.53,1.51.4,1.84.05a1.88,1.88,0,0,1-1.36-.33,5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.48,4.48,0,0,1-.05-1.95.62.62,0,0,0-.39.13C289.63,160,289.71,160.94,289.85,161.8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.83,156.9a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.65,1.73.52,2.08.15a2.27,2.27,0,0,1-1.61-.42,4.89,4.89,0,0,1-1-.84,5.77,5.77,0,0,1-1.32-3,7.59,7.59,0,0,1-.12-2.14.7.7,0,0,0-.35,0C281.53,154.66,281.7,156.12,281.83,156.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,161.8a5.5,5.5,0,0,0,.61,1.74h0a4.81,4.81,0,0,0,1.9,1.91c.95.53,1.51.4,1.84.05l.06-.06.05-.07a.18.18,0,0,0,.05-.07.21.21,0,0,1,0-.06s0,0,0-.05l0-.05a.25.25,0,0,1,0-.07h0l.09-.23h0s0-.1.05-.15,0-.17.06-.24v-.1a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.87l-.14-.07a4.92,4.92,0,0,0-.6-.23l-.23-.07-.58-.12h-.48a.62.62,0,0,0-.39.13C289.63,160,289.71,160.94,289.85,161.8Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,156.9a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.65,1.73.52,2.08.15h0s0,0,0,0l0,0,0,0,.06-.08.05-.09,0,0v0s0,0,0,0,0,0,0,0a2.3,2.3,0,0,0,.14-.45,3.83,3.83,0,0,0,0-2.13,8.15,8.15,0,0,0-2.28-2.33c-.23-.16-.44-.3-.64-.42l-.07,0-.09-.05-.22-.12-.08,0-.1-.05-.18-.08-.32-.12-.08,0h0l-.05,0-.07,0-.1,0-.15,0h0a.7.7,0,0,0-.35,0C281.53,154.66,281.7,156.12,281.83,156.9Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,146.34l-13-7.51-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 143.83 298.86 156.34 298.86 157.94 277.2 145.44 277.2 143.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.08,138.71l7.12-4.1a2.38,2.38,0,0,1,2.39,0,2.35,2.35,0,0,1,1.19,2.07v.25a.34.34,0,0,1-.68,0v-.25a1.7,1.7,0,0,0-.85-1.48,1.67,1.67,0,0,0-1.7,0l-7.13,4.11a.33.33,0,0,1-.17,0,.32.32,0,0,1-.29-.17A.34.34,0,0,1,281.08,138.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,142.11a1.15,1.15,0,0,1,.55-.12,4.26,4.26,0,0,1,2.14.77,6.1,6.1,0,0,1,3.17,4.82c.16,2.16-.36,3.54-1,3.93l.44-.25c.64-.36,1.17-1.76,1-3.95a6.11,6.11,0,0,0-3.16-4.82,4.42,4.42,0,0,0-2.14-.77,1.21,1.21,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.3,145.39l.46-.27a5.61,5.61,0,0,1,.6,2.19c.16,2.19-.37,3.59-1,3.95l-.44.25c.63-.39,1.15-1.77,1-3.93A5.56,5.56,0,0,0,294.3,145.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,142.11a1.15,1.15,0,0,1,.55-.12,4.26,4.26,0,0,1,2.14.77,6.84,6.84,0,0,1,2.57,2.63l.46-.27a6.9,6.9,0,0,0-2.56-2.63,4.42,4.42,0,0,0-2.14-.77,1.21,1.21,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,137.72a1.15,1.15,0,0,1,.66-.18,4.18,4.18,0,0,1,1.79.58,6.44,6.44,0,0,1,3,3,4.1,4.1,0,0,1-1.22,4,.66.66,0,0,1-.17.12l.4-.23h0l.22-.14a4.11,4.11,0,0,0,1.21-4,6.55,6.55,0,0,0-3-3,4.19,4.19,0,0,0-1.8-.57,1.28,1.28,0,0,0-.65.16l-.44.26Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,141.16a2.3,2.3,0,0,0-.16-.37l.47-.27a3.59,3.59,0,0,1,.15.37,4.11,4.11,0,0,1-1.21,4l-.22.14h0l-.4.23a.66.66,0,0,0,.17-.12A4.1,4.1,0,0,0,286.67,141.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,143.69a.11.11,0,0,0,.1-.06.11.11,0,0,0,0-.15l-.17-.1v-.12a.74.74,0,0,0-.32-.6l-.86-.5a.28.28,0,0,0-.29,0,.33.33,0,0,0-.15.29l-.06,0a.11.11,0,0,0-.15,0,.12.12,0,0,0,0,.16l.4.23v-.38c0-.08,0-.11,0-.12a.08.08,0,0,1,.06,0l.86.5a.49.49,0,0,1,.21.4v.25l.29.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,144.39a12.28,12.28,0,0,0,1.14,3.15,9.13,9.13,0,0,0,2.62,3.25.59.59,0,0,0,.82-.17.68.68,0,0,1-.36-.1,9.24,9.24,0,0,1-2.62-3.25,11.65,11.65,0,0,1-1.13-3.15,5.24,5.24,0,0,1-.13-1.55h-.1c-.21,0-.3.05-.31.07A3.7,3.7,0,0,0,289.35,144.39Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.35,144.39a12.28,12.28,0,0,0,1.14,3.15,9.13,9.13,0,0,0,2.62,3.25.59.59,0,0,0,.82-.17.68.68,0,0,1-.36-.1,9.24,9.24,0,0,1-2.62-3.25,11.65,11.65,0,0,1-1.13-3.15,5.24,5.24,0,0,1-.13-1.55h-.1c-.21,0-.3.05-.31.07A3.7,3.7,0,0,0,289.35,144.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,144.2a2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.78.15,2.21,2.21,0,0,1-1.81-.92,8.86,8.86,0,0,1-1-4.87,2,2,0,0,1,.26-.95c-.25,0-.64.13-.72,1.21A8.73,8.73,0,0,0,282.1,144.2Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.1,144.2a2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.78.15,2.21,2.21,0,0,1-1.81-.92,8.86,8.86,0,0,1-1-4.87,2,2,0,0,1,.26-.95c-.25,0-.64.13-.72,1.21A8.73,8.73,0,0,0,282.1,144.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,142.56a3.88,3.88,0,0,1,1.84.68,5.49,5.49,0,0,1,2.9,4.38,5.91,5.91,0,0,1-.37,2.93.58.58,0,0,1-.85.24,9.13,9.13,0,0,1-2.62-3.25,11.89,11.89,0,0,1-1.13-3.15,3.43,3.43,0,0,1-.08-1.75s.1-.08.31-.08Zm0-.57a.85.85,0,0,0-.82.38c-.35.68,0,3.19,1.21,5.44s2.87,3.78,3.65,3.78a.38.38,0,0,0,.19,0c.67-.3,1.24-1.71,1.08-4a6.1,6.1,0,0,0-3.17-4.82,4.26,4.26,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,138.11a3.64,3.64,0,0,1,1.53.52,5.94,5.94,0,0,1,2.69,2.71,3.55,3.55,0,0,1-1,3.39,2,2,0,0,1-1.21.4,2.19,2.19,0,0,1-1.81-.93,8.73,8.73,0,0,1-1-4.87c.09-1.22.57-1.22.8-1.22Zm0-.57c-.71,0-1.27.44-1.37,1.75a9.4,9.4,0,0,0,1.08,5.22,2.73,2.73,0,0,0,2.29,1.19,2.54,2.54,0,0,0,1.54-.51,4.1,4.1,0,0,0,1.22-4,6.44,6.44,0,0,0-3-3,4.18,4.18,0,0,0-1.79-.58Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,137.54a1.15,1.15,0,0,0-.66.18l0,0,.44-.26a1.28,1.28,0,0,1,.65-.16,4.19,4.19,0,0,1,1.8.57,7.14,7.14,0,0,1,2.81,2.67l-.47.27a6.94,6.94,0,0,0-2.81-2.67A4.18,4.18,0,0,0,281.91,137.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,146.71l7.12-4.1a2.39,2.39,0,0,1,3.58,2.06v.26a.34.34,0,0,1-.68,0v-.26a1.69,1.69,0,0,0-.85-1.47,1.67,1.67,0,0,0-1.7,0l-7.13,4.1a.34.34,0,0,1-.17,0,.34.34,0,0,1-.29-.17A.34.34,0,0,1,295,146.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,138.11h0c-.23,0-.71,0-.8,1.22a8.73,8.73,0,0,0,1,4.87,2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4,3.55,3.55,0,0,0,1-3.39,5.94,5.94,0,0,0-2.69-2.71,3.64,3.64,0,0,0-1.53-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.59,142.56c-.21,0-.3.05-.31.08a3.43,3.43,0,0,0,.08,1.75,11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.62,3.25.58.58,0,0,0,.85-.24,5.91,5.91,0,0,0,.37-2.93,5.49,5.49,0,0,0-2.9-4.38,3.88,3.88,0,0,0-1.84-.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,142.8a.11.11,0,0,0,.09-.06.1.1,0,0,0,0-.15,72.26,72.26,0,0,0-8-4.65.13.13,0,0,0-.16.05.13.13,0,0,0,.06.16,71.69,71.69,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,131.33l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 128.83 298.86 141.33 298.86 142.94 277.2 130.44 277.2 128.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.92,132.33l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,132.33l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,128.63a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36.83.83,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,303.6,128.63Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,128.63a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36.83.83,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,303.6,128.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.39,132.6l6.65-3.83a.87.87,0,0,1,.56-.14.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a1,1,0,0,0,.44.12.88.88,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.12-.72a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,129.86a.93.93,0,0,0,.33.35l-.46-.27a.83.83,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,123.7l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,123.7l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,120a.93.93,0,0,1,.18.43l.05.27a1.05,1.05,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,288.65,120Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,120a.93.93,0,0,1,.18.43l.05.27a1.05,1.05,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,288.65,120Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.44,124l6.65-3.83a.87.87,0,0,1,.56-.14.79.79,0,0,1,.66.7l0,.27a.89.89,0,0,0,.43.61h0a1,1,0,0,0,.44.12.88.88,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.12-.72a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.44,121.23a.88.88,0,0,0,.34.35l-.47-.27a.83.83,0,0,1-.28-.25L289,121Z",
    style: {
      opacity: 0.15
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.62,124.05s.3.08.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,5,5,0,0,0,.91.42l.07,0a2.16,2.16,0,0,0,.75.11h.19l.07,0,.09,0,.07,0,.15-.07a1.71,1.71,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.13,0,.13,0,.08,0a2,2,0,0,0,.48,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.55,1.55,0,0,0,.55-.63,13.1,13.1,0,0,0,.52-2.33c.15-.57.45-.31.45-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37A3.71,3.71,0,0,0,280.62,124.05Zm9.27,5.35a.56.56,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a5.87,5.87,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25s0,.1-.05.15h0l-.09.24h0a.3.3,0,0,0,0,.08l0,0a.08.08,0,0,1,0,0l0,.07-.05.06a.18.18,0,0,1-.05.07l-.06.07c-.33.34-.89.48-1.84-.06a4.85,4.85,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C289.71,130.62,289.63,129.68,289.89,129.4Zm-8.06-5.2a.72.72,0,0,1,.35,0h0l.15,0,.1,0,.07,0h.07l.08,0,.32.12.18.08.1,0,.08,0,.22.12.09,0,.07,0a7.41,7.41,0,0,1,.64.41,8,8,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2,2,0,0,1-.14.44s0,0,0,0l0,.05v0l0,.05-.05.1-.06.08,0,0,0,0s0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.71,4.71,0,0,1-1-.84,5.86,5.86,0,0,1-1.31-3C281.7,125.81,281.53,124.34,281.83,124.2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M286.53,131.53h0l.46-.27a1.77,1.77,0,0,0,.63-.67,14.68,14.68,0,0,0,.5-1.56c-.65-.21-.57,1.13-1,1.83A1.71,1.71,0,0,1,286.53,131.53Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M295,135.52a13.1,13.1,0,0,0,.52-2.33c.15-.57.45-.31.45-.31l.05,0a.64.64,0,0,0,0,.07,13.32,13.32,0,0,1-.53,2.33,1.54,1.54,0,0,1-.55.63l-.47.27A1.55,1.55,0,0,0,295,135.52Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M296,131.4l.48-.28a3.63,3.63,0,0,1-.07,1.48l-.42.25-.05,0A3.54,3.54,0,0,0,296,131.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281,122.22c.26.1.55.22.86.36a18.64,18.64,0,0,1,4.26,2.59,23.51,23.51,0,0,0,2.6,2.44c.75.44,1.23.21,2.59.56a17,17,0,0,1,4.26,2.33l.86.62-.48.28c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,124.05s.3.08.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,5,5,0,0,0,.91.42l.07,0a2.16,2.16,0,0,0,.75.11h.19l.07,0,.09,0,.07,0,.15-.07h0a1.71,1.71,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.13,0,.13,0,.08,0a2,2,0,0,0,.48,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.55,1.55,0,0,0,.55-.63,13.1,13.1,0,0,0,.52-2.33c.15-.57.45-.31.45-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37A3.71,3.71,0,0,0,280.62,124.05Zm9.27,5.35a.56.56,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a5.87,5.87,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25s0,.1-.05.15h0l-.09.24h0a.3.3,0,0,0,0,.08l0,0a.08.08,0,0,1,0,0l0,.07-.05.06a.18.18,0,0,1-.05.07l-.06.07c-.33.34-.89.48-1.84-.06a4.85,4.85,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C289.71,130.62,289.63,129.68,289.89,129.4Zm-8.06-5.2a.72.72,0,0,1,.35,0h0l.15,0,.1,0,.07,0h.07l.08,0,.32.12.18.08.1,0,.08,0,.22.12.09,0,.07,0a7.41,7.41,0,0,1,.64.41,8,8,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2,2,0,0,1-.14.44s0,0,0,0l0,.05v0l0,.05-.05.1-.06.08,0,0,0,0s0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.71,4.71,0,0,1-1-.84,5.86,5.86,0,0,1-1.31-3C281.7,125.81,281.53,124.34,281.83,124.2Z",
    style: {
      fill: "#37474f"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M289.85,131.49a5.59,5.59,0,0,0,.61,1.74h0a4.85,4.85,0,0,0,1.9,1.9c.95.54,1.51.4,1.84.06a2,2,0,0,1-1.36-.33,4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74,4.48,4.48,0,0,1-.05-2,.56.56,0,0,0-.39.14C289.63,129.68,289.71,130.62,289.85,131.49Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M281.83,126.58a5.86,5.86,0,0,0,1.31,3,4.71,4.71,0,0,0,1,.84c1.1.65,1.73.51,2.08.15a2.24,2.24,0,0,1-1.61-.43,4.34,4.34,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3,7.62,7.62,0,0,1-.12-2.14.72.72,0,0,0-.35,0C281.53,124.34,281.7,125.81,281.83,126.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,131.49a5.59,5.59,0,0,0,.61,1.74h0a4.85,4.85,0,0,0,1.9,1.9c.95.54,1.51.4,1.84.06l.06-.07a.18.18,0,0,0,.05-.07l.05-.06,0-.07a.08.08,0,0,0,0,0l0,0a.3.3,0,0,1,0-.08h0l.09-.24h0s0-.11.05-.15l.06-.25V134a4.37,4.37,0,0,0,0-2.38,5.87,5.87,0,0,0-2.4-1.88l-.14-.06a4.92,4.92,0,0,0-.6-.23l-.23-.07a3.33,3.33,0,0,0-.58-.12l-.18,0h-.3a.56.56,0,0,0-.39.14C289.63,129.68,289.71,130.62,289.85,131.49Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,126.58a5.86,5.86,0,0,0,1.31,3,4.71,4.71,0,0,0,1,.84c1.1.65,1.73.51,2.08.15h0s0,0,0,0l0,0,0,0,.06-.08.05-.1,0-.05v0l0-.05s0,0,0,0a2,2,0,0,0,.14-.44,3.83,3.83,0,0,0,0-2.13,8,8,0,0,0-2.28-2.34,7.41,7.41,0,0,0-.64-.41l-.07,0-.09,0-.22-.12-.08,0-.1,0-.18-.08-.32-.12-.08,0h-.07l-.07,0-.1,0-.15,0h0a.72.72,0,0,0-.35,0C281.53,124.34,281.7,125.81,281.83,126.58Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "324.84 202.94 303.19 190.44 303.18 115.43 324.84 127.94 324.84 202.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.85 185.44 311.85 120.44 303.18 115.43 303.19 190.44 311.85 185.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.19 190.44 311.85 185.44 324.84 192.94 324.84 202.94 303.19 190.44",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.9,194.11l.5-.29,0-.91,5.89-3.41a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,194.11l.5-.29,0-.91,5.89-3.41a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,190.41a1,1,0,0,1,.18.43l.05.27a.86.86,0,0,0,.43.61l.46.27a.88.88,0,0,1-.42-.61l0-.27A.78.78,0,0,0,329.58,190.41Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,190.41a1,1,0,0,1,.18.43l.05.27a.86.86,0,0,0,.43.61l.46.27a.88.88,0,0,1-.42-.61l0-.27A.78.78,0,0,0,329.58,190.41Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,194.39l6.65-3.84a.87.87,0,0,1,.56-.14.78.78,0,0,1,.65.7l0,.27a.88.88,0,0,0,.42.61h0a.86.86,0,0,0,.44.12.88.88,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.12-.71a2.29,2.29,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.41,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.37,191.65a1,1,0,0,0,.33.34l-.46-.27a.83.83,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,185.48l.5-.29,0-.91,5.89-3.41a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.18,2.18,0,0,0-2.25.11L307,184Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,185.48l.5-.29,0-.91,5.89-3.41a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.18,2.18,0,0,0-2.25.11L307,184Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,181.78a1,1,0,0,1,.18.43l.05.27a1,1,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.87.87,0,0,1-.43-.61l0-.27A.79.79,0,0,0,314.63,181.78Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,181.78a1,1,0,0,1,.18.43l.05.27a1,1,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.87.87,0,0,1-.43-.61l0-.27A.79.79,0,0,0,314.63,181.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,185.76l6.64-3.84a.87.87,0,0,1,.56-.14.79.79,0,0,1,.66.7l0,.27a.87.87,0,0,0,.43.61h0a.87.87,0,0,0,.88,0,.25.25,0,0,0,.12-.26l-.12-.71a2.29,2.29,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.41,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,183a.92.92,0,0,0,.34.34l-.47-.27a.83.83,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.6,185.83s.3.08.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,4.42,4.42,0,0,0,.91.42l.07,0a2.39,2.39,0,0,0,.75.1h.26l.09,0,.07,0,.15-.07a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09.42.17.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.19-.54-.41-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37A3.72,3.72,0,0,0,306.6,185.83Zm9.27,5.35a.64.64,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.24h0a.59.59,0,0,0,0,.08l0,0,0,.05,0,.06,0,.07-.05.06-.06.07c-.33.34-.89.48-1.84-.06a4.79,4.79,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C315.69,192.41,315.61,191.46,315.87,191.18ZM307.81,186a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.06,0h0l.08,0,.32.12.18.07.1.06.08,0a1.19,1.19,0,0,1,.22.12l.09,0,.07.05c.2.12.41.25.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2,2,0,0,1-.14.44v0l0,0v0l0,0,0,.1-.06.08,0,0,0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.44,4.44,0,0,1-1-.84,5.83,5.83,0,0,1-1.31-3C307.68,187.59,307.51,186.12,307.81,186Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.51,193.31h0l.46-.26a1.87,1.87,0,0,0,.63-.68,14.68,14.68,0,0,0,.5-1.56c-.65-.2-.57,1.13-1,1.83A1.65,1.65,0,0,1,312.51,193.31Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93,197.3a14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31l.05,0s0,.05,0,.07a13.12,13.12,0,0,1-.53,2.33,1.48,1.48,0,0,1-.55.63l-.47.27A1.55,1.55,0,0,0,320.93,197.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M322,193.18l.48-.27a3.63,3.63,0,0,1-.07,1.48l-.42.24-.05,0A3.54,3.54,0,0,0,322,193.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,184c.26.1.55.22.86.37a18,18,0,0,1,4.26,2.59,25.71,25.71,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.33l.86.63-.48.27c-.25-.19-.54-.41-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,185.83s.3.08.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,4.42,4.42,0,0,0,.91.42l.07,0a2.39,2.39,0,0,0,.75.1h.26l.09,0,.07,0,.15-.07h0a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09.42.17.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.19-.54-.41-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.37A3.72,3.72,0,0,0,306.6,185.83Zm9.27,5.35a.64.64,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.24h0a.59.59,0,0,0,0,.08l0,0,0,.05,0,.06,0,.07-.05.06-.06.07c-.33.34-.89.48-1.84-.06a4.79,4.79,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74C315.69,192.41,315.61,191.46,315.87,191.18ZM307.81,186a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.06,0h0l.08,0,.32.12.18.07.1.06.08,0a1.19,1.19,0,0,1,.22.12l.09,0,.07.05c.2.12.41.25.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2,2,0,0,1-.14.44v0l0,0v0l0,0,0,.1-.06.08,0,0,0,0,0,0h0c-.35.36-1,.5-2.08-.15a4.44,4.44,0,0,1-1-.84,5.83,5.83,0,0,1-1.31-3C307.68,187.59,307.51,186.12,307.81,186Z",
    style: {
      fill: "#37474f"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,193.27a5.59,5.59,0,0,0,.61,1.74h0a4.79,4.79,0,0,0,1.9,1.9c1,.54,1.51.4,1.84.06a1.88,1.88,0,0,1-1.36-.33,5,5,0,0,1-1.91-1.9h0a5.48,5.48,0,0,1-.6-1.75,4.48,4.48,0,0,1-.05-2,.64.64,0,0,0-.39.14C315.61,191.46,315.69,192.41,315.83,193.27Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M307.81,188.36a5.83,5.83,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.08.15a2.24,2.24,0,0,1-1.61-.43,4.34,4.34,0,0,1-1-.84,5.63,5.63,0,0,1-1.31-3,7.29,7.29,0,0,1-.13-2.14.7.7,0,0,0-.35,0C307.51,186.12,307.68,187.59,307.81,188.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.83,193.27a5.59,5.59,0,0,0,.61,1.74h0a4.79,4.79,0,0,0,1.9,1.9c1,.54,1.51.4,1.84.06l.06-.07.05-.06,0-.07,0-.06,0-.05,0,0a.59.59,0,0,1,0-.08h0l.09-.24h0s0-.1.05-.15l.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a4.92,4.92,0,0,0-.6-.23l-.23-.07a3.33,3.33,0,0,0-.58-.12l-.18,0h-.3a.64.64,0,0,0-.39.14C315.61,191.46,315.69,192.41,315.83,193.27Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,188.36a5.83,5.83,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.08.15h0l0,0,0,0,0,0,.06-.08,0-.1,0,0v0l0,0v0a2,2,0,0,0,.14-.44,3.83,3.83,0,0,0,0-2.13,8,8,0,0,0-2.28-2.33c-.23-.17-.44-.3-.64-.42l-.07-.05-.09,0a1.19,1.19,0,0,0-.22-.12l-.08,0-.1-.06-.18-.07-.32-.12-.08,0h0l-.06,0-.07,0-.1,0-.15,0h0a.7.7,0,0,0-.35,0C307.51,186.12,307.68,187.59,307.81,188.36Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,177.94l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.18 175.44 324.84 187.94 324.84 189.55 303.18 177.05 303.18 175.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.4,177a.39.39,0,0,0,.21-.06l7.59-4.38a1.78,1.78,0,0,1,2.67,1.54v.18a.43.43,0,1,0,.85,0v-.18a2.63,2.63,0,0,0-3.94-2.28l-7.59,4.38a.43.43,0,0,0-.16.59A.44.44,0,0,0,320.4,177Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27,169.39a.39.39,0,0,0,.21-.06l7.6-4.38a1.78,1.78,0,0,1,2.66,1.54v.18a.43.43,0,1,0,.85,0v-.18a2.62,2.62,0,0,0-1.31-2.28,2.58,2.58,0,0,0-2.63,0l-7.59,4.38a.43.43,0,0,0-.16.59A.44.44,0,0,0,307.27,169.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.88,168.11a12.92,12.92,0,0,0,.18,3.87c.41,2.42,1.75,4.79,3.43,5.76a2.31,2.31,0,0,0,1.47.35l0,.1.51-.29h0a2.69,2.69,0,0,0,1.05-2.46s.21-.76.68-.49.69,1.28.69,1.28a7.3,7.3,0,0,0,3,5.82,2.39,2.39,0,0,0,1.74.36l0,.11.53-.3h0a2.86,2.86,0,0,0,1.2-2c.24-1.1.46-3.28,0-4.29-.28-.61-2.54-1.94-3.44-2.32a2.24,2.24,0,0,0-2-.06h0l-.51.3.12,0A2.45,2.45,0,0,0,315,175h0a2.7,2.7,0,0,0-.82-.93.77.77,0,0,0-.82,0h0a7.52,7.52,0,0,0-2.91-4.68c-.87-.65-3.05-1.88-3.41-1.67h0l-.49.28Zm8.72,8.52c0-1.74,1-2.53,2.35-1.78a5.63,5.63,0,0,1,2.36,4.49c0,1.74-1.06,2.53-2.36,1.78A5.62,5.62,0,0,1,315.6,176.63Zm-7.46-4.31c0-1.73,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.36,4.5c0,1.73-1.06,2.53-2.36,1.78A5.64,5.64,0,0,1,308.14,172.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,168c.36-.2,2.53,1,3.41,1.67a6.62,6.62,0,0,1,1,.9l.5-.28a6.69,6.69,0,0,0-1-.9c-.87-.65-3.05-1.88-3.41-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.44,173.88h0a2.24,2.24,0,0,1,2,.06c.89.37,3.16,1.71,3.44,2.32l.49-.29c-.28-.61-2.54-1.94-3.44-2.32a2.24,2.24,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,174.27a.8.8,0,0,1,.76.06,1.21,1.21,0,0,1,.26.2l.49-.29a1.28,1.28,0,0,0-.26-.2.77.77,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,174.53a3.5,3.5,0,0,1,.56.72h0a2.59,2.59,0,0,1,.25-.66,2.6,2.6,0,0,0-.32-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.72,182.49l.48-.27h0a2.86,2.86,0,0,0,1.2-2c.24-1.1.46-3.28,0-4.29l-.49.29c.46,1,.23,3.18,0,4.29A2.89,2.89,0,0,1,319.72,182.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,178.16l.46-.26a2.69,2.69,0,0,0,1.05-2.46,1,1,0,0,1,.1-.24c-.41-.14-.59.52-.59.52A2.71,2.71,0,0,1,312,178.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,170.53a7.75,7.75,0,0,1,1.91,3.78h0l0,0,.43-.25a7.61,7.61,0,0,0-1.9-3.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,172.27c.41,2.41,1.76,4.79,3.44,5.76s3.05-.06,3.05-2.31c0,0,.21-.76.68-.48s.68,1.27.68,1.27a7.29,7.29,0,0,0,3,5.82c1.68,1,3,.15,3.44-1.78.23-1.11.46-3.29,0-4.29-.28-.61-2.55-1.95-3.44-2.32-1.3-.54-2.19-.24-2.66.65a2.59,2.59,0,0,0-.25.66h0a2.71,2.71,0,0,0-.82-.92.77.77,0,0,0-.82,0h0a7.66,7.66,0,0,0-2.91-4.68c-.9-.66-3.16-1.94-3.44-1.65C306.1,168.46,306.33,170.9,306.56,172.27Zm8.54,4.64c0-1.73,1.06-2.53,2.36-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.64,5.64,0,0,1,315.1,176.91Zm-7.45-4.3c0-1.74,1.05-2.53,2.35-1.78a5.62,5.62,0,0,1,2.35,4.49c0,1.74-1.05,2.53-2.35,1.78A5.62,5.62,0,0,1,307.65,172.61Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.69,176.71a.69.69,0,0,0-.29-.55c-.16-.09-.29,0-.29.22a.67.67,0,0,0,.29.54C320.56,177,320.69,176.92,320.69,176.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,168.8c0-.21.13-.31.29-.22a.69.69,0,0,1,.29.55c0,.21-.13.3-.29.21A.67.67,0,0,1,307,168.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,176.91a5.64,5.64,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77,0,1.65,1.65,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C315.53,175.08,315.1,175.81,315.1,176.91Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.65,172.61A5.62,5.62,0,0,0,310,177.1a1.41,1.41,0,0,0,1.77,0,1.62,1.62,0,0,1-1.27-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C308.07,170.78,307.65,171.5,307.65,172.61Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.1,176.91a5.64,5.64,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77,0,1.65,1.65,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C315.53,175.08,315.1,175.81,315.1,176.91Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.65,172.61A5.62,5.62,0,0,0,310,177.1a1.41,1.41,0,0,0,1.77,0,1.62,1.62,0,0,1-1.27-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C308.07,170.78,307.65,171.5,307.65,172.61Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.46,181.41c1.3.75,2.35,0,2.35-1.78a5.64,5.64,0,0,0-2.35-4.5c-1.3-.75-2.36.05-2.36,1.78A5.64,5.64,0,0,0,317.46,181.41Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,177.1c1.3.75,2.35,0,2.35-1.78a5.62,5.62,0,0,0-2.35-4.49c-1.3-.75-2.35,0-2.35,1.78A5.62,5.62,0,0,0,310,177.1Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,161.33l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.18 158.83 324.84 171.34 324.84 172.94 303.18 160.44 303.18 158.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.9,162.64l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,162.64l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,159a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1.12,1.12,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.61l0-.27A.76.76,0,0,0,329.58,159Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,159a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1.12,1.12,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.61l0-.27A.76.76,0,0,0,329.58,159Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,162.92l6.65-3.84a.92.92,0,0,1,.56-.13.76.76,0,0,1,.65.69l0,.27a.86.86,0,0,0,.42.61h0a.86.86,0,0,0,.44.12.88.88,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.12-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.37,160.18a1,1,0,0,0,.33.34l-.46-.26A1.12,1.12,0,0,1,330,160l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,154l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,154l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.44-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,150.32a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.6l0-.27A.78.78,0,0,0,314.63,150.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,150.32a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.6l0-.27A.78.78,0,0,0,314.63,150.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,154.29l6.64-3.84a.92.92,0,0,1,.56-.13.78.78,0,0,1,.66.7l0,.27a.85.85,0,0,0,.43.6h0a.87.87,0,0,0,.88,0,.25.25,0,0,0,.12-.26l-.12-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,151.55a.92.92,0,0,0,.34.34l-.47-.26a1.12,1.12,0,0,1-.28-.25l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M306.6,154.36s.3.08.44.83a27.72,27.72,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,5.14,5.14,0,0,0,.91.43l.07,0a2.13,2.13,0,0,0,.75.1h.19l.07,0,.09,0s0,0,.07,0l.15-.07a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.82l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,13.94,13.94,0,0,0,.53-2.32c.14-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17.24,17.24,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,306.6,154.36Zm9.27,5.35a.64.64,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.23h0a.25.25,0,0,0,0,.07l0,.05s0,0,0,.05l0,.06,0,.07-.05.07-.06.06c-.33.35-.89.48-1.84-.05a4.81,4.81,0,0,1-1.9-1.91h0a5.5,5.5,0,0,1-.61-1.74C315.69,160.94,315.61,160,315.87,159.71Zm-8.06-5.19a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.06,0h0l.08,0,.32.12.18.08.1.05.08,0a2.39,2.39,0,0,1,.22.12l.09.05.07,0c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0l0,0v0l0,0,0,.09-.06.08,0,0,0,0,0,0h0c-.35.37-1,.5-2.08-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C307.68,156.12,307.51,154.65,307.81,154.52Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M312.51,161.84h0l.46-.26a1.8,1.8,0,0,0,.63-.68,15.31,15.31,0,0,0,.5-1.55c-.65-.21-.57,1.12-1,1.82A1.65,1.65,0,0,1,312.51,161.84Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93,165.83a13.94,13.94,0,0,0,.53-2.32c.14-.58.44-.32.44-.32l.05,0s0,.05,0,.07a13.12,13.12,0,0,1-.53,2.33,1.48,1.48,0,0,1-.55.63l-.47.27A1.55,1.55,0,0,0,320.93,165.83Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M322,161.71l.48-.27a3.63,3.63,0,0,1-.07,1.48l-.42.24-.05,0A3.54,3.54,0,0,0,322,161.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,152.53c.26.1.55.23.86.37a18,18,0,0,1,4.26,2.59,24.56,24.56,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.34c.31.21.6.42.86.62l-.48.27-.85-.62a17.24,17.24,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,154.36s.3.08.44.83a27.72,27.72,0,0,0,.53,2.93,5.74,5.74,0,0,0,2.64,3.34,5.14,5.14,0,0,0,.91.43l.07,0a2.13,2.13,0,0,0,.75.1h.19l.07,0,.09,0s0,0,.07,0l.15-.07h0a1.65,1.65,0,0,0,.61-.67c.41-.7.33-2,1-1.82l.07,0,.08,0c.81.47.69,1.81,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.13,0,.13,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.55,1.55,0,0,0,.55-.63,13.94,13.94,0,0,0,.53-2.32c.14-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17.24,17.24,0,0,0-4.27-2.34c-1.36-.34-1.84-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.57,18.57,0,0,0-4.27-2.59l-.85-.36A3.67,3.67,0,0,0,306.6,154.36Zm9.27,5.35a.64.64,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25c0,.05,0,.1-.05.15h0l-.09.23h0a.25.25,0,0,0,0,.07l0,.05s0,0,0,.05l0,.06,0,.07-.05.07-.06.06c-.33.35-.89.48-1.84-.05a4.81,4.81,0,0,1-1.9-1.91h0a5.5,5.5,0,0,1-.61-1.74C315.69,160.94,315.61,160,315.87,159.71Zm-8.06-5.19a.7.7,0,0,1,.35,0h0l.15,0,.1,0,.07,0,.06,0h0l.08,0,.32.12.18.08.1.05.08,0a2.39,2.39,0,0,1,.22.12l.09.05.07,0c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,2.3,2.3,0,0,1-.14.45s0,0,0,0l0,0v0l0,0,0,.09-.06.08,0,0,0,0,0,0h0c-.35.37-1,.5-2.08-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C307.68,156.12,307.51,154.65,307.81,154.52Z",
    style: {
      fill: "#37474f"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,161.8a5.5,5.5,0,0,0,.61,1.74h0a4.81,4.81,0,0,0,1.9,1.91c1,.53,1.51.4,1.84.05a1.88,1.88,0,0,1-1.36-.33,5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.48,4.48,0,0,1-.05-1.95.64.64,0,0,0-.39.13C315.61,160,315.69,160.94,315.83,161.8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M307.81,156.9a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.65,1.73.52,2.08.15a2.27,2.27,0,0,1-1.61-.42,4.89,4.89,0,0,1-1-.84,5.69,5.69,0,0,1-1.31-3,7.28,7.28,0,0,1-.13-2.14.7.7,0,0,0-.35,0C307.51,154.65,307.68,156.12,307.81,156.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.83,161.8a5.5,5.5,0,0,0,.61,1.74h0a4.81,4.81,0,0,0,1.9,1.91c1,.53,1.51.4,1.84.05l.06-.06.05-.07,0-.07,0-.06s0,0,0-.05l0-.05a.25.25,0,0,1,0-.07h0l.09-.23h0s0-.1.05-.15l.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a4.92,4.92,0,0,0-.6-.23l-.23-.07-.58-.12h-.48a.64.64,0,0,0-.39.13C315.61,160,315.69,160.94,315.83,161.8Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,156.9a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.65,1.73.52,2.08.15h0l0,0,0,0,0,0,.06-.08,0-.09,0,0v0l0,0s0,0,0,0a2.3,2.3,0,0,0,.14-.45,3.83,3.83,0,0,0,0-2.13,8,8,0,0,0-2.28-2.33c-.23-.16-.44-.3-.64-.42l-.07,0-.09-.05a2.39,2.39,0,0,0-.22-.12l-.08,0-.1-.05-.18-.08-.32-.12-.08,0h0l-.06,0-.07,0-.1,0-.15,0h0a.7.7,0,0,0-.35,0C307.51,154.65,307.68,156.12,307.81,156.9Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,146.33l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.18 143.83 324.84 156.34 324.84 157.94 303.18 145.44 303.18 143.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.06,138.71l7.13-4.1a2.38,2.38,0,0,1,3.57,2.06v.26a.34.34,0,1,1-.68,0v-.26a1.69,1.69,0,0,0-.85-1.47,1.67,1.67,0,0,0-1.7,0l-7.13,4.11a.33.33,0,0,1-.17,0,.32.32,0,0,1-.29-.17A.34.34,0,0,1,307.06,138.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,142.11a1.15,1.15,0,0,1,.55-.12,4.32,4.32,0,0,1,2.15.77,6.11,6.11,0,0,1,3.16,4.82c.16,2.16-.36,3.54-1,3.92l.44-.24c.64-.37,1.17-1.76,1-3.95a6.11,6.11,0,0,0-3.16-4.82,4.42,4.42,0,0,0-2.14-.77,1.21,1.21,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.28,145.39l.46-.27a5.56,5.56,0,0,1,.6,2.19c.16,2.19-.37,3.58-1,3.95l-.44.24c.63-.38,1.15-1.76,1-3.92A5.56,5.56,0,0,0,320.28,145.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,142.11a1.15,1.15,0,0,1,.55-.12,4.32,4.32,0,0,1,2.15.77,6.89,6.89,0,0,1,2.56,2.63l.46-.27a6.9,6.9,0,0,0-2.56-2.63,4.42,4.42,0,0,0-2.14-.77,1.21,1.21,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.23,137.71a1.23,1.23,0,0,1,.66-.17,4.18,4.18,0,0,1,1.79.58,6.44,6.44,0,0,1,3,3,4.11,4.11,0,0,1-1.22,4,1,1,0,0,1-.17.12l.4-.23h0l.22-.14a4.11,4.11,0,0,0,1.21-4,6.46,6.46,0,0,0-3-3,4.19,4.19,0,0,0-1.8-.57,1.31,1.31,0,0,0-.65.16l-.44.25Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.65,141.16a2.3,2.3,0,0,0-.16-.37l.47-.27a3.59,3.59,0,0,1,.15.37,4.11,4.11,0,0,1-1.21,4l-.22.14h0l-.4.23a1,1,0,0,0,.17-.12A4.11,4.11,0,0,0,312.65,141.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,143.69a.11.11,0,0,0,.1-.06.11.11,0,0,0,0-.15l-.17-.1v-.12a.74.74,0,0,0-.32-.6l-.86-.5a.28.28,0,0,0-.29,0,.33.33,0,0,0-.15.29l-.06,0a.11.11,0,0,0-.15,0,.12.12,0,0,0,0,.16l.4.23v-.38c0-.08,0-.11,0-.12a.08.08,0,0,1,.06,0l.86.49a.52.52,0,0,1,.21.41v.25l.29.16S314.79,143.69,314.81,143.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,144.39a11.89,11.89,0,0,0,1.13,3.15,9.23,9.23,0,0,0,2.62,3.25.59.59,0,0,0,.82-.17.62.62,0,0,1-.35-.1,9.13,9.13,0,0,1-2.63-3.25,11.65,11.65,0,0,1-1.13-3.15,5.24,5.24,0,0,1-.13-1.55h-.1c-.21,0-.3.05-.31.07A3.63,3.63,0,0,0,315.34,144.39Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,144.39a11.89,11.89,0,0,0,1.13,3.15,9.23,9.23,0,0,0,2.62,3.25.59.59,0,0,0,.82-.17.62.62,0,0,1-.35-.1,9.13,9.13,0,0,1-2.63-3.25,11.65,11.65,0,0,1-1.13-3.15,5.24,5.24,0,0,1-.13-1.55h-.1c-.21,0-.3.05-.31.07A3.63,3.63,0,0,0,315.34,144.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.08,144.2a2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.78.15,2.21,2.21,0,0,1-1.81-.92,8.86,8.86,0,0,1-1-4.87,1.94,1.94,0,0,1,.26-.95c-.25,0-.64.13-.72,1.21A8.73,8.73,0,0,0,308.08,144.2Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.08,144.2a2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.78.15,2.21,2.21,0,0,1-1.81-.92,8.86,8.86,0,0,1-1-4.87,1.94,1.94,0,0,1,.26-.95c-.25,0-.64.13-.72,1.21A8.73,8.73,0,0,0,308.08,144.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.57,142.56a3.88,3.88,0,0,1,1.84.68,5.49,5.49,0,0,1,2.9,4.38,5.91,5.91,0,0,1-.37,2.93.58.58,0,0,1-.85.24,9.23,9.23,0,0,1-2.62-3.25,11.89,11.89,0,0,1-1.13-3.15,3.49,3.49,0,0,1-.08-1.76s.1-.07.31-.07Zm0-.57a.85.85,0,0,0-.82.38c-.35.68,0,3.19,1.21,5.44s2.87,3.78,3.65,3.78a.38.38,0,0,0,.19,0c.67-.3,1.24-1.71,1.08-4a6.1,6.1,0,0,0-3.17-4.82,4.26,4.26,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,138.11a3.64,3.64,0,0,1,1.53.52,6,6,0,0,1,2.69,2.7,3.56,3.56,0,0,1-1,3.4,2,2,0,0,1-1.21.4,2.19,2.19,0,0,1-1.81-.93,8.73,8.73,0,0,1-1-4.87c.09-1.22.57-1.22.8-1.22Zm0-.57c-.71,0-1.27.43-1.37,1.75a9.4,9.4,0,0,0,1.08,5.22,2.75,2.75,0,0,0,2.29,1.19,2.54,2.54,0,0,0,1.54-.51,4.11,4.11,0,0,0,1.22-4,6.44,6.44,0,0,0-3-3,4.18,4.18,0,0,0-1.79-.58Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,137.54a1.23,1.23,0,0,0-.66.17l0,0,.44-.25a1.31,1.31,0,0,1,.65-.16,4.19,4.19,0,0,1,1.8.57,7.14,7.14,0,0,1,2.81,2.67l-.47.27a6.94,6.94,0,0,0-2.81-2.67A4.18,4.18,0,0,0,307.89,137.54Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,146.71l7.12-4.11a2.39,2.39,0,0,1,3.58,2.07v.25a.34.34,0,1,1-.68,0v-.25a1.7,1.7,0,0,0-2.55-1.47l-7.13,4.1a.34.34,0,0,1-.17,0,.34.34,0,0,1-.29-.17A.34.34,0,0,1,321,146.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,138.11h0c-.23,0-.71,0-.8,1.22a8.73,8.73,0,0,0,1,4.87,2.19,2.19,0,0,0,1.81.93,2,2,0,0,0,1.21-.4,3.56,3.56,0,0,0,1-3.4,6,6,0,0,0-2.69-2.7,3.64,3.64,0,0,0-1.53-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.57,142.56c-.21,0-.3.05-.31.07a3.49,3.49,0,0,0,.08,1.76,11.89,11.89,0,0,0,1.13,3.15,9.23,9.23,0,0,0,2.62,3.25.58.58,0,0,0,.85-.24,5.91,5.91,0,0,0,.37-2.93,5.49,5.49,0,0,0-2.9-4.38,3.88,3.88,0,0,0-1.84-.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,142.79a.1.1,0,0,0,.09,0,.1.1,0,0,0,0-.15,72.26,72.26,0,0,0-8-4.65.13.13,0,0,0-.16.05.13.13,0,0,0,.06.16,70.17,70.17,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.84,131.33l-13-7.5-8.67,5v1.61l21.66,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.18 128.83 324.84 141.33 324.84 142.94 303.18 130.44 303.18 128.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.9,132.33l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,132.33l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,128.63a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36,1,1,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l0-.27A.78.78,0,0,0,329.58,128.63Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.58,128.63a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36,1,1,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l0-.27A.78.78,0,0,0,329.58,128.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.37,132.6l6.65-3.84a.92.92,0,0,1,.56-.13.78.78,0,0,1,.65.7l0,.27a.9.9,0,0,0,.42.61h0a1,1,0,0,0,.44.11.79.79,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.12-.71a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.37,129.86a.93.93,0,0,0,.33.35l-.46-.27a1,1,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,123.7l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,123.7l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.44-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,120a.93.93,0,0,1,.18.43l.05.27a1.05,1.05,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,314.63,120Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.63,120a.93.93,0,0,1,.18.43l.05.27a1.05,1.05,0,0,0,.15.36.83.83,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,314.63,120Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,124l6.64-3.84a.92.92,0,0,1,.56-.13.79.79,0,0,1,.66.7l0,.27a.89.89,0,0,0,.43.61h0a1,1,0,0,0,.44.12.8.8,0,0,0,.44-.13.23.23,0,0,0,.12-.25l-.12-.72a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,121.23a.88.88,0,0,0,.34.35l-.47-.27a.83.83,0,0,1-.28-.25L315,121Z",
    style: {
      opacity: 0.15
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M306.6,124.05s.3.07.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,5,5,0,0,0,.91.42l.07,0a2.16,2.16,0,0,0,.75.11h.19l.07,0,.09,0,.07,0,.15-.07a1.71,1.71,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.13,0,.13,0,.08,0a1.57,1.57,0,0,0,.48,0h0a.41.41,0,0,0,.16,0h0a1.09,1.09,0,0,0,.27-.11h0a1.62,1.62,0,0,0,.55-.63,14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.23,18.23,0,0,0-4.27-2.59c-.31-.15-.6-.27-.85-.37A3.71,3.71,0,0,0,306.6,124.05Zm9.27,5.35a.58.58,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07c.2.06.4.14.6.22l.14.07a5.87,5.87,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09c0,.07,0,.16-.06.25s0,.09-.05.14h0l-.09.24h0a.3.3,0,0,0,0,.08l0,0a.08.08,0,0,1,0,0,.43.43,0,0,1,0,.07l0,.06a.18.18,0,0,1-.05.07l-.06.07c-.33.34-.89.48-1.84-.06a4.85,4.85,0,0,1-1.9-1.9h0a5.55,5.55,0,0,1-.61-1.75C315.69,130.62,315.61,129.67,315.87,129.4Zm-8.06-5.2a.72.72,0,0,1,.35,0h0s0,0,0,0l.15,0,.1,0,.07,0h.07l.08,0,.32.12.18.08.1,0,.08,0,.22.12.09,0,.07,0c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2.22,2.22,0,0,1-.14.44s0,0,0,0l0,.05v0l0,.05,0,.1-.06.08,0,0,0,.06s0,0,0,0h0c-.35.37-1,.51-2.08-.15a4.41,4.41,0,0,1-1-.83,5.86,5.86,0,0,1-1.31-3C307.68,125.81,307.51,124.34,307.81,124.2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.51,131.53h0l.46-.27a1.73,1.73,0,0,0,.63-.68,13.85,13.85,0,0,0,.5-1.55c-.65-.21-.57,1.13-1,1.83A1.71,1.71,0,0,1,312.51,131.53Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93,135.52a14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31l.05,0a.64.64,0,0,0,0,.07,13.32,13.32,0,0,1-.53,2.33,1.54,1.54,0,0,1-.55.63l-.47.27A1.62,1.62,0,0,0,320.93,135.52Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M322,131.4l.48-.28a3.63,3.63,0,0,1-.07,1.48l-.42.25-.05,0A3.54,3.54,0,0,0,322,131.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,122.22c.26.1.55.22.86.36a18.3,18.3,0,0,1,4.26,2.59,23.51,23.51,0,0,0,2.6,2.44c.75.44,1.23.21,2.59.56a17,17,0,0,1,4.26,2.33l.86.62-.48.28c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.23,18.23,0,0,0-4.27-2.59c-.31-.15-.6-.27-.85-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.6,124.05s.3.07.44.82a27.88,27.88,0,0,0,.53,2.94,5.74,5.74,0,0,0,2.64,3.34,5,5,0,0,0,.91.42l.07,0a2.16,2.16,0,0,0,.75.11h.19l.07,0,.09,0,.07,0,.15-.07h0a1.71,1.71,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.13,0,.13,0,.08,0a1.57,1.57,0,0,0,.48,0h0a.41.41,0,0,0,.16,0h0a.81.81,0,0,0,.27-.11h0a1.62,1.62,0,0,0,.55-.63,14.06,14.06,0,0,0,.53-2.33c.14-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.63a17.17,17.17,0,0,0-4.27-2.33c-1.36-.34-1.84-.12-2.59-.55a25.8,25.8,0,0,1-2.59-2.44,18.23,18.23,0,0,0-4.27-2.59c-.31-.15-.6-.27-.85-.37A3.71,3.71,0,0,0,306.6,124.05Zm9.27,5.35a.58.58,0,0,1,.39-.14h.3l.18,0a3.33,3.33,0,0,1,.58.12l.23.07c.2.06.4.14.6.22l.14.07a5.87,5.87,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09c0,.07,0,.16-.06.25s0,.09-.05.14h0l-.09.24h0a.3.3,0,0,0,0,.08l0,0a.08.08,0,0,1,0,0,.43.43,0,0,1,0,.07l0,.06a.18.18,0,0,1-.05.07l-.06.07c-.33.34-.89.48-1.84-.06a4.85,4.85,0,0,1-1.9-1.9h0a5.55,5.55,0,0,1-.61-1.75C315.69,130.62,315.61,129.67,315.87,129.4Zm-8.06-5.2a.72.72,0,0,1,.35,0h0l.15,0,.1,0,.07,0h.07l.08,0,.32.12.18.08.1,0,.08,0,.22.12.09,0,.07,0c.2.12.41.26.64.42a8,8,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2.22,2.22,0,0,1-.14.44s0,0,0,0l0,.05v0l0,.05,0,.1-.06.08,0,0,0,.06s0,0,0,0h0c-.35.37-1,.51-2.08-.15a4.41,4.41,0,0,1-1-.83,5.86,5.86,0,0,1-1.31-3C307.68,125.81,307.51,124.34,307.81,124.2Z",
    style: {
      fill: "#37474f"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M315.83,131.48a5.55,5.55,0,0,0,.61,1.75h0a4.85,4.85,0,0,0,1.9,1.9c1,.54,1.51.4,1.84.06a2,2,0,0,1-1.36-.33,4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74,4.48,4.48,0,0,1-.05-2,.58.58,0,0,0-.39.14C315.61,129.67,315.69,130.62,315.83,131.48Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M307.81,126.58a5.86,5.86,0,0,0,1.31,3,4.41,4.41,0,0,0,1,.83c1.1.66,1.73.52,2.08.15a2.17,2.17,0,0,1-1.61-.42,4.34,4.34,0,0,1-1-.84,5.67,5.67,0,0,1-1.31-3,7.29,7.29,0,0,1-.13-2.14.72.72,0,0,0-.35,0C307.51,124.34,307.68,125.81,307.81,126.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M315.83,131.48a5.55,5.55,0,0,0,.61,1.75h0a4.85,4.85,0,0,0,1.9,1.9c1,.54,1.51.4,1.84.06l.06-.07a.18.18,0,0,0,.05-.07l0-.06a.43.43,0,0,0,0-.07.08.08,0,0,0,0,0l0,0a.3.3,0,0,1,0-.08h0l.09-.24h0c0-.05,0-.1.05-.14s0-.18.06-.25V134a4.37,4.37,0,0,0,0-2.38,5.87,5.87,0,0,0-2.4-1.88l-.14-.07c-.2-.08-.4-.16-.6-.22l-.23-.07a3.33,3.33,0,0,0-.58-.12l-.18,0h-.3a.58.58,0,0,0-.39.14C315.61,129.67,315.69,130.62,315.83,131.48Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,126.58a5.86,5.86,0,0,0,1.31,3,4.41,4.41,0,0,0,1,.83c1.1.66,1.73.52,2.08.15h0s0,0,0,0l0-.06,0,0,.06-.08,0-.1,0-.05v0l0-.05s0,0,0,0a2.22,2.22,0,0,0,.14-.44,3.83,3.83,0,0,0,0-2.13,8,8,0,0,0-2.28-2.34c-.23-.16-.44-.3-.64-.42l-.07,0-.09,0-.22-.12-.08,0-.1,0-.18-.08-.32-.12-.08,0h-.07l-.07,0-.1,0-.15,0h0a.72.72,0,0,0-.35,0C307.51,124.34,307.68,125.81,307.81,126.58Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "350.82 232.95 329.17 220.45 329.17 145.44 350.82 157.94 350.82 232.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.83 215.45 337.83 150.44 329.17 145.44 329.17 220.45 337.83 215.45",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 220.45 337.83 215.45 350.82 222.95 350.82 232.95 329.17 220.45",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.88,224.12l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.11l-5.9,3.41Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,224.12l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.11l-5.9,3.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,220.42a.9.9,0,0,1,.18.42l.05.27a1.11,1.11,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,355.56,220.42Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,220.42a.9.9,0,0,1,.18.42l.05.27a1.11,1.11,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,355.56,220.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36,224.39l6.64-3.84a.94.94,0,0,1,.56-.13.79.79,0,0,1,.66.7l0,.27a.89.89,0,0,0,.43.61h0a1,1,0,0,0,.44.11.88.88,0,0,0,.44-.12.26.26,0,0,0,.13-.26l-.13-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,221.65a.85.85,0,0,0,.33.35l-.47-.27a1,1,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,215.49l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11L333,214Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,215.49l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11L333,214Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,211.79a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,340.62,211.79Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,211.79a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,340.62,211.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,215.76l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.87.87,0,0,0,.42.61h0a.92.92,0,0,0,.43.11,1,1,0,0,0,.45-.12.24.24,0,0,0,.12-.26l-.13-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.41,213a.8.8,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25.61.61,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M332.58,215.83s.3.08.45.83a25.39,25.39,0,0,0,.52,2.94,5.79,5.79,0,0,0,2.64,3.34,5.87,5.87,0,0,0,.92.42l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0,.08,0,.14-.08a1.71,1.71,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0l.28-.11h0a1.52,1.52,0,0,0,.55-.62,13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.83-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.71,18.71,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36A3.67,3.67,0,0,0,332.58,215.83Zm9.27,5.36a.59.59,0,0,1,.4-.14h.3l.17,0a3.33,3.33,0,0,1,.58.12l.24.06c.19.07.39.14.59.23a.61.61,0,0,1,.14.07,5.79,5.79,0,0,1,2.4,1.88,4.33,4.33,0,0,1,0,2.37v.1l-.06.24a.88.88,0,0,1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,0l0,.05,0,.06a.43.43,0,0,1,0,.07l-.06.07-.06.06c-.33.35-.88.48-1.83-.05a4.89,4.89,0,0,1-1.91-1.9h0a5.77,5.77,0,0,1-.61-1.74C341.67,222.41,341.59,221.46,341.85,221.19Zm-8.06-5.2a.86.86,0,0,1,.35,0h0s0,0,0,0l.16,0,.09,0,.08,0h.07l.07,0,.32.12.18.08.1.05.08,0,.23.12.08.05.07,0c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.34,3.74,3.74,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0a.05.05,0,0,1,0,0v0l0,0a.93.93,0,0,1-.05.1l-.06.08,0,0a.1.1,0,0,1,0,0l0,0h0c-.36.37-1,.51-2.09-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C333.66,217.59,333.49,216.13,333.79,216Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M338.49,223.31h0l.46-.26a1.73,1.73,0,0,0,.63-.68,14.54,14.54,0,0,0,.5-1.55c-.64-.21-.57,1.13-1,1.83A1.71,1.71,0,0,1,338.49,223.31Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M346.91,227.31a13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32l.05,0a.24.24,0,0,1,0,.08,13.21,13.21,0,0,1-.53,2.32,1.48,1.48,0,0,1-.55.63l-.47.27A1.52,1.52,0,0,0,346.91,227.31Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M347.94,223.18l.48-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.54,3.54,0,0,0,347.94,223.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333,214l.85.36a18.3,18.3,0,0,1,4.26,2.59,24.46,24.46,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.34c.31.21.6.43.86.62l-.48.27-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.83-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.71,18.71,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,215.83s.3.08.45.83a25.39,25.39,0,0,0,.52,2.94,5.79,5.79,0,0,0,2.64,3.34,5.87,5.87,0,0,0,.92.42l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0,.08,0,.14-.08h0a1.71,1.71,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.36,1.36,0,0,0,.28-.11h0a1.52,1.52,0,0,0,.55-.62,13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.35-1.83-.12-2.59-.56a24.64,24.64,0,0,1-2.59-2.44,18.71,18.71,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36A3.67,3.67,0,0,0,332.58,215.83Zm9.27,5.36a.59.59,0,0,1,.4-.14h.3l.17,0a3.33,3.33,0,0,1,.58.12l.24.06c.19.07.39.14.59.23a.61.61,0,0,1,.14.07,5.79,5.79,0,0,1,2.4,1.88,4.33,4.33,0,0,1,0,2.37v.1l-.06.24a.88.88,0,0,1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,0l0,.05,0,.06a.43.43,0,0,1,0,.07l-.06.07-.06.06c-.33.35-.88.48-1.83-.05a4.89,4.89,0,0,1-1.91-1.9h0a5.77,5.77,0,0,1-.61-1.74C341.67,222.41,341.59,221.46,341.85,221.19Zm-8.06-5.2a.86.86,0,0,1,.35,0s0,0,0,0l.16,0,.09,0,.08,0h.07l.07,0,.32.12.18.08.1.05.08,0,.23.12.08.05.07,0c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.34,3.74,3.74,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0a.05.05,0,0,1,0,0v0l0,0a.93.93,0,0,1-.05.1l-.06.08,0,0a.1.1,0,0,1,0,0l0,0h0c-.36.37-1,.51-2.09-.15a4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C333.66,217.59,333.49,216.13,333.79,216Z",
    style: {
      fill: "#37474f"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M341.81,223.27a5.77,5.77,0,0,0,.61,1.74h0a4.89,4.89,0,0,0,1.91,1.9c.95.53,1.5.4,1.83.05a1.9,1.9,0,0,1-1.36-.33,4.83,4.83,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.59.59,0,0,0-.4.14C341.59,221.46,341.67,222.41,341.81,223.27Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M333.79,218.37a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.66,1.73.52,2.09.15a2.24,2.24,0,0,1-1.62-.42,4.6,4.6,0,0,1-1-.84,5.66,5.66,0,0,1-1.31-3,7.26,7.26,0,0,1-.13-2.14.86.86,0,0,0-.35,0C333.49,216.13,333.66,217.59,333.79,218.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,223.27a5.77,5.77,0,0,0,.61,1.74h0a4.89,4.89,0,0,0,1.91,1.9c.95.53,1.5.4,1.83.05l.06-.06.06-.07a.43.43,0,0,0,0-.07l0-.06,0-.05s0,0,0,0l0-.08h0a1.17,1.17,0,0,0,.09-.24h0a.88.88,0,0,0,0-.15l.06-.24v-.1a4.33,4.33,0,0,0,0-2.37,5.79,5.79,0,0,0-2.4-1.88.61.61,0,0,0-.14-.07c-.2-.09-.4-.16-.59-.23l-.24-.06a3.33,3.33,0,0,0-.58-.12l-.17,0h-.3a.59.59,0,0,0-.4.14C341.59,221.46,341.67,222.41,341.81,223.27Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79,218.37a5.84,5.84,0,0,0,1.31,3,4.2,4.2,0,0,0,1,.84c1.1.66,1.73.52,2.09.15h0l0,0a.1.1,0,0,0,0,0l0,0,.06-.08a.93.93,0,0,0,.05-.1l0,0v0a.05.05,0,0,0,0,0l0,0a3,3,0,0,0,.13-.44,3.74,3.74,0,0,0,0-2.13,8,8,0,0,0-2.28-2.34c-.22-.16-.44-.3-.64-.42l-.07,0-.08-.05-.23-.12-.08,0-.1-.05-.18-.08-.32-.12-.07,0h-.07l-.08,0-.09,0-.16,0s0,0,0,0a.86.86,0,0,0-.35,0C333.49,216.13,333.66,217.59,333.79,218.37Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,208l-13-7.51-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 205.44 350.82 217.95 350.82 219.55 329.17 207.05 329.17 205.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.38,207a.42.42,0,0,0,.22-.05l7.59-4.39a1.78,1.78,0,0,1,2.66,1.54v.19a.43.43,0,0,0,.43.43.44.44,0,0,0,.43-.43v-.19a2.64,2.64,0,0,0-3.95-2.28l-7.59,4.39a.44.44,0,0,0-.16.58A.43.43,0,0,0,346.38,207Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,199.39a.54.54,0,0,0,.22,0l7.59-4.39a1.78,1.78,0,0,1,2.66,1.54v.19a.43.43,0,0,0,.43.43.44.44,0,0,0,.43-.43v-.19a2.64,2.64,0,0,0-3.95-2.28L333,198.6a.43.43,0,0,0-.16.58A.43.43,0,0,0,333.25,199.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.86,198.12A13.27,13.27,0,0,0,333,202c.41,2.41,1.75,4.78,3.44,5.76a2.26,2.26,0,0,0,1.46.34l0,.11.52-.3h0a2.69,2.69,0,0,0,1-2.46s.22-.76.69-.49.68,1.28.68,1.28a7.28,7.28,0,0,0,3.05,5.82,2.43,2.43,0,0,0,1.73.37l0,.11.53-.31h0a2.84,2.84,0,0,0,1.19-2c.24-1.1.46-3.28,0-4.29-.27-.6-2.54-1.94-3.43-2.31a2.26,2.26,0,0,0-2-.07h0l-.51.29.12,0A2.4,2.4,0,0,0,341,205h0a2.71,2.71,0,0,0-.82-.92.79.79,0,0,0-.82,0h0a7.6,7.6,0,0,0-2.9-4.68c-.88-.65-3.06-1.88-3.42-1.67h0l-.49.29Zm8.72,8.51c0-1.73,1.06-2.53,2.36-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.65,5.65,0,0,1,341.58,206.63Zm-7.46-4.31c0-1.73,1.06-2.52,2.36-1.77a5.62,5.62,0,0,1,2.35,4.49c0,1.74-1.05,2.53-2.35,1.78A5.64,5.64,0,0,1,334.12,202.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.57,198c.36-.21,2.54,1,3.41,1.67a7.14,7.14,0,0,1,1,.89l.5-.28a7.14,7.14,0,0,0-1-.9c-.88-.65-3.06-1.88-3.42-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.42,203.89h0a2.24,2.24,0,0,1,2,.05c.9.38,3.16,1.71,3.44,2.32l.49-.28c-.27-.61-2.54-1.95-3.43-2.32a2.22,2.22,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,204.28a.79.79,0,0,1,.76.05,1.64,1.64,0,0,1,.26.2l.5-.29a1.57,1.57,0,0,0-.26-.19.79.79,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,204.53a3.1,3.1,0,0,1,.56.73h0a3.11,3.11,0,0,1,.25-.67,3.25,3.25,0,0,0-.31-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,212.5l.48-.28h0a2.84,2.84,0,0,0,1.19-2c.24-1.1.46-3.28,0-4.28l-.49.28c.46,1,.23,3.19,0,4.29A2.91,2.91,0,0,1,345.7,212.5Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,208.17l.45-.27a2.67,2.67,0,0,0,1-2.46s0-.11.1-.24c-.41-.14-.59.53-.59.53A2.75,2.75,0,0,1,338,208.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,200.53a7.79,7.79,0,0,1,1.91,3.78h0l0,0h0l.43-.25a7.64,7.64,0,0,0-1.9-3.78Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.54,202.27c.42,2.42,1.76,4.79,3.44,5.76s3-.06,3-2.3c0,0,.21-.76.68-.49s.68,1.28.68,1.28a7.31,7.31,0,0,0,3.05,5.82c1.68,1,3,.15,3.44-1.79.23-1.1.46-3.28,0-4.29-.28-.61-2.54-1.94-3.44-2.32-1.3-.54-2.19-.24-2.66.65a3.11,3.11,0,0,0-.25.67h0a2.7,2.7,0,0,0-.82-.93.77.77,0,0,0-.82,0h0a7.56,7.56,0,0,0-2.91-4.68c-.9-.67-3.16-1.94-3.44-1.65C332.08,198.46,332.31,200.9,332.54,202.27Zm8.55,4.65c0-1.74,1.05-2.53,2.35-1.78a5.62,5.62,0,0,1,2.35,4.49c0,1.74-1.05,2.53-2.35,1.78A5.62,5.62,0,0,1,341.09,206.92Zm-7.46-4.31c0-1.73,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.36,4.5c0,1.73-1.06,2.53-2.36,1.78A5.64,5.64,0,0,1,333.63,202.61Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67,206.71a.67.67,0,0,0-.29-.54c-.16-.1-.28,0-.28.21a.68.68,0,0,0,.28.55C346.54,207,346.67,206.92,346.67,206.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,198.8c0-.21.12-.31.28-.21a.67.67,0,0,1,.29.54c0,.21-.13.31-.29.22A.68.68,0,0,1,333,198.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.09,206.92a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78,0,1.64,1.64,0,0,1-1.28-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C341.51,205.09,341.09,205.81,341.09,206.92Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.63,202.61a5.64,5.64,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.77-.05,1.67,1.67,0,0,1-1.27-.24,5.64,5.64,0,0,1-2.36-4.5,2.34,2.34,0,0,1,.58-1.72C334.06,200.78,333.63,201.51,333.63,202.61Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.09,206.92a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78,0,1.64,1.64,0,0,1-1.28-.23,5.65,5.65,0,0,1-2.36-4.5,2.36,2.36,0,0,1,.58-1.73C341.51,205.09,341.09,205.81,341.09,206.92Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.63,202.61a5.64,5.64,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.77-.05,1.67,1.67,0,0,1-1.27-.24,5.64,5.64,0,0,1-2.36-4.5,2.34,2.34,0,0,1,.58-1.72C334.06,200.78,333.63,201.51,333.63,202.61Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.44,211.41c1.3.75,2.35,0,2.35-1.78a5.62,5.62,0,0,0-2.35-4.49c-1.3-.75-2.35,0-2.35,1.78A5.62,5.62,0,0,0,343.44,211.41Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,207.11c1.3.75,2.36-.05,2.36-1.78a5.65,5.65,0,0,0-2.36-4.5c-1.3-.75-2.35,0-2.35,1.78A5.64,5.64,0,0,0,336,207.11Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,191.34l-13-7.5-8.66,5v1.6l21.65,12.5V193h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 188.84 350.82 201.34 350.82 202.94 329.17 190.44 329.17 188.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.88,192.65l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.12l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,192.65l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.12l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,189a.93.93,0,0,1,.18.43l.05.26a1,1,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,355.56,189Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,189a.93.93,0,0,1,.18.43l.05.26a1,1,0,0,0,.15.37,1,1,0,0,0,.28.25l.47.27a.89.89,0,0,1-.43-.61l0-.27A.79.79,0,0,0,355.56,189Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36,192.92l6.64-3.84a.94.94,0,0,1,.56-.13.79.79,0,0,1,.66.7l0,.27a.89.89,0,0,0,.43.61h0a1,1,0,0,0,.44.11.79.79,0,0,0,.44-.12.26.26,0,0,0,.13-.26l-.13-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,190.18a.8.8,0,0,0,.33.35l-.47-.27a1,1,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,184l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,184l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,180.32a1.21,1.21,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,340.62,180.32Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,180.32a1.21,1.21,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,340.62,180.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,184.29l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.87.87,0,0,0,.42.61h0a.92.92,0,0,0,.43.11.85.85,0,0,0,.45-.12.24.24,0,0,0,.12-.26l-.13-.71a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.41,181.55a.8.8,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25.61.61,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M332.58,184.36s.3.08.45.83a25.39,25.39,0,0,0,.52,2.94,5.74,5.74,0,0,0,2.64,3.34,5.87,5.87,0,0,0,.92.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.08a1.71,1.71,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0a.41.41,0,0,0,.16,0h0a1.36,1.36,0,0,0,.28-.11h0a1.54,1.54,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31a3.59,3.59,0,0,0,.06-1.49l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.34-1.83-.12-2.59-.55a27.07,27.07,0,0,1-2.59-2.44,18,18,0,0,0-4.27-2.59c-.3-.15-.59-.27-.85-.37A3.67,3.67,0,0,0,332.58,184.36Zm9.27,5.36a.59.59,0,0,1,.4-.14h.3l.17,0a3.33,3.33,0,0,1,.58.12l.24.07a5.37,5.37,0,0,1,.59.22l.14.07a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09c0,.07,0,.16-.06.25a1.21,1.21,0,0,1,0,.14h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,0l0,.05,0,.07,0,.06-.06.07-.06.07c-.33.34-.88.48-1.83-.06a4.89,4.89,0,0,1-1.91-1.9h0a5.81,5.81,0,0,1-.61-1.75C341.67,190.94,341.59,190,341.85,189.72Zm-8.06-5.2a.86.86,0,0,1,.35,0h0s0,0,0,0l.16,0,.09,0,.08,0h.07l.07,0,.32.12.18.08.1.05.08,0,.23.12.08.05.07,0c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.34,3.74,3.74,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0s0,0,0,.05v0l0,0a.47.47,0,0,1-.05.1l-.06.08,0,0a.1.1,0,0,1,0,0l0,.05h0c-.36.37-1,.51-2.09-.15a4.41,4.41,0,0,1-1-.83,5.86,5.86,0,0,1-1.31-3C333.66,186.13,333.49,184.66,333.79,184.52Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M338.49,191.84h0l.46-.27a1.73,1.73,0,0,0,.63-.68,13.85,13.85,0,0,0,.5-1.55c-.64-.21-.57,1.13-1,1.83A1.71,1.71,0,0,1,338.49,191.84Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M346.91,195.84a13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31l.05,0a.25.25,0,0,1,0,.07,13,13,0,0,1-.53,2.32,1.51,1.51,0,0,1-.55.64l-.47.27A1.54,1.54,0,0,0,346.91,195.84Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M347.94,191.71l.48-.27a3.54,3.54,0,0,1-.06,1.48l-.43.25-.05,0A3.59,3.59,0,0,0,347.94,191.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333,182.54l.85.36a18.3,18.3,0,0,1,4.26,2.59,24.46,24.46,0,0,0,2.6,2.44c.75.44,1.23.21,2.59.56a17,17,0,0,1,4.26,2.33l.86.62-.48.27-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.34-1.83-.12-2.59-.55a27.07,27.07,0,0,1-2.59-2.44,18,18,0,0,0-4.27-2.59c-.3-.15-.59-.27-.85-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,184.36s.3.08.45.83a25.39,25.39,0,0,0,.52,2.94,5.74,5.74,0,0,0,2.64,3.34,5.87,5.87,0,0,0,.92.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.07h0a1.71,1.71,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.46.69,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0a.41.41,0,0,0,.16,0h0a1,1,0,0,0,.28-.11h0a1.54,1.54,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31a3.59,3.59,0,0,0,.06-1.49l-.85-.62a16.85,16.85,0,0,0-4.27-2.33c-1.36-.34-1.83-.12-2.59-.55a27.07,27.07,0,0,1-2.59-2.44,18,18,0,0,0-4.27-2.59c-.3-.15-.59-.27-.85-.37A3.67,3.67,0,0,0,332.58,184.36Zm9.27,5.36a.59.59,0,0,1,.4-.14h.3l.17,0a3.33,3.33,0,0,1,.58.12l.24.07a5.37,5.37,0,0,1,.59.22l.14.07a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09c0,.07,0,.16-.06.25a1.21,1.21,0,0,1,0,.14h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,0l0,.05,0,.07,0,.06-.06.07-.06.07c-.33.34-.88.48-1.83-.06a4.89,4.89,0,0,1-1.91-1.9h0a5.81,5.81,0,0,1-.61-1.75C341.67,190.94,341.59,190,341.85,189.72Zm-8.06-5.2a.86.86,0,0,1,.35,0h0l.16,0,.09,0,.08,0h.07l.07,0,.32.12.18.08.1.05.08,0,.23.12.08.05.07,0c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.34,3.74,3.74,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0s0,0,0,.05v0l0,0a.47.47,0,0,1-.05.1l-.06.08,0,0a.1.1,0,0,1,0,0l0,.05h0c-.36.37-1,.51-2.09-.15a4.41,4.41,0,0,1-1-.83,5.86,5.86,0,0,1-1.31-3C333.66,186.13,333.49,184.66,333.79,184.52Z",
    style: {
      fill: "#37474f"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M341.81,191.8a5.81,5.81,0,0,0,.61,1.75h0a4.89,4.89,0,0,0,1.91,1.9c.95.54,1.5.4,1.83.06a2,2,0,0,1-1.36-.33,4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.59.59,0,0,0-.4.14C341.59,190,341.67,190.94,341.81,191.8Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M333.79,186.9a5.86,5.86,0,0,0,1.31,3,4.41,4.41,0,0,0,1,.83c1.1.66,1.73.52,2.09.15a2.19,2.19,0,0,1-1.62-.42,4.34,4.34,0,0,1-1-.84,5.67,5.67,0,0,1-1.31-3,7.34,7.34,0,0,1-.13-2.15.86.86,0,0,0-.35,0C333.49,184.66,333.66,186.13,333.79,186.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,191.8a5.81,5.81,0,0,0,.61,1.75h0a4.89,4.89,0,0,0,1.91,1.9c.95.54,1.5.4,1.83.06l.06-.07.06-.07,0-.06,0-.07,0-.05s0,0,0,0l0-.08h0a1.17,1.17,0,0,0,.09-.24h0a1.21,1.21,0,0,0,0-.14c0-.09,0-.18.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,5.79,5.79,0,0,0-2.4-1.88l-.14-.07a5.37,5.37,0,0,0-.59-.22l-.24-.07a3.33,3.33,0,0,0-.58-.12l-.17,0h-.3a.59.59,0,0,0-.4.14C341.59,190,341.67,190.94,341.81,191.8Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79,186.9a5.86,5.86,0,0,0,1.31,3,4.41,4.41,0,0,0,1,.83c1.1.66,1.73.52,2.09.15h0l0-.05a.1.1,0,0,0,0,0l0,0,.06-.08a.47.47,0,0,0,.05-.1l0,0v0s0,0,0-.05l0,0a3,3,0,0,0,.13-.44,3.74,3.74,0,0,0,0-2.13,8,8,0,0,0-2.28-2.34c-.22-.16-.44-.3-.64-.42l-.07,0-.08-.05-.23-.12-.08,0-.1-.05-.18-.08-.32-.12-.07,0h-.07l-.08,0-.09,0-.16,0h0a.86.86,0,0,0-.35,0C333.49,184.66,333.66,186.13,333.79,186.9Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,176.34l-13-7.5-8.66,5v1.6l21.65,12.5V178h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 173.84 350.82 186.34 350.82 187.94 329.17 175.44 329.17 173.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333,168.72l7.13-4.11a2.39,2.39,0,0,1,3.58,2.07v.25a.35.35,0,1,1-.69,0v-.25a1.7,1.7,0,0,0-2.55-1.47l-7.12,4.1a.41.41,0,0,1-.17.05.34.34,0,0,1-.3-.18A.33.33,0,0,1,333,168.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,172.11a1.19,1.19,0,0,1,.56-.12,4.42,4.42,0,0,1,2.14.77,6.11,6.11,0,0,1,3.16,4.82c.16,2.16-.36,3.55-1,3.93l.43-.25c.64-.36,1.17-1.76,1-3.94a6.09,6.09,0,0,0-3.16-4.82,4.29,4.29,0,0,0-2.14-.77,1.13,1.13,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.26,175.4l.47-.27a5.73,5.73,0,0,1,.59,2.19c.16,2.18-.37,3.58-1,3.94l-.43.25c.62-.38,1.14-1.77,1-3.93A5.51,5.51,0,0,0,346.26,175.4Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,172.11a1.19,1.19,0,0,1,.56-.12,4.42,4.42,0,0,1,2.14.77,6.86,6.86,0,0,1,2.56,2.64l.46-.27a6.76,6.76,0,0,0-2.56-2.63,4.29,4.29,0,0,0-2.14-.77,1.13,1.13,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.21,167.72a1.23,1.23,0,0,1,.66-.17,4.08,4.08,0,0,1,1.8.58,6.49,6.49,0,0,1,3,3,4.14,4.14,0,0,1-1.21,4l-.18.11.41-.23h0l.21-.14a4.1,4.1,0,0,0,1.21-4,6.41,6.41,0,0,0-3-3,4.22,4.22,0,0,0-1.79-.58,1.25,1.25,0,0,0-.66.17l-.44.25Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,171.16a3.59,3.59,0,0,0-.15-.37l.46-.26a1.92,1.92,0,0,1,.15.37,4.1,4.1,0,0,1-1.21,4l-.21.14h0l-.41.23.18-.11A4.14,4.14,0,0,0,338.63,171.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,173.69a.12.12,0,0,0,.09-.05.11.11,0,0,0,0-.16l-.17-.1v-.11a.76.76,0,0,0-.32-.61l-.86-.5a.3.3,0,0,0-.29,0,.35.35,0,0,0-.15.3l-.05,0a.11.11,0,0,0-.16,0,.11.11,0,0,0,0,.15l.4.23v-.38c0-.07,0-.11,0-.11a.07.07,0,0,1,.06,0l.87.5a.52.52,0,0,1,.21.41v.25l.28.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.32,174.39a11.65,11.65,0,0,0,1.13,3.15,9.24,9.24,0,0,0,2.62,3.25.58.58,0,0,0,.82-.17.51.51,0,0,1-.35-.1,9.07,9.07,0,0,1-2.63-3.24,11.89,11.89,0,0,1-1.13-3.15,4.83,4.83,0,0,1-.12-1.56h-.1c-.21,0-.31.06-.32.08A3.6,3.6,0,0,0,341.32,174.39Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.32,174.39a11.65,11.65,0,0,0,1.13,3.15,9.24,9.24,0,0,0,2.62,3.25.58.58,0,0,0,.82-.17.51.51,0,0,1-.35-.1,9.07,9.07,0,0,1-2.63-3.24,11.89,11.89,0,0,1-1.13-3.15,4.83,4.83,0,0,1-.12-1.56h-.1c-.21,0-.31.06-.32.08A3.6,3.6,0,0,0,341.32,174.39Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,174.21a2.21,2.21,0,0,0,1.81.92,2,2,0,0,0,1.21-.39l.13-.11-.1.08a2,2,0,0,1-.78.15,2.19,2.19,0,0,1-1.8-.92,8.81,8.81,0,0,1-1-4.87,2,2,0,0,1,.26-.95c-.25,0-.63.13-.72,1.22A8.77,8.77,0,0,0,334.06,174.21Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,174.21a2.21,2.21,0,0,0,1.81.92,2,2,0,0,0,1.21-.39l.13-.11-.1.08a2,2,0,0,1-.78.15,2.19,2.19,0,0,1-1.8-.92,8.81,8.81,0,0,1-1-4.87,2,2,0,0,1,.26-.95c-.25,0-.63.13-.72,1.22A8.77,8.77,0,0,0,334.06,174.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,172.56a3.81,3.81,0,0,1,1.83.69,5.48,5.48,0,0,1,2.9,4.37,6,6,0,0,1-.36,2.94.59.59,0,0,1-.86.23,9.24,9.24,0,0,1-2.62-3.25,11.65,11.65,0,0,1-1.13-3.15,3.6,3.6,0,0,1-.08-1.75s.11-.08.32-.08Zm0-.57a.87.87,0,0,0-.83.39c-.35.67,0,3.18,1.22,5.43s2.86,3.79,3.64,3.79a.53.53,0,0,0,.19,0c.67-.3,1.24-1.72,1.08-4a6.11,6.11,0,0,0-3.16-4.82,4.42,4.42,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.87,168.12a3.6,3.6,0,0,1,1.53.51,5.93,5.93,0,0,1,2.69,2.71,3.56,3.56,0,0,1-1,3.4,2,2,0,0,1-1.21.39,2.21,2.21,0,0,1-1.81-.92,8.77,8.77,0,0,1-1-4.87c.1-1.22.57-1.22.8-1.22Zm0-.57c-.71,0-1.27.43-1.37,1.74a9.4,9.4,0,0,0,1.08,5.22,2.75,2.75,0,0,0,2.29,1.19,2.62,2.62,0,0,0,1.55-.5,4.14,4.14,0,0,0,1.21-4,6.45,6.45,0,0,0-3-3,4.08,4.08,0,0,0-1.8-.58Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.87,167.55a1.23,1.23,0,0,0-.66.17l0,0,.44-.25a1.25,1.25,0,0,1,.66-.17,4.22,4.22,0,0,1,1.79.58,7,7,0,0,1,2.81,2.67l-.46.26a7.05,7.05,0,0,0-2.81-2.66A4.08,4.08,0,0,0,333.87,167.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,176.71l7.13-4.1a2.39,2.39,0,0,1,3.58,2.06v.26a.35.35,0,0,1-.35.34.34.34,0,0,1-.34-.34v-.26a1.69,1.69,0,0,0-.85-1.47,1.67,1.67,0,0,0-1.7,0l-7.13,4.11a.33.33,0,0,1-.17,0,.32.32,0,0,1-.29-.17A.34.34,0,0,1,347,176.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.87,168.12h0c-.23,0-.7,0-.8,1.22a8.77,8.77,0,0,0,1,4.87,2.21,2.21,0,0,0,1.81.92,2,2,0,0,0,1.21-.39,3.56,3.56,0,0,0,1-3.4,5.93,5.93,0,0,0-2.69-2.71,3.6,3.6,0,0,0-1.53-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,172.56c-.21,0-.31.06-.32.08a3.6,3.6,0,0,0,.08,1.75,11.65,11.65,0,0,0,1.13,3.15,9.24,9.24,0,0,0,2.62,3.25.59.59,0,0,0,.86-.23,6,6,0,0,0,.36-2.94,5.48,5.48,0,0,0-2.9-4.37,3.81,3.81,0,0,0-1.83-.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,172.8a.12.12,0,0,0,.06-.21,72.15,72.15,0,0,0-8-4.64.1.1,0,0,0-.15.05.11.11,0,0,0,.05.15,73.4,73.4,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,161.33l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 158.83 350.82 171.34 350.82 172.94 329.17 160.44 329.17 158.83",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.88,162.33l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,162.33l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.44-.25a2.17,2.17,0,0,0-2.24.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,158.64a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.61l0-.27A.77.77,0,0,0,355.56,158.64Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.56,158.64a.9.9,0,0,1,.18.42l.05.27a.86.86,0,0,0,.43.62l.47.26a.85.85,0,0,1-.43-.61l0-.27A.77.77,0,0,0,355.56,158.64Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.36,162.61l6.64-3.84a.87.87,0,0,1,.56-.13.77.77,0,0,1,.66.69l0,.27a.85.85,0,0,0,.43.61h0a.87.87,0,0,0,.88,0,.27.27,0,0,0,.13-.26l-.13-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,159.87a.83.83,0,0,0,.33.34l-.47-.26a1.12,1.12,0,0,1-.28-.25l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,153.7l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,153.7l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,150a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,340.62,150Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.62,150a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,340.62,150Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,154l6.64-3.84a.88.88,0,0,1,.57-.13.76.76,0,0,1,.65.69l.05.27a.83.83,0,0,0,.42.61h0a.82.82,0,0,0,.43.12,1,1,0,0,0,.45-.12.25.25,0,0,0,.12-.26l-.13-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.41,151.24a.83.83,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25l-.07-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M332.58,154.05s.3.08.45.83a25.62,25.62,0,0,0,.52,2.93,5.74,5.74,0,0,0,2.64,3.34,5.2,5.2,0,0,0,.92.43l.07,0a2.33,2.33,0,0,0,.74.1h.27l.08,0,.08,0,.14-.07a1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.47.69,1.81,1.13,3.06a6.35,6.35,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.39,1.39,0,0,0,.28-.12h0a1.48,1.48,0,0,0,.55-.63,13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.83-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.36,18.36,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36A3.67,3.67,0,0,0,332.58,154.05Zm9.27,5.35a.59.59,0,0,1,.4-.13h.47a4.62,4.62,0,0,1,.58.12l.24.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25a.88.88,0,0,1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08,0,0,0,.05,0,.06,0,.07-.06.06-.06.07c-.33.34-.88.48-1.83-.05a4.84,4.84,0,0,1-1.91-1.91h0a5.77,5.77,0,0,1-.61-1.74C341.67,160.63,341.59,159.68,341.85,159.4Zm-8.06-5.19a.72.72,0,0,1,.35,0h0l.16,0,.09,0,.08,0,.05,0h0l.07,0,.32.12.18.08.1.05.08,0a1.27,1.27,0,0,1,.23.12l.08,0,.07.05c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.33,3.74,3.74,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0a.08.08,0,0,1,0,0v0l0,0a.41.41,0,0,1-.05.09l-.06.08,0,0,0,0,0,0h0c-.36.36-1,.5-2.09-.15a4.44,4.44,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C333.66,155.81,333.49,154.34,333.79,154.21Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M338.49,161.53h0l.46-.26a1.8,1.8,0,0,0,.63-.68,14.68,14.68,0,0,0,.5-1.56c-.64-.2-.57,1.13-1,1.83A1.74,1.74,0,0,1,338.49,161.53Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M346.91,165.52a13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32l.05,0a.19.19,0,0,1,0,.07,13.12,13.12,0,0,1-.53,2.33,1.48,1.48,0,0,1-.55.63l-.47.27A1.48,1.48,0,0,0,346.91,165.52Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M347.94,161.4l.48-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.54,3.54,0,0,0,347.94,161.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M333,152.22l.85.37a18,18,0,0,1,4.26,2.59,26.85,26.85,0,0,0,2.6,2.44c.75.43,1.23.21,2.59.55a17,17,0,0,1,4.26,2.33l.86.63-.48.27-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.83-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.36,18.36,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.58,154.05s.3.08.45.83a25.62,25.62,0,0,0,.52,2.93,5.74,5.74,0,0,0,2.64,3.34,5.2,5.2,0,0,0,.92.43l.07,0a2.33,2.33,0,0,0,.74.1h.27l.08,0,.08,0,.14-.07h0a1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.08,0,.07,0c.81.47.69,1.81,1.13,3.06a6.35,6.35,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0h.08a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.39,1.39,0,0,0,.28-.12h0a1.48,1.48,0,0,0,.55-.63,13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a16.92,16.92,0,0,0-4.27-2.34c-1.36-.34-1.83-.11-2.59-.55a24.64,24.64,0,0,1-2.59-2.44,18.36,18.36,0,0,0-4.27-2.59c-.3-.14-.59-.26-.85-.36A3.67,3.67,0,0,0,332.58,154.05Zm9.27,5.35a.59.59,0,0,1,.4-.13h.47a4.62,4.62,0,0,1,.58.12l.24.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09l-.06.25a.88.88,0,0,1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08,0,0,0,.05,0,.06,0,.07-.06.06-.06.07c-.33.34-.88.48-1.83-.05a4.84,4.84,0,0,1-1.91-1.91h0a5.77,5.77,0,0,1-.61-1.74C341.67,160.63,341.59,159.68,341.85,159.4Zm-8.06-5.19a.72.72,0,0,1,.35,0h0l.16,0,.09,0,.08,0,.05,0h0l.07,0,.32.12.18.08.1.05.08,0a1.27,1.27,0,0,1,.23.12l.08,0,.07.05c.2.12.42.26.64.42a8,8,0,0,1,2.28,2.33,3.74,3.74,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0a.08.08,0,0,1,0,0v0l0,0a.41.41,0,0,1-.05.09l-.06.08,0,0,0,0,0,0h0c-.36.36-1,.5-2.09-.15a4.44,4.44,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3C333.66,155.81,333.49,154.34,333.79,154.21Z",
    style: {
      fill: "#37474f"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M341.81,161.49a5.77,5.77,0,0,0,.61,1.74h0a4.84,4.84,0,0,0,1.91,1.91c.95.53,1.5.39,1.83.05a1.9,1.9,0,0,1-1.36-.33,5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.59.59,0,0,0-.4.13C341.59,159.68,341.67,160.63,341.81,161.49Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M333.79,156.59a5.84,5.84,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.09.15a2.29,2.29,0,0,1-1.62-.42,4.89,4.89,0,0,1-1-.84,5.69,5.69,0,0,1-1.31-3,7.28,7.28,0,0,1-.13-2.14.72.72,0,0,0-.35,0C333.49,154.34,333.66,155.81,333.79,156.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,161.49a5.77,5.77,0,0,0,.61,1.74h0a4.84,4.84,0,0,0,1.91,1.91c.95.53,1.5.39,1.83.05l.06-.07.06-.06,0-.07,0-.06,0-.05,0,0,0-.08h0a1.17,1.17,0,0,0,.09-.24h0a.88.88,0,0,0,0-.15l.06-.25V164a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a5.5,5.5,0,0,0-.59-.23l-.24-.07a4.62,4.62,0,0,0-.58-.12h-.47a.59.59,0,0,0-.4.13C341.59,159.68,341.67,160.63,341.81,161.49Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.79,156.59a5.84,5.84,0,0,0,1.31,3,4.44,4.44,0,0,0,1,.84c1.1.65,1.73.51,2.09.15h0l0,0,0,0,0,0,.06-.08a.41.41,0,0,0,.05-.09l0,0v0a.08.08,0,0,0,0,0l0,0a3.14,3.14,0,0,0,.13-.45,3.74,3.74,0,0,0,0-2.13,8,8,0,0,0-2.28-2.33c-.22-.16-.44-.3-.64-.42l-.07-.05-.08,0a1.27,1.27,0,0,0-.23-.12l-.08,0-.1-.05-.18-.08-.32-.12-.07,0h0l-.05,0-.08,0-.09,0-.16,0h0a.72.72,0,0,0-.35,0C333.49,154.34,333.66,155.81,333.79,156.59Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "414.39 269.65 392.74 257.14 392.74 182.14 414.39 194.64 414.39 269.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.4 252.14 401.4 187.14 392.74 182.14 392.74 257.14 401.4 252.14",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.74 257.14 401.4 252.14 414.39 259.64 414.39 269.65 392.74 257.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.45,260.81l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,260.81l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,257.12a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l0-.27A.76.76,0,0,0,419.14,257.12Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,257.12a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l0-.27A.76.76,0,0,0,419.14,257.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,261.09l6.64-3.84a1,1,0,0,1,.57-.13.76.76,0,0,1,.65.69l0,.27a.83.83,0,0,0,.42.61h0a.82.82,0,0,0,.43.12,1,1,0,0,0,.45-.12.25.25,0,0,0,.12-.26l-.13-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.93,258.35a.83.83,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25l-.07-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,252.18l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,252.18l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,248.49a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,404.19,248.49Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,248.49a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,404.19,248.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,252.46l6.64-3.84a1,1,0,0,1,.57-.13.77.77,0,0,1,.65.7l.05.27a.86.86,0,0,0,.42.6h0a.83.83,0,0,0,.44.12.91.91,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.13-.71a2.3,2.3,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14L397,251l0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,249.72a.9.9,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25.3.3,0,0,1-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M396.16,252.53s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a2.07,2.07,0,0,0,.74.1h.19l.08,0,.08,0,.08,0a.61.61,0,0,0,.14-.07,1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.82l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0H409a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1,1,0,0,0,.28-.12h0a1.48,1.48,0,0,0,.55-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.59,3.59,0,0,0,396.16,252.53Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.36,1.36,0,0,1-.09.23h0a.25.25,0,0,1,0,.07s0,0,0,.05l0,.05,0,.06,0,.07-.06.07-.05.06c-.34.35-.89.48-1.84-.05a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C405.24,259.11,405.16,258.16,405.43,257.88Zm-8.07-5.19a.72.72,0,0,1,.35,0h0l.15,0,.09,0,.08,0,.05,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8,8,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0,0,0v0l0,.05-.06.09,0,.08,0,0-.05.05,0,0h0c-.36.37-1,.5-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C397.23,254.29,397.06,252.82,397.36,252.69Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M402.06,260h0l.46-.26a1.72,1.72,0,0,0,.63-.68c.26-.45.32-1.16.51-1.55-.65-.21-.58,1.12-1,1.82A1.74,1.74,0,0,1,402.06,260Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M410.48,264a13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32l.05,0a.19.19,0,0,1,0,.07,13.1,13.1,0,0,1-.52,2.33,1.58,1.58,0,0,1-.56.63l-.47.27A1.48,1.48,0,0,0,410.48,264Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M411.51,259.88l.48-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.54,3.54,0,0,0,411.51,259.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,250.7l.85.37a18.23,18.23,0,0,1,4.27,2.59,25.8,25.8,0,0,0,2.59,2.44c.75.43,1.23.21,2.59.55a17.09,17.09,0,0,1,4.27,2.34c.31.21.6.42.85.62l-.48.27-.85-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,252.53s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a2.07,2.07,0,0,0,.74.1h.19l.08,0,.08,0,.08,0a.61.61,0,0,0,.14-.07h0a1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.82l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0H409a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1,1,0,0,0,.28-.12h0a1.48,1.48,0,0,0,.55-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.59,3.59,0,0,0,396.16,252.53Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.36,1.36,0,0,1-.09.23h0a.25.25,0,0,1,0,.07s0,0,0,.05l0,.05,0,.06,0,.07-.06.07-.05.06c-.34.35-.89.48-1.84-.05a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C405.24,259.11,405.16,258.16,405.43,257.88Zm-8.07-5.19a.72.72,0,0,1,.35,0h0l.15,0,.09,0,.08,0,.05,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8,8,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0,0,0v0l0,.05-.06.09,0,.08,0,0-.05.05,0,0h0c-.36.37-1,.5-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C397.23,254.29,397.06,252.82,397.36,252.69Z",
    style: {
      fill: "#37474f"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M405.39,260a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c1,.53,1.5.4,1.84.05a1.92,1.92,0,0,1-1.37-.33,4.85,4.85,0,0,1-1.9-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.62.62,0,0,0-.39.13C405.16,258.16,405.24,259.11,405.39,260Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M397.36,255.07a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.65,1.73.52,2.09.15a2.26,2.26,0,0,1-1.61-.42,4.71,4.71,0,0,1-1-.84,5.77,5.77,0,0,1-1.31-3,7.61,7.61,0,0,1-.13-2.14.72.72,0,0,0-.35,0C397.06,252.82,397.23,254.29,397.36,255.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,260a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c1,.53,1.5.4,1.84.05l.05-.06.06-.07,0-.07,0-.06,0-.05s0,0,0-.05a.25.25,0,0,0,0-.07h0a1.36,1.36,0,0,0,.09-.23h0c0-.05,0-.1,0-.15a1.29,1.29,0,0,0,.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a5.5,5.5,0,0,0-.59-.23l-.23-.07-.58-.12h-.48a.62.62,0,0,0-.39.13C405.16,258.16,405.24,259.11,405.39,260Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,255.07a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.65,1.73.52,2.09.15h0l0,0,.05-.05,0,0,0-.08.06-.09,0-.05v0l0,0,0,0a3.14,3.14,0,0,0,.13-.45,3.66,3.66,0,0,0,0-2.13,8,8,0,0,0-2.27-2.33l-.64-.42-.08,0-.08-.05-.22-.12-.08,0-.11,0-.17-.08-.33-.12-.07,0h0l-.05,0-.08,0-.09,0-.15,0h0a.72.72,0,0,0-.35,0C397.06,252.82,397.23,254.29,397.36,255.07Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,244.64l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.74 242.14 414.39 254.64 414.39 256.25 392.74 243.75 392.74 242.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410,243.67a.43.43,0,0,0,.22-.06l7.59-4.38a1.78,1.78,0,0,1,2.66,1.54V241a.43.43,0,0,0,.86,0v-.19a2.64,2.64,0,0,0-3.95-2.28l-7.59,4.38a.43.43,0,0,0,.21.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,236.09A.42.42,0,0,0,397,236l7.59-4.38a1.77,1.77,0,0,1,2.66,1.54v.19a.43.43,0,0,0,.86,0v-.19a2.64,2.64,0,0,0-3.95-2.28l-7.59,4.38a.43.43,0,0,0-.15.59A.42.42,0,0,0,396.83,236.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43,234.81a13.34,13.34,0,0,0,.18,3.88c.41,2.41,1.76,4.78,3.44,5.75a2.22,2.22,0,0,0,1.46.35l0,.11.51-.3h0a2.71,2.71,0,0,0,1.05-2.46s.21-.76.68-.49.68,1.28.68,1.28a7.28,7.28,0,0,0,3.05,5.82,2.45,2.45,0,0,0,1.74.37l0,.1.53-.3h0a2.86,2.86,0,0,0,1.19-2c.24-1.1.46-3.28,0-4.29-.27-.61-2.54-1.94-3.43-2.32a2.29,2.29,0,0,0-2-.06h0l-.51.3.12,0a2.56,2.56,0,0,0-.51,1.06h0a2.8,2.8,0,0,0-.82-.93.77.77,0,0,0-.82,0h0a7.66,7.66,0,0,0-2.91-4.68c-.88-.65-3.06-1.88-3.42-1.67h0l-.49.28Zm8.72,8.52c0-1.73,1.06-2.53,2.36-1.78a5.63,5.63,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.77A5.63,5.63,0,0,1,405.15,243.33ZM397.7,239c0-1.73,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1,2.53-2.35,1.78A5.63,5.63,0,0,1,397.7,239Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,234.66c.36-.2,2.54,1,3.41,1.68a7.22,7.22,0,0,1,1,.89l.49-.28a7.14,7.14,0,0,0-1-.9c-.88-.65-3.06-1.88-3.42-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,240.59h0a2.19,2.19,0,0,1,2,0c.9.37,3.16,1.71,3.44,2.32l.49-.29c-.27-.6-2.54-1.94-3.43-2.32a2.29,2.29,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,241a.8.8,0,0,1,.76.05,1.21,1.21,0,0,1,.26.2l.5-.29-.26-.2a.77.77,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.54,241.23a2.85,2.85,0,0,1,.56.72h0a2.92,2.92,0,0,1,.25-.67,3.25,3.25,0,0,0-.31-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.27,249.2l.48-.28h0a2.86,2.86,0,0,0,1.19-2c.24-1.1.47-3.28,0-4.29l-.49.29c.46,1,.23,3.19,0,4.29A2.87,2.87,0,0,1,409.27,249.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.59,244.87l.46-.27a2.69,2.69,0,0,0,1-2.46,2.08,2.08,0,0,1,.1-.24c-.4-.14-.59.53-.59.53A2.75,2.75,0,0,1,401.59,244.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,237.23a7.77,7.77,0,0,1,1.9,3.78h.06l.44-.26a7.76,7.76,0,0,0-1.91-3.77Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,239c.41,2.42,1.75,4.79,3.43,5.76s3.05-.06,3.05-2.3c0,0,.21-.76.68-.49s.69,1.27.69,1.27a7.32,7.32,0,0,0,3,5.83c1.68,1,3,.14,3.44-1.79.23-1.1.46-3.28,0-4.29-.28-.61-2.54-2-3.44-2.32-1.29-.54-2.19-.24-2.66.65a2.92,2.92,0,0,0-.25.67h0a2.71,2.71,0,0,0-.82-.92.77.77,0,0,0-.82,0h0a7.62,7.62,0,0,0-2.91-4.68c-.89-.66-3.16-1.93-3.43-1.65C395.66,235.16,395.88,237.6,396.12,239Zm8.54,4.64c0-1.73,1-2.53,2.35-1.77a5.63,5.63,0,0,1,2.36,4.49c0,1.73-1.06,2.53-2.36,1.78A5.63,5.63,0,0,1,404.66,243.61Zm-7.46-4.3c0-1.74,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.36,4.5c0,1.73-1.06,2.52-2.36,1.77A5.62,5.62,0,0,1,397.2,239.31Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.24,243.41a.69.69,0,0,0-.29-.55c-.15-.09-.28,0-.28.22a.73.73,0,0,0,.28.55C410.11,243.72,410.24,243.62,410.24,243.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,235.5c0-.21.13-.31.28-.22a.69.69,0,0,1,.29.55c0,.21-.13.31-.29.21A.69.69,0,0,1,396.54,235.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,243.61a5.63,5.63,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.67,5.67,0,0,1-2.36-4.5,2.35,2.35,0,0,1,.58-1.73C405.09,241.79,404.66,242.51,404.66,243.61Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.2,239.31a5.66,5.66,0,0,0,2.35,4.5,1.43,1.43,0,0,0,1.78-.06,1.64,1.64,0,0,1-1.28-.23,5.65,5.65,0,0,1-2.36-4.5,2.32,2.32,0,0,1,.59-1.73C397.63,237.48,397.2,238.2,397.2,239.31Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.66,243.61a5.63,5.63,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.67,5.67,0,0,1-2.36-4.5,2.35,2.35,0,0,1,.58-1.73C405.09,241.79,404.66,242.51,404.66,243.61Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.2,239.31a5.66,5.66,0,0,0,2.35,4.5,1.43,1.43,0,0,0,1.78-.06,1.64,1.64,0,0,1-1.28-.23,5.65,5.65,0,0,1-2.36-4.5,2.32,2.32,0,0,1,.59-1.73C397.63,237.48,397.2,238.2,397.2,239.31Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407,248.11c1.3.75,2.36-.05,2.36-1.78a5.63,5.63,0,0,0-2.36-4.49c-1.3-.76-2.35,0-2.35,1.77A5.63,5.63,0,0,0,407,248.11Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,243.8c1.3.76,2.36,0,2.36-1.77a5.64,5.64,0,0,0-2.36-4.5c-1.3-.75-2.35.05-2.35,1.78A5.62,5.62,0,0,0,399.55,243.8Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,228l-13-7.51-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.74 225.53 414.39 238.04 414.39 239.64 392.74 227.14 392.74 225.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.45,229.34l.5-.28,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,229.34l.5-.28,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,225.65a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l0-.27A.78.78,0,0,0,419.14,225.65Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,225.65a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l0-.27A.78.78,0,0,0,419.14,225.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,229.62l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l0,.27a.87.87,0,0,0,.42.61h0a.92.92,0,0,0,.43.11,1,1,0,0,0,.45-.12.24.24,0,0,0,.12-.26l-.13-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.93,226.88a.85.85,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25.61.61,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,220.72l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,220.72l.5-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,217a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,404.19,217Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,217a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,404.19,217Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,221l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.11.91.91,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.13-.71a2.32,2.32,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,218.25a.93.93,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25.27.27,0,0,1-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M396.16,221.06s.29.08.44.83a25.92,25.92,0,0,0,.53,2.94,5.67,5.67,0,0,0,2.64,3.33,4.84,4.84,0,0,0,.91.43l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0,.08,0,.14-.08a1.79,1.79,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.46.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.49,1.49,0,0,0,.28-.11h0a1.52,1.52,0,0,0,.55-.62,13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.59,3.59,0,0,0,396.16,221.06Zm9.27,5.36a.56.56,0,0,1,.39-.14h.3l.18,0a5.26,5.26,0,0,1,.58.11l.23.07c.19.07.39.14.59.23a.61.61,0,0,1,.14.07,5.79,5.79,0,0,1,2.4,1.88,4.33,4.33,0,0,1,0,2.37v.1a1.2,1.2,0,0,1-.06.24s0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08a.08.08,0,0,1,0,0l0,.05a.21.21,0,0,1,0,.06.43.43,0,0,1,0,.07l-.06.07-.05.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C405.24,227.64,405.16,226.69,405.43,226.42Zm-8.07-5.2a.86.86,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8,8,0,0,1,2.27,2.34,3.65,3.65,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0,0,0v0l0,.05-.06.1,0,.07,0,0s0,0-.05.05l0,0h0c-.36.37-1,.51-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C397.23,222.82,397.06,221.36,397.36,221.22Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M402.06,228.54h0l.46-.26a1.66,1.66,0,0,0,.63-.68c.26-.45.32-1.16.51-1.55-.65-.21-.58,1.13-1,1.83A1.79,1.79,0,0,1,402.06,228.54Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M410.48,232.54a13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32l.05,0a.14.14,0,0,1,0,.07,13.1,13.1,0,0,1-.52,2.33,1.58,1.58,0,0,1-.56.63l-.47.27A1.52,1.52,0,0,0,410.48,232.54Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M411.51,228.41l.48-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.54,3.54,0,0,0,411.51,228.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,219.23l.85.37a18.57,18.57,0,0,1,4.27,2.59,25.8,25.8,0,0,0,2.59,2.44c.75.43,1.23.21,2.59.55a17.09,17.09,0,0,1,4.27,2.34c.31.21.6.43.85.62l-.48.27-.85-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,221.06s.29.08.44.83a25.92,25.92,0,0,0,.53,2.94,5.67,5.67,0,0,0,2.64,3.33,4.84,4.84,0,0,0,.91.43l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0,.08,0,.14-.08h0a1.79,1.79,0,0,0,.62-.66c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.46.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.49,1.49,0,0,0,.28-.11h0a1.52,1.52,0,0,0,.55-.62,13.32,13.32,0,0,0,.53-2.33c.15-.58.44-.32.44-.32a3.54,3.54,0,0,0,.06-1.48l-.85-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.59,3.59,0,0,0,396.16,221.06Zm9.27,5.36a.56.56,0,0,1,.39-.14h.3l.18,0a5.26,5.26,0,0,1,.58.11l.23.07c.19.07.39.14.59.23a.61.61,0,0,1,.14.07,5.79,5.79,0,0,1,2.4,1.88,4.33,4.33,0,0,1,0,2.37v.1a1.2,1.2,0,0,1-.06.24s0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08a.08.08,0,0,1,0,0l0,.05a.21.21,0,0,1,0,.06.43.43,0,0,1,0,.07l-.06.07-.05.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C405.24,227.64,405.16,226.69,405.43,226.42Zm-8.07-5.2a.86.86,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8,8,0,0,1,2.27,2.34,3.65,3.65,0,0,1,0,2.13,3,3,0,0,1-.13.44l0,0,0,0v0l0,.05-.06.1,0,.07,0,0s0,0-.05.05l0,0h0c-.36.37-1,.51-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C397.23,222.82,397.06,221.36,397.36,221.22Z",
    style: {
      fill: "#37474f"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M405.39,228.5a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c1,.53,1.5.4,1.84,0a1.92,1.92,0,0,1-1.37-.33,4.73,4.73,0,0,1-1.9-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.56.56,0,0,0-.39.14C405.16,226.69,405.24,227.64,405.39,228.5Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M397.36,223.6a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.66,1.73.52,2.09.15a2.21,2.21,0,0,1-1.61-.42,4.44,4.44,0,0,1-1-.84,5.74,5.74,0,0,1-1.31-3,7.61,7.61,0,0,1-.13-2.14.86.86,0,0,0-.35,0C397.06,221.36,397.23,222.82,397.36,223.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,228.5a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c1,.53,1.5.4,1.84,0l.05-.06.06-.07a.43.43,0,0,0,0-.07.21.21,0,0,0,0-.06l0-.05a.08.08,0,0,0,0,0l0-.08h0a1.17,1.17,0,0,0,.09-.24h0c0-.05,0-.1,0-.15a1.2,1.2,0,0,0,.06-.24V231a4.33,4.33,0,0,0,0-2.37,5.79,5.79,0,0,0-2.4-1.88.61.61,0,0,0-.14-.07c-.2-.09-.4-.16-.59-.23l-.23-.07a5.26,5.26,0,0,0-.58-.11l-.18,0h-.3a.56.56,0,0,0-.39.14C405.16,226.69,405.24,227.64,405.39,228.5Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,223.6a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.66,1.73.52,2.09.15h0l0,0s0,0,.05-.05l0,0,0-.07.06-.1,0-.05v0l0,0,0,0a3,3,0,0,0,.13-.44,3.65,3.65,0,0,0,0-2.13,8,8,0,0,0-2.27-2.34l-.64-.42-.08,0-.08-.05-.22-.12-.08,0-.11,0-.17-.08-.33-.12-.07,0h-.07l-.08,0-.09,0-.15,0h0a.86.86,0,0,0-.35,0C397.06,221.36,397.23,222.82,397.36,223.6Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,213l-13-7.51-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.74 210.53 414.39 223.04 414.39 224.64 392.74 212.14 392.74 210.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.62,205.41l7.12-4.1a2.39,2.39,0,0,1,3.58,2.07v.25a.35.35,0,0,1-.69,0v-.25a1.68,1.68,0,0,0-.85-1.48,1.72,1.72,0,0,0-1.7,0L397,206a.36.36,0,0,1-.47-.13A.35.35,0,0,1,396.62,205.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.57,208.81a1.19,1.19,0,0,1,.56-.12,4.39,4.39,0,0,1,2.14.77,6.09,6.09,0,0,1,3.16,4.82c.16,2.16-.36,3.54-1,3.93l.43-.25c.64-.36,1.18-1.76,1-4a6.14,6.14,0,0,0-3.17-4.82,4.39,4.39,0,0,0-2.14-.77,1.24,1.24,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.83,212.09l.47-.26a5.68,5.68,0,0,1,.6,2.18c.16,2.19-.38,3.59-1,4l-.43.25c.62-.39,1.14-1.77,1-3.93A5.56,5.56,0,0,0,409.83,212.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.57,208.81a1.19,1.19,0,0,1,.56-.12,4.39,4.39,0,0,1,2.14.77,6.76,6.76,0,0,1,2.56,2.63l.47-.26a6.88,6.88,0,0,0-2.57-2.64,4.39,4.39,0,0,0-2.14-.77,1.24,1.24,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.78,204.42a1.25,1.25,0,0,1,.66-.17,4.19,4.19,0,0,1,1.8.57,6.46,6.46,0,0,1,3,3,4.11,4.11,0,0,1-1.21,4l-.18.11.41-.23h0l.21-.14a4.12,4.12,0,0,0,1.22-4,6.52,6.52,0,0,0-3-3,4.08,4.08,0,0,0-1.79-.58,1.25,1.25,0,0,0-.66.17l-.44.25Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.2,207.86a3.59,3.59,0,0,0-.15-.37l.46-.27a2.76,2.76,0,0,1,.16.37,4.12,4.12,0,0,1-1.22,4l-.21.14h0l-.41.23.18-.11A4.11,4.11,0,0,0,402.2,207.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.37,210.39a.12.12,0,0,0,.1-.06.11.11,0,0,0-.05-.15l-.16-.1V210a.75.75,0,0,0-.33-.61l-.86-.5a.28.28,0,0,0-.29,0,.35.35,0,0,0-.15.3l-.05,0a.12.12,0,0,0-.16,0,.11.11,0,0,0,0,.15l.4.23v-.38c0-.08,0-.11,0-.12a.1.1,0,0,1,.06,0l.86.5a.52.52,0,0,1,.21.41v.24l.28.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,211.09a11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.81-.17.51.51,0,0,1-.35-.1,9.17,9.17,0,0,1-2.63-3.24,11.83,11.83,0,0,1-1.13-3.16,4.79,4.79,0,0,1-.12-1.55h-.1c-.21,0-.31.05-.32.08A3.58,3.58,0,0,0,404.89,211.09Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.89,211.09a11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.81-.17.51.51,0,0,1-.35-.1,9.17,9.17,0,0,1-2.63-3.24,11.83,11.83,0,0,1-1.13-3.16,4.79,4.79,0,0,1-.12-1.55h-.1c-.21,0-.31.05-.32.08A3.58,3.58,0,0,0,404.89,211.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,210.91a2.22,2.22,0,0,0,1.81.92,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.77.15,2.19,2.19,0,0,1-1.81-.92,8.83,8.83,0,0,1-1-4.87,2,2,0,0,1,.26-1c-.25,0-.63.13-.72,1.21A8.87,8.87,0,0,0,397.63,210.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,210.91a2.22,2.22,0,0,0,1.81.92,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.77.15,2.19,2.19,0,0,1-1.81-.92,8.83,8.83,0,0,1-1-4.87,2,2,0,0,1,.26-1c-.25,0-.63.13-.72,1.21A8.87,8.87,0,0,0,397.63,210.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.13,209.26a4,4,0,0,1,1.84.68,5.48,5.48,0,0,1,2.89,4.38,5.94,5.94,0,0,1-.36,2.93.58.58,0,0,1-.85.24,9.13,9.13,0,0,1-2.63-3.25,11.77,11.77,0,0,1-1.13-3.15,3.58,3.58,0,0,1-.08-1.75s.11-.08.32-.08Zm0-.57a.86.86,0,0,0-.83.38c-.35.68,0,3.19,1.22,5.44s2.86,3.78,3.64,3.78a.45.45,0,0,0,.2,0c.66-.3,1.24-1.71,1.07-4a6.09,6.09,0,0,0-3.16-4.82,4.39,4.39,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,204.82a3.56,3.56,0,0,1,1.53.51,5.89,5.89,0,0,1,2.69,2.71,3.55,3.55,0,0,1-1,3.39,2,2,0,0,1-1.21.4,2.21,2.21,0,0,1-1.81-.92,8.87,8.87,0,0,1-1-4.88c.1-1.21.58-1.21.8-1.21Zm0-.57c-.7,0-1.26.43-1.37,1.74a9.4,9.4,0,0,0,1.08,5.22,2.76,2.76,0,0,0,2.29,1.19,2.6,2.6,0,0,0,1.55-.5,4.11,4.11,0,0,0,1.21-4,6.41,6.41,0,0,0-3-3,4.19,4.19,0,0,0-1.8-.57Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,204.25a1.25,1.25,0,0,0-.66.17l0,0,.44-.25a1.25,1.25,0,0,1,.66-.17,4.08,4.08,0,0,1,1.79.58,7,7,0,0,1,2.81,2.66l-.46.27a7.07,7.07,0,0,0-2.81-2.67A4.19,4.19,0,0,0,397.44,204.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.57,213.41l7.13-4.1a2.39,2.39,0,0,1,3.58,2.06v.26a.35.35,0,0,1-.69,0v-.26a1.69,1.69,0,0,0-.85-1.47,1.67,1.67,0,0,0-1.7,0l-7.12,4.1a.37.37,0,0,1-.17.05.35.35,0,0,1-.3-.17A.34.34,0,0,1,410.57,213.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.44,204.82h0c-.22,0-.7,0-.8,1.21a8.87,8.87,0,0,0,1,4.88,2.21,2.21,0,0,0,1.81.92,2,2,0,0,0,1.21-.4,3.55,3.55,0,0,0,1-3.39,5.89,5.89,0,0,0-2.69-2.71,3.56,3.56,0,0,0-1.53-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.13,209.26c-.21,0-.31.05-.32.08a3.58,3.58,0,0,0,.08,1.75,11.77,11.77,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.85-.24,5.94,5.94,0,0,0,.36-2.93,5.48,5.48,0,0,0-2.89-4.38,4,4,0,0,0-1.84-.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59,209.5a.14.14,0,0,0,.1-.05.11.11,0,0,0,0-.16,72.93,72.93,0,0,0-8-4.65.12.12,0,0,0-.15.06.11.11,0,0,0,.05.15,71.81,71.81,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414.39,198l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.74 195.53 414.39 208.03 414.39 209.64 392.74 197.14 392.74 195.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.45,199l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.45,199l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.9,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,195.33a1.3,1.3,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.85.85,0,0,1-.42-.61l0-.27A.78.78,0,0,0,419.14,195.33Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.14,195.33a1.3,1.3,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.85.85,0,0,1-.42-.61l0-.27A.78.78,0,0,0,419.14,195.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,199.3l6.64-3.83a.9.9,0,0,1,.57-.14.78.78,0,0,1,.65.7l0,.27a.85.85,0,0,0,.42.61h0a.82.82,0,0,0,.43.12,1,1,0,0,0,.45-.12.26.26,0,0,0,.12-.26l-.13-.72a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.93,196.56a.8.8,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25.36.36,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,190.4l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,190.4l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,186.7a1.12,1.12,0,0,1,.18.43l0,.27a.85.85,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.88.88,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,404.19,186.7Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,186.7a1.12,1.12,0,0,1,.18.43l0,.27a.85.85,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.88.88,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,404.19,186.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,190.67l6.64-3.83a.9.9,0,0,1,.57-.14.78.78,0,0,1,.65.7l.05.27a.88.88,0,0,0,.42.61h0a.83.83,0,0,0,.44.12.91.91,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.13-.72a2.28,2.28,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,187.93a.86.86,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25.21.21,0,0,1-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M396.16,190.75s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.65,5.65,0,0,0,2.64,3.34,4.19,4.19,0,0,0,.91.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.07a1.82,1.82,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09a3.22,3.22,0,0,0,.42.16l.14,0a.27.27,0,0,0,.12,0l.08,0a1.6,1.6,0,0,0,.48,0h0l.16,0h0a.78.78,0,0,0,.28-.11h0a1.48,1.48,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37A3.63,3.63,0,0,0,396.16,190.75Zm9.27,5.35a.62.62,0,0,1,.39-.14h.3l.18,0a3.76,3.76,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,.05l0,0a.21.21,0,0,1,0,.06l0,.06-.06.07-.05.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74C405.24,197.33,405.16,196.38,405.43,196.1Zm-8.07-5.19a.61.61,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.13.17.07.11.05a.2.2,0,0,0,.08,0l.22.13.08,0,.08,0c.19.11.41.25.64.41a8,8,0,0,1,2.27,2.34,3.66,3.66,0,0,1,0,2.13,2.71,2.71,0,0,1-.13.44l0,0,0,0v0s0,0,0,0l-.06.1a.35.35,0,0,0,0,.08l0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.64,4.64,0,0,1-1-.84,5.77,5.77,0,0,1-1.32-3C397.23,192.51,397.06,191,397.36,190.91Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M402.06,198.23h0l.46-.26a1.79,1.79,0,0,0,.63-.68c.26-.45.32-1.16.51-1.56-.65-.21-.58,1.13-1,1.83A1.82,1.82,0,0,1,402.06,198.23Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M410.48,202.22a13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31l.05,0a.25.25,0,0,1,0,.07A13.1,13.1,0,0,1,411,202a1.65,1.65,0,0,1-.56.63l-.47.27A1.48,1.48,0,0,0,410.48,202.22Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M411.51,198.1l.48-.28a3.54,3.54,0,0,1-.06,1.48l-.43.25-.05,0A3.54,3.54,0,0,0,411.51,198.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,188.92l.85.36a18.93,18.93,0,0,1,4.27,2.59,24.64,24.64,0,0,0,2.59,2.44c.75.44,1.23.22,2.59.56a17,17,0,0,1,4.27,2.33l.85.62-.48.28c-.25-.2-.54-.41-.85-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,190.75s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.65,5.65,0,0,0,2.64,3.34,4.19,4.19,0,0,0,.91.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.07h0a1.82,1.82,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.09a3.22,3.22,0,0,0,.42.16l.14,0a.27.27,0,0,0,.12,0l.08,0a1.6,1.6,0,0,0,.48,0h0l.16,0h0a.78.78,0,0,0,.28-.11h0a1.48,1.48,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.54,3.54,0,0,0,.06-1.48c-.25-.2-.54-.41-.85-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37A3.63,3.63,0,0,0,396.16,190.75Zm9.27,5.35a.62.62,0,0,1,.39-.14h.3l.18,0a3.76,3.76,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0l0,.08s0,0,0,.05l0,0a.21.21,0,0,1,0,.06l0,.06-.06.07-.05.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74C405.24,197.33,405.16,196.38,405.43,196.1Zm-8.07-5.19a.61.61,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.13.17.07.11.05a.2.2,0,0,0,.08,0l.22.13.08,0,.08,0c.19.11.41.25.64.41a8,8,0,0,1,2.27,2.34,3.66,3.66,0,0,1,0,2.13,2.71,2.71,0,0,1-.13.44l0,0,0,0v0s0,0,0,0l-.06.1a.35.35,0,0,0,0,.08l0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.64,4.64,0,0,1-1-.84,5.77,5.77,0,0,1-1.32-3C397.23,192.51,397.06,191,397.36,190.91Z",
    style: {
      fill: "#37474f"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M405.39,198.19a5.52,5.52,0,0,0,.6,1.74h0a5,5,0,0,0,1.91,1.9c1,.54,1.5.4,1.84.06a2,2,0,0,1-1.37-.33,4.81,4.81,0,0,1-1.9-1.91h0a5.44,5.44,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.62.62,0,0,0-.39.14C405.16,196.38,405.24,197.33,405.39,198.19Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M397.36,193.28a5.77,5.77,0,0,0,1.32,3,4.64,4.64,0,0,0,1,.84c1.11.65,1.73.51,2.09.15a2.23,2.23,0,0,1-1.61-.43,4.2,4.2,0,0,1-1-.84,5.75,5.75,0,0,1-1.31-3,7.65,7.65,0,0,1-.13-2.14.61.61,0,0,0-.35,0C397.06,191,397.23,192.51,397.36,193.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,198.19a5.52,5.52,0,0,0,.6,1.74h0a5,5,0,0,0,1.91,1.9c1,.54,1.5.4,1.84.06l.05-.07.06-.07,0-.06a.21.21,0,0,0,0-.06l0,0s0,0,0-.05l0-.08h0a1.17,1.17,0,0,0,.09-.24h0c0-.05,0-.1,0-.15a1.29,1.29,0,0,0,.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,5.79,5.79,0,0,0-2.4-1.88l-.14-.06a5.5,5.5,0,0,0-.59-.23l-.23-.07a3.76,3.76,0,0,0-.58-.12l-.18,0h-.3a.62.62,0,0,0-.39.14C405.16,196.38,405.24,197.33,405.39,198.19Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,193.28a5.77,5.77,0,0,0,1.32,3,4.64,4.64,0,0,0,1,.84c1.11.65,1.73.51,2.09.15h0l0,0,.05-.05,0,0a.35.35,0,0,1,0-.08l.06-.1s0,0,0,0v0l0,0,0,0a2.71,2.71,0,0,0,.13-.44,3.66,3.66,0,0,0,0-2.13,8,8,0,0,0-2.27-2.34c-.23-.16-.45-.3-.64-.41l-.08,0-.08,0-.22-.13a.2.2,0,0,1-.08,0l-.11-.05-.17-.07-.33-.13-.07,0h-.07l-.08,0-.09,0-.15,0h0a.61.61,0,0,0-.35,0C397.06,191,397.23,192.51,397.36,193.28Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "440.37 269.65 418.72 257.14 418.72 182.14 440.37 194.64 440.37 269.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.38 252.14 427.38 187.14 418.72 182.14 418.72 257.14 427.38 252.14",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 257.14 427.38 252.14 440.37 259.64 440.37 269.65 418.72 257.14",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.43,260.81l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,260.81l.5-.29,0-.91,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,257.12a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,445.12,257.12Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,257.12a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.83.83,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,445.12,257.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,261.09l6.64-3.84a.88.88,0,0,1,.57-.13.76.76,0,0,1,.65.69l.05.27a.83.83,0,0,0,.42.61h0a.82.82,0,0,0,.43.12,1,1,0,0,0,.45-.12.25.25,0,0,0,.12-.26l-.13-.71a2.31,2.31,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,258.35a.9.9,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25l-.07-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,252.18l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,252.18l.5-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,248.49a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,430.17,248.49Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,248.49a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.61l-.05-.27A.76.76,0,0,0,430.17,248.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,252.46l6.64-3.84a.88.88,0,0,1,.57-.13.76.76,0,0,1,.65.69l.05.27a.86.86,0,0,0,.42.61h0a.83.83,0,0,0,.44.12.91.91,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.13-.71a2.3,2.3,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14L423,251l0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,249.72a.9.9,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25.3.3,0,0,1-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M422.14,252.53s.29.08.44.83a25.77,25.77,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a2.33,2.33,0,0,0,.74.1h.17s0,0,0,0h.08l.08,0,.08,0A.61.61,0,0,0,428,260a1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.82l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.35,6.35,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0H435a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.48,1.48,0,0,0,.55-.63,13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.63,3.63,0,0,0,.07-1.48l-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,422.14,252.53Zm9.27,5.35a.56.56,0,0,1,.39-.13h.48a5.48,5.48,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0a.2.2,0,0,1,0,.08s0,0,0,.05l0,.05,0,.06,0,.07-.06.06a.18.18,0,0,1,0,.07c-.34.34-.89.48-1.84-.05a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C431.22,259.11,431.14,258.16,431.41,257.88Zm-8.07-5.19a.72.72,0,0,1,.35,0h0l.15,0,.09,0,.08,0,0,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08,0,.08,0,.64.42a8,8,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0,0,0v0s0,0,0,.05l-.06.09a.56.56,0,0,1-.05.08l0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.38,4.38,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C423.21,254.29,423,252.82,423.34,252.69Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M428,260h0l.46-.26a1.72,1.72,0,0,0,.63-.68c.26-.45.32-1.16.51-1.55-.65-.21-.58,1.12-1,1.82A1.74,1.74,0,0,1,428,260Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M436.46,264a13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32l.05,0a.19.19,0,0,1,0,.07,13.1,13.1,0,0,1-.52,2.33,1.51,1.51,0,0,1-.56.63l-.47.27A1.48,1.48,0,0,0,436.46,264Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M437.5,259.88l.47-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.63,3.63,0,0,0,437.5,259.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.55,250.7l.85.37a18.23,18.23,0,0,1,4.27,2.59,25.8,25.8,0,0,0,2.59,2.44c.75.43,1.23.21,2.59.55a17.17,17.17,0,0,1,4.27,2.33c.31.22.6.43.85.63l-.47.27-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14,252.53s.29.08.44.83a25.77,25.77,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a2.33,2.33,0,0,0,.74.1h.17s0,0,0,0h.08l.08,0,.08,0A.61.61,0,0,0,428,260h0a1.74,1.74,0,0,0,.62-.67c.4-.7.33-2,1-1.82l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.35,6.35,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0H435a1.6,1.6,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.48,1.48,0,0,0,.55-.63,13.21,13.21,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.63,3.63,0,0,0,.07-1.48l-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.6-.55a24.64,24.64,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,422.14,252.53Zm9.27,5.35a.56.56,0,0,1,.39-.13h.48a5.48,5.48,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a6,6,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0a.2.2,0,0,1,0,.08s0,0,0,.05l0,.05,0,.06,0,.07-.06.06a.18.18,0,0,1,0,.07c-.34.34-.89.48-1.84-.05a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C431.22,259.11,431.14,258.16,431.41,257.88Zm-8.07-5.19a.72.72,0,0,1,.35,0h0l.15,0,.09,0,.08,0,0,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08,0,.08,0,.64.42a8,8,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,3.14,3.14,0,0,1-.13.45l0,0,0,0v0s0,0,0,.05l-.06.09a.56.56,0,0,1-.05.08l0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.38,4.38,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C423.21,254.29,423,252.82,423.34,252.69Z",
    style: {
      fill: "#37474f"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M431.37,260a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.39,1.84.05a1.92,1.92,0,0,1-1.37-.33,4.85,4.85,0,0,1-1.9-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.56.56,0,0,0-.39.13C431.14,258.16,431.22,259.11,431.37,260Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M423.34,255.07a5.78,5.78,0,0,0,1.32,3,4.38,4.38,0,0,0,1,.84c1.11.65,1.73.51,2.09.15a2.26,2.26,0,0,1-1.61-.42,4.71,4.71,0,0,1-1-.84,5.77,5.77,0,0,1-1.31-3,7.63,7.63,0,0,1-.13-2.14.72.72,0,0,0-.35,0C423,252.82,423.21,254.29,423.34,255.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,260a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.39,1.84.05a.18.18,0,0,0,0-.07l.06-.06,0-.07,0-.06,0-.05s0,0,0-.05a.2.2,0,0,0,0-.08h0a1.17,1.17,0,0,0,.09-.24h0c0-.05,0-.1,0-.15a1.29,1.29,0,0,0,.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,6,6,0,0,0-2.4-1.88l-.14-.06a5.5,5.5,0,0,0-.59-.23l-.23-.07a5.48,5.48,0,0,0-.58-.12h-.48a.56.56,0,0,0-.39.13C431.14,258.16,431.22,259.11,431.37,260Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34,255.07a5.78,5.78,0,0,0,1.32,3,4.38,4.38,0,0,0,1,.84c1.11.65,1.73.51,2.09.15h0l0,0,.05-.05,0,0a.56.56,0,0,0,.05-.08l.06-.09s0,0,0-.05v0l0,0,0,0a3.14,3.14,0,0,0,.13-.45,3.66,3.66,0,0,0,0-2.13,8,8,0,0,0-2.27-2.33l-.64-.42-.08,0-.08,0-.22-.12-.08,0-.11,0-.17-.08-.33-.12-.07,0h0l0,0-.08,0-.09,0-.15,0h0a.72.72,0,0,0-.35,0C423,252.82,423.21,254.29,423.34,255.07Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,244.64l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 242.14 440.37 254.64 440.37 256.25 418.72 243.75 418.72 242.14",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.93,243.67a.43.43,0,0,0,.22-.06l7.59-4.38a1.77,1.77,0,0,1,2.66,1.54V241a.43.43,0,0,0,.86,0v-.19a2.64,2.64,0,0,0-3.95-2.28l-7.59,4.38a.43.43,0,0,0,.21.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.81,236.09A.42.42,0,0,0,423,236l7.59-4.38a1.77,1.77,0,0,1,2.66,1.54v.19a.43.43,0,0,0,.43.42.42.42,0,0,0,.43-.42v-.19a2.64,2.64,0,0,0-3.95-2.28l-7.59,4.38a.43.43,0,0,0-.15.59A.42.42,0,0,0,422.81,236.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,234.81a13.34,13.34,0,0,0,.18,3.88c.41,2.41,1.76,4.78,3.44,5.75a2.22,2.22,0,0,0,1.46.35l0,.11.51-.3h0a2.71,2.71,0,0,0,1.05-2.46s.21-.76.68-.49.68,1.28.68,1.28a7.28,7.28,0,0,0,3.05,5.82,2.45,2.45,0,0,0,1.74.37l0,.1.53-.3h0a2.88,2.88,0,0,0,1.19-2c.24-1.1.47-3.28,0-4.29-.27-.61-2.54-1.94-3.43-2.32a2.29,2.29,0,0,0-2-.06h0l-.51.3.12,0a2.56,2.56,0,0,0-.51,1.06h0a2.8,2.8,0,0,0-.82-.93.77.77,0,0,0-.82,0h0a7.63,7.63,0,0,0-2.91-4.68c-.88-.65-3.06-1.88-3.42-1.67h0l-.49.28Zm8.72,8.52c0-1.74,1.06-2.53,2.36-1.78a5.63,5.63,0,0,1,2.35,4.5c0,1.73-1,2.52-2.35,1.77A5.63,5.63,0,0,1,431.13,243.33ZM423.68,239c0-1.73,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.64,5.64,0,0,1,423.68,239Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.12,234.66c.36-.2,2.54,1,3.41,1.67a7.29,7.29,0,0,1,1,.9L427,237a6.62,6.62,0,0,0-1-.9c-.88-.65-3.06-1.88-3.42-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,240.59h0a2.19,2.19,0,0,1,2,0c.9.37,3.16,1.71,3.44,2.32l.49-.29c-.27-.61-2.54-1.94-3.43-2.32a2.29,2.29,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.5,241a.81.81,0,0,1,.76.06,1.21,1.21,0,0,1,.26.2l.5-.29a1.64,1.64,0,0,0-.26-.2.77.77,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.52,241.23a2.85,2.85,0,0,1,.56.72h0a3,3,0,0,1,.25-.66,2.51,2.51,0,0,0-.31-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.25,249.2l.48-.28h0a2.88,2.88,0,0,0,1.19-2c.24-1.1.47-3.28,0-4.29l-.49.29c.46,1,.23,3.19,0,4.29A2.87,2.87,0,0,1,435.25,249.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57,244.87l.46-.27a2.71,2.71,0,0,0,1.05-2.46,1,1,0,0,1,.1-.24c-.41-.14-.6.53-.6.53A2.75,2.75,0,0,1,427.57,244.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.54,237.23a7.64,7.64,0,0,1,1.9,3.78h0l0,0,.44-.25A7.76,7.76,0,0,0,427,237Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.1,239c.41,2.41,1.75,4.79,3.43,5.76s3.05-.06,3.05-2.31c0,0,.21-.75.68-.48s.69,1.27.69,1.27a7.28,7.28,0,0,0,3,5.82c1.68,1,3,.15,3.44-1.78.23-1.1.46-3.28,0-4.29-.28-.61-2.54-2-3.44-2.32-1.29-.54-2.19-.24-2.66.65a3,3,0,0,0-.25.66h0a2.71,2.71,0,0,0-.82-.92.77.77,0,0,0-.82,0h0a7.62,7.62,0,0,0-2.91-4.68c-.89-.66-3.16-1.94-3.43-1.65C421.64,235.16,421.86,237.6,422.1,239Zm8.54,4.64c0-1.73,1.05-2.53,2.35-1.78a5.65,5.65,0,0,1,2.36,4.5c0,1.73-1.06,2.53-2.36,1.78A5.63,5.63,0,0,1,430.64,243.61Zm-7.46-4.3c0-1.74,1.05-2.53,2.35-1.78a5.63,5.63,0,0,1,2.36,4.49c0,1.74-1.06,2.53-2.36,1.78A5.62,5.62,0,0,1,423.18,239.31Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,243.41a.69.69,0,0,0-.29-.55c-.15-.09-.28,0-.28.22a.69.69,0,0,0,.28.54C436.09,243.72,436.22,243.62,436.22,243.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.52,235.5c0-.21.13-.31.28-.22a.69.69,0,0,1,.29.55c0,.21-.13.31-.29.21A.69.69,0,0,1,422.52,235.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.64,243.61a5.63,5.63,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.78-.05,1.65,1.65,0,0,1-1.28-.24,5.63,5.63,0,0,1-2.36-4.49,2.35,2.35,0,0,1,.58-1.73C431.07,241.79,430.64,242.51,430.64,243.61Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.18,239.31a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.64,5.64,0,0,1-2.35-4.5,2.32,2.32,0,0,1,.58-1.73C423.61,237.48,423.18,238.2,423.18,239.31Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.64,243.61a5.63,5.63,0,0,0,2.35,4.5,1.42,1.42,0,0,0,1.78-.05,1.65,1.65,0,0,1-1.28-.24,5.63,5.63,0,0,1-2.36-4.49,2.35,2.35,0,0,1,.58-1.73C431.07,241.79,430.64,242.51,430.64,243.61Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.18,239.31a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.64,5.64,0,0,1-2.35-4.5,2.32,2.32,0,0,1,.58-1.73C423.61,237.48,423.18,238.2,423.18,239.31Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M433,248.11c1.3.75,2.36-.05,2.36-1.78a5.65,5.65,0,0,0-2.36-4.5c-1.3-.75-2.35,0-2.35,1.78A5.63,5.63,0,0,0,433,248.11Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.53,243.8c1.3.75,2.36,0,2.36-1.78a5.63,5.63,0,0,0-2.36-4.49c-1.3-.75-2.35,0-2.35,1.78A5.62,5.62,0,0,0,425.53,243.8Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,228l-13-7.51-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 225.53 440.37 238.04 440.37 239.64 418.72 227.14 418.72 225.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.43,229.34l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,229.34l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,225.65a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.26a.84.84,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,445.12,225.65Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,225.65a1.16,1.16,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.26a.84.84,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,445.12,225.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,229.62l6.64-3.84a1,1,0,0,1,.57-.13.77.77,0,0,1,.65.7l.05.27a.84.84,0,0,0,.42.6l0,0a.92.92,0,0,0,.43.11,1,1,0,0,0,.45-.12.25.25,0,0,0,.12-.26l-.13-.71a2.33,2.33,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,226.88a.9.9,0,0,0,.33.34l-.46-.26a.84.84,0,0,1-.28-.25.61.61,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,220.71l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,220.71l.5-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,217a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,430.17,217Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,217a1,1,0,0,1,.18.42l0,.27a1,1,0,0,0,.16.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,430.17,217Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,221l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.11.91.91,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.13-.71a2.32,2.32,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,218.25a.93.93,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25.27.27,0,0,1-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M422.14,221.06s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0a.13.13,0,0,0,.08,0l.14-.07a1.79,1.79,0,0,0,.62-.66c.4-.71.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.82,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.48,1.48,0,0,0,.55-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.63,3.63,0,0,0,.07-1.48l-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,422.14,221.06Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a5.5,5.5,0,0,1,.59.23l.14.07a5.88,5.88,0,0,1,2.4,1.87,4.37,4.37,0,0,1,0,2.38v.1a1.4,1.4,0,0,1-.06.24s0,.1,0,.15h0a.92.92,0,0,1-.09.23h0a.25.25,0,0,1,0,.07s0,0,0,0l0,.05,0,.06a.43.43,0,0,1,0,.07l-.06.07,0,.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C431.22,227.64,431.14,226.69,431.41,226.41Zm-8.07-5.19a.86.86,0,0,1,.35,0h0l.15,0,.09,0,.08,0,0,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8.09,8.09,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,2.81,2.81,0,0,1-.13.45l0,0a.08.08,0,0,1,0,0v0l0,.05-.06.09a.56.56,0,0,1-.05.08l0,0-.05.05a.08.08,0,0,1,0,0h0c-.36.37-1,.51-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C423.21,222.82,423,221.36,423.34,221.22Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M428,228.54h0l.46-.26a1.66,1.66,0,0,0,.63-.68c.26-.45.32-1.16.51-1.55-.65-.21-.58,1.12-1,1.83A1.79,1.79,0,0,1,428,228.54Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M436.46,232.53a13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32l.05,0a.14.14,0,0,1,0,.07,13.1,13.1,0,0,1-.52,2.33,1.51,1.51,0,0,1-.56.63l-.47.27A1.48,1.48,0,0,0,436.46,232.53Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M437.5,228.41l.47-.27a3.54,3.54,0,0,1-.06,1.48l-.43.24-.05,0A3.63,3.63,0,0,0,437.5,228.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.55,219.23l.85.37a18.57,18.57,0,0,1,4.27,2.59,25.8,25.8,0,0,0,2.59,2.44c.75.43,1.23.21,2.59.55a16.92,16.92,0,0,1,4.27,2.34c.31.21.6.43.85.62l-.47.27-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14,221.06s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.65,5.65,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a1.87,1.87,0,0,0,.74.1h.19l.08,0,.08,0a.13.13,0,0,0,.08,0l.14-.07h0a1.79,1.79,0,0,0,.62-.66c.4-.71.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.82,1.13,3.06a6.33,6.33,0,0,0,2.91,3.66l.23.12.18.09a3.37,3.37,0,0,0,.42.17l.14,0,.12,0,.08,0a1.57,1.57,0,0,0,.48,0h0l.16,0h0a1.69,1.69,0,0,0,.27-.11h0a1.48,1.48,0,0,0,.55-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.63,3.63,0,0,0,.07-1.48l-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.35-1.84-.12-2.6-.56a24.64,24.64,0,0,1-2.59-2.44,18.64,18.64,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,422.14,221.06Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a5.5,5.5,0,0,1,.59.23l.14.07a5.88,5.88,0,0,1,2.4,1.87,4.37,4.37,0,0,1,0,2.38v.1a1.4,1.4,0,0,1-.06.24s0,.1,0,.15h0a.92.92,0,0,1-.09.23h0a.25.25,0,0,1,0,.07s0,0,0,0l0,.05,0,.06a.43.43,0,0,1,0,.07l-.06.07,0,.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C431.22,227.64,431.14,226.69,431.41,226.41Zm-8.07-5.19a.86.86,0,0,1,.35,0h0l.15,0,.09,0,.08,0,0,0h0l.07,0,.33.12.17.08.11,0,.08,0,.22.12.08.05.08,0,.64.42a8.09,8.09,0,0,1,2.27,2.33,3.66,3.66,0,0,1,0,2.13,2.81,2.81,0,0,1-.13.45l0,0a.08.08,0,0,1,0,0v0l0,.05-.06.09a.56.56,0,0,1-.05.08l0,0-.05.05a.08.08,0,0,1,0,0h0c-.36.37-1,.51-2.09-.15a4.15,4.15,0,0,1-1-.84,5.78,5.78,0,0,1-1.32-3C423.21,222.82,423,221.36,423.34,221.22Z",
    style: {
      fill: "#37474f"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M431.37,228.5a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.4,1.84,0a1.92,1.92,0,0,1-1.37-.33,4.85,4.85,0,0,1-1.9-1.9h0a5.52,5.52,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.62.62,0,0,0-.39.13C431.14,226.69,431.22,227.64,431.37,228.5Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M423.34,223.6a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.66,1.73.52,2.09.15a2.21,2.21,0,0,1-1.61-.42,4.71,4.71,0,0,1-1-.84,5.74,5.74,0,0,1-1.31-3,7.61,7.61,0,0,1-.13-2.14.86.86,0,0,0-.35,0C423,221.36,423.21,222.82,423.34,223.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,228.5a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.4,1.84,0l0-.06.06-.07a.43.43,0,0,0,0-.07l0-.06,0-.05s0,0,0,0a.25.25,0,0,0,0-.07h0a.92.92,0,0,0,.09-.23h0c0-.05,0-.1,0-.15a1.4,1.4,0,0,0,.06-.24V231a4.37,4.37,0,0,0,0-2.38,5.88,5.88,0,0,0-2.4-1.87l-.14-.07a5.5,5.5,0,0,0-.59-.23l-.23-.07-.58-.12h-.48a.62.62,0,0,0-.39.13C431.14,226.69,431.22,227.64,431.37,228.5Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34,223.6a5.78,5.78,0,0,0,1.32,3,4.15,4.15,0,0,0,1,.84c1.11.66,1.73.52,2.09.15h0a.08.08,0,0,0,0,0l.05-.05,0,0a.56.56,0,0,0,.05-.08l.06-.09,0-.05v0a.08.08,0,0,0,0,0l0,0a2.81,2.81,0,0,0,.13-.45,3.66,3.66,0,0,0,0-2.13,8.09,8.09,0,0,0-2.27-2.33l-.64-.42-.08,0-.08-.05-.22-.12-.08,0-.11,0-.17-.08-.33-.12-.07,0h0l0,0-.08,0-.09,0-.15,0h0a.86.86,0,0,0-.35,0C423,221.36,423.21,222.82,423.34,223.6Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,213l-13-7.51-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 210.53 440.37 223.04 440.37 224.64 418.72 212.14 418.72 210.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.6,205.41l7.12-4.1a2.39,2.39,0,0,1,3.58,2.07v.25a.35.35,0,0,1-.69,0v-.25a1.7,1.7,0,0,0-2.55-1.48L422.94,206a.36.36,0,0,1-.47-.13A.35.35,0,0,1,422.6,205.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.55,208.81a1.19,1.19,0,0,1,.56-.12,4.29,4.29,0,0,1,2.14.77,6.09,6.09,0,0,1,3.16,4.82c.16,2.16-.36,3.54-1,3.93l.43-.25c.64-.36,1.18-1.76,1-4a6.14,6.14,0,0,0-3.17-4.82,4.39,4.39,0,0,0-2.14-.77,1.24,1.24,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,212.09l.47-.27a5.79,5.79,0,0,1,.6,2.19c.16,2.19-.38,3.59-1,4l-.43.25c.62-.39,1.14-1.77,1-3.93A5.56,5.56,0,0,0,435.81,212.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.55,208.81a1.19,1.19,0,0,1,.56-.12,4.29,4.29,0,0,1,2.14.77,6.76,6.76,0,0,1,2.56,2.63l.47-.27a6.92,6.92,0,0,0-2.57-2.63,4.39,4.39,0,0,0-2.14-.77,1.24,1.24,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.76,204.42a1.26,1.26,0,0,1,.66-.18,4.21,4.21,0,0,1,1.8.58,6.46,6.46,0,0,1,3,3,4.12,4.12,0,0,1-1.21,4l-.18.11.41-.23h0l.21-.14a4.12,4.12,0,0,0,1.22-4,6.52,6.52,0,0,0-3-3,4.08,4.08,0,0,0-1.79-.58,1.34,1.34,0,0,0-.66.16l-.44.26Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.18,207.86a3.59,3.59,0,0,0-.15-.37l.46-.27a2.3,2.3,0,0,1,.16.37,4.12,4.12,0,0,1-1.22,4l-.21.14h0l-.41.23.18-.11A4.12,4.12,0,0,0,428.18,207.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.35,210.39a.12.12,0,0,0,.1-.06.11.11,0,0,0-.05-.15l-.16-.1V210a.75.75,0,0,0-.33-.6l-.86-.5a.28.28,0,0,0-.29,0,.35.35,0,0,0-.15.29l-.05,0a.12.12,0,0,0-.12.2l.4.23v-.38c0-.08,0-.11,0-.12a.1.1,0,0,1,.06,0l.86.5a.51.51,0,0,1,.21.4v.25l.28.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,211.09a11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.81-.17.57.57,0,0,1-.35-.1,9.13,9.13,0,0,1-2.63-3.25,12,12,0,0,1-1.13-3.15,4.79,4.79,0,0,1-.12-1.55h-.1c-.21,0-.31.05-.32.08A3.58,3.58,0,0,0,430.87,211.09Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.87,211.09a11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.81-.17.57.57,0,0,1-.35-.1,9.13,9.13,0,0,1-2.63-3.25,12,12,0,0,1-1.13-3.15,4.79,4.79,0,0,1-.12-1.55h-.1c-.21,0-.31.05-.32.08A3.58,3.58,0,0,0,430.87,211.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,210.9a2.2,2.2,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.77.15,2.19,2.19,0,0,1-1.81-.92,8.85,8.85,0,0,1-1-4.87,2,2,0,0,1,.26-1c-.25,0-.63.13-.72,1.21A8.81,8.81,0,0,0,423.61,210.9Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,210.9a2.2,2.2,0,0,0,1.81.93,2,2,0,0,0,1.21-.4l.13-.1-.1.08a2,2,0,0,1-.77.15,2.19,2.19,0,0,1-1.81-.92,8.85,8.85,0,0,1-1-4.87,2,2,0,0,1,.26-1c-.25,0-.63.13-.72,1.21A8.81,8.81,0,0,0,423.61,210.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11,209.26a4,4,0,0,1,1.84.68,5.48,5.48,0,0,1,2.89,4.38,5.94,5.94,0,0,1-.36,2.93.58.58,0,0,1-.85.24,9.13,9.13,0,0,1-2.63-3.25,11.89,11.89,0,0,1-1.13-3.15,3.58,3.58,0,0,1-.08-1.75s.11-.08.32-.08Zm0-.57a.86.86,0,0,0-.83.38c-.35.68,0,3.19,1.22,5.44s2.86,3.78,3.64,3.78a.45.45,0,0,0,.2,0c.66-.3,1.24-1.71,1.07-4a6.09,6.09,0,0,0-3.16-4.82,4.29,4.29,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,204.81a3.75,3.75,0,0,1,1.53.52,5.89,5.89,0,0,1,2.69,2.71,3.55,3.55,0,0,1-1,3.39,2,2,0,0,1-1.21.4,2.22,2.22,0,0,1-1.81-.92,8.87,8.87,0,0,1-1-4.88c.1-1.21.58-1.22.8-1.22Zm0-.57c-.7,0-1.26.44-1.37,1.75a9.4,9.4,0,0,0,1.08,5.22,2.76,2.76,0,0,0,2.29,1.19,2.55,2.55,0,0,0,1.55-.51,4.1,4.1,0,0,0,1.21-4,6.41,6.41,0,0,0-3-3,4.21,4.21,0,0,0-1.8-.58Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,204.24a1.26,1.26,0,0,0-.66.18l0,0,.44-.26a1.34,1.34,0,0,1,.66-.16,4.08,4.08,0,0,1,1.79.58,7,7,0,0,1,2.81,2.66l-.46.27a7.07,7.07,0,0,0-2.81-2.67A4.21,4.21,0,0,0,423.42,204.24Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.56,213.41l7.12-4.1a2.31,2.31,0,0,1,2.38,0,2.35,2.35,0,0,1,1.2,2.06v.26a.35.35,0,0,1-.69,0v-.26a1.69,1.69,0,0,0-.85-1.47,1.67,1.67,0,0,0-1.7,0L436.9,214a.37.37,0,0,1-.17.05.35.35,0,0,1-.3-.17A.34.34,0,0,1,436.56,213.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.42,204.81h0c-.22,0-.7,0-.8,1.22a8.87,8.87,0,0,0,1,4.88,2.22,2.22,0,0,0,1.81.92,2,2,0,0,0,1.21-.4,3.55,3.55,0,0,0,1-3.39,5.89,5.89,0,0,0-2.69-2.71,3.75,3.75,0,0,0-1.53-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11,209.26c-.21,0-.31.05-.32.08a3.58,3.58,0,0,0,.08,1.75,11.89,11.89,0,0,0,1.13,3.15,9.13,9.13,0,0,0,2.63,3.25.58.58,0,0,0,.85-.24,5.94,5.94,0,0,0,.36-2.93,5.48,5.48,0,0,0-2.89-4.38,4,4,0,0,0-1.84-.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.57,209.5a.12.12,0,0,0,.1-.06.1.1,0,0,0,0-.15,72.93,72.93,0,0,0-8-4.65.11.11,0,0,0-.15.05.12.12,0,0,0,.05.16,71.81,71.81,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.37,198l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 195.53 440.37 208.03 440.37 209.64 418.72 197.14 418.72 195.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.43,199l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,199l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,195.33a1.21,1.21,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,445.12,195.33Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.12,195.33a1.21,1.21,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.87.87,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,445.12,195.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,199.3l6.64-3.83a.9.9,0,0,1,.57-.14.78.78,0,0,1,.65.7l.05.27a.87.87,0,0,0,.42.61h0a.93.93,0,0,0,.43.12,1,1,0,0,0,.45-.12.26.26,0,0,0,.12-.26l-.13-.72a2.29,2.29,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,196.56a.86.86,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25.36.36,0,0,1-.07-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,190.4l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,190.4l.5-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,186.7a1.05,1.05,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,430.17,186.7Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.17,186.7a1.05,1.05,0,0,1,.18.43l0,.27a.9.9,0,0,0,.16.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,430.17,186.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,190.67l6.64-3.83a.9.9,0,0,1,.57-.14.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.83.83,0,0,0,.44.12.91.91,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.13-.72a2.28,2.28,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,187.93a.86.86,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25.21.21,0,0,1-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M422.14,190.75s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.65,5.65,0,0,0,2.64,3.34,4.73,4.73,0,0,0,.91.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.07a1.82,1.82,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.14,0,.12,0,.08,0a2,2,0,0,0,.48,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.48,1.48,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.63,3.63,0,0,0,.07-1.48c-.26-.2-.55-.41-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37A3.85,3.85,0,0,0,422.14,190.75Zm9.27,5.35a.56.56,0,0,1,.39-.14h.11a1.2,1.2,0,0,1,.19,0l.18,0a3.76,3.76,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0a.3.3,0,0,1,0,.08l0,0,0,.06,0,.06,0,.06-.06.07,0,.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74C431.22,197.32,431.14,196.38,431.41,196.1Zm-8.07-5.19a.61.61,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.12.17.08.11.05a.2.2,0,0,0,.08,0l.22.12.08.05.08,0c.19.11.41.25.64.41a8,8,0,0,1,2.27,2.34,3.66,3.66,0,0,1,0,2.13,2.71,2.71,0,0,1-.13.44l0,0s0,0,0,0v0s0,0,0,0l-.06.1-.05.08,0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.64,4.64,0,0,1-1-.84,5.81,5.81,0,0,1-1.32-3C423.21,192.51,423,191,423.34,190.91Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M428,198.23h0l.46-.27a1.69,1.69,0,0,0,.63-.67c.26-.45.32-1.16.51-1.56-.65-.21-.58,1.13-1,1.83A1.82,1.82,0,0,1,428,198.23Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M436.46,202.22a13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31l.05,0a.25.25,0,0,1,0,.07,13.3,13.3,0,0,1-.52,2.33,1.57,1.57,0,0,1-.56.63l-.47.27A1.48,1.48,0,0,0,436.46,202.22Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M437.5,198.1l.47-.28a3.54,3.54,0,0,1-.06,1.48l-.43.25-.05,0A3.63,3.63,0,0,0,437.5,198.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.55,188.92l.85.36a18.93,18.93,0,0,1,4.27,2.59,24.64,24.64,0,0,0,2.59,2.44c.75.44,1.23.21,2.59.56a16.85,16.85,0,0,1,4.27,2.33l.85.62-.47.28c-.26-.2-.55-.41-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14,190.75s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.65,5.65,0,0,0,2.64,3.34,4.73,4.73,0,0,0,.91.42l.07,0a2.11,2.11,0,0,0,.74.11h.19l.08,0,.08,0,.08,0,.14-.07h0a1.82,1.82,0,0,0,.62-.67c.4-.7.33-2,1-1.83l.07,0,.07,0c.81.47.7,1.81,1.13,3.06a6.31,6.31,0,0,0,2.91,3.65l.23.13.18.08a2.31,2.31,0,0,0,.42.17l.14,0,.12,0,.08,0a2,2,0,0,0,.48,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.48,1.48,0,0,0,.55-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.63,3.63,0,0,0,.07-1.48c-.26-.2-.55-.41-.86-.62a17,17,0,0,0-4.26-2.34c-1.36-.34-1.84-.12-2.6-.55a25.8,25.8,0,0,1-2.59-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.27-.86-.37A3.85,3.85,0,0,0,422.14,190.75Zm9.27,5.35a.56.56,0,0,1,.39-.14h.11a1.2,1.2,0,0,1,.19,0l.18,0a3.76,3.76,0,0,1,.58.12l.23.07a5.5,5.5,0,0,1,.59.23l.14.06a5.79,5.79,0,0,1,2.4,1.88,4.37,4.37,0,0,1,0,2.38v.09a1.29,1.29,0,0,1-.06.25c0,.05,0,.1,0,.15h0a1.17,1.17,0,0,1-.09.24h0a.3.3,0,0,1,0,.08l0,0,0,.06,0,.06,0,.06-.06.07,0,.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.52,5.52,0,0,1-.6-1.74C431.22,197.32,431.14,196.38,431.41,196.1Zm-8.07-5.19a.61.61,0,0,1,.35,0h0l.15,0,.09,0,.08,0h.07l.07,0,.33.12.17.08.11.05a.2.2,0,0,0,.08,0l.22.12.08.05.08,0c.19.11.41.25.64.41a8,8,0,0,1,2.27,2.34,3.66,3.66,0,0,1,0,2.13,2.71,2.71,0,0,1-.13.44l0,0s0,0,0,0v0s0,0,0,0l-.06.1-.05.08,0,0-.05.05,0,0h0c-.36.36-1,.5-2.09-.15a4.64,4.64,0,0,1-1-.84,5.81,5.81,0,0,1-1.32-3C423.21,192.51,423,191,423.34,190.91Z",
    style: {
      fill: "#37474f"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M431.37,198.19a5.52,5.52,0,0,0,.6,1.74h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.06a2,2,0,0,1-1.37-.33,4.81,4.81,0,0,1-1.9-1.91h0a5.44,5.44,0,0,1-.6-1.74,4.45,4.45,0,0,1,0-1.95.56.56,0,0,0-.39.14C431.14,196.38,431.22,197.32,431.37,198.19Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M423.34,193.28a5.81,5.81,0,0,0,1.32,3,4.64,4.64,0,0,0,1,.84c1.11.65,1.73.51,2.09.15a2.23,2.23,0,0,1-1.61-.43,4.2,4.2,0,0,1-1-.84,5.75,5.75,0,0,1-1.31-3,7.65,7.65,0,0,1-.13-2.14.61.61,0,0,0-.35,0C423,191,423.21,192.51,423.34,193.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.37,198.19a5.52,5.52,0,0,0,.6,1.74h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.06l0-.07.06-.07,0-.06,0-.06,0-.06,0,0a.3.3,0,0,0,0-.08h0a1.17,1.17,0,0,0,.09-.24h0c0-.05,0-.1,0-.15a1.29,1.29,0,0,0,.06-.25v-.09a4.37,4.37,0,0,0,0-2.38,5.79,5.79,0,0,0-2.4-1.88l-.14-.06a5.5,5.5,0,0,0-.59-.23l-.23-.07a3.76,3.76,0,0,0-.58-.12l-.18,0a1.2,1.2,0,0,0-.19,0h-.11a.56.56,0,0,0-.39.14C431.14,196.38,431.22,197.32,431.37,198.19Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34,193.28a5.81,5.81,0,0,0,1.32,3,4.64,4.64,0,0,0,1,.84c1.11.65,1.73.51,2.09.15h0l0,0,.05-.05,0,0,.05-.08.06-.1s0,0,0,0v0s0,0,0,0l0,0a2.71,2.71,0,0,0,.13-.44,3.66,3.66,0,0,0,0-2.13,8,8,0,0,0-2.27-2.34c-.23-.16-.45-.3-.64-.41l-.08,0-.08-.05-.22-.12a.2.2,0,0,1-.08,0l-.11-.05-.17-.08-.33-.12-.07,0H424l-.08,0-.09,0-.15,0h0a.61.61,0,0,0-.35,0C423,191,423.21,192.51,423.34,193.28Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "466.35 299.65 444.7 287.15 444.7 212.14 466.36 224.64 466.35 299.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.36 282.15 453.36 217.14 444.7 212.14 444.7 287.15 453.36 282.15",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 287.15 453.36 282.15 466.35 289.65 466.35 299.65 444.7 287.15",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.42,290.82l.49-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.16,2.16,0,0,0-2.25.12l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,290.82l.49-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.16,2.16,0,0,0-2.25.12l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,287.12a.89.89,0,0,1,.18.43l.05.26a.76.76,0,0,0,.15.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,471.1,287.12Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,287.12a.89.89,0,0,1,.18.43l.05.26a.76.76,0,0,0,.15.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,471.1,287.12Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.89,291.09l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.11.91.91,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.13-.71a2.32,2.32,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,288.35a.86.86,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,282.19l.49-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.19,2.19,0,0,0-2.25.12l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,282.19l.49-.29,0-.92,5.89-3.4a2.21,2.21,0,0,1,2.21-.14l-.43-.25a2.19,2.19,0,0,0-2.25.12l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,278.49a.89.89,0,0,1,.18.43l.05.26a.88.88,0,0,0,.15.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,456.15,278.49Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,278.49a.89.89,0,0,1,.18.43l.05.26a.88.88,0,0,0,.15.37.84.84,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,456.15,278.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.94,282.46l6.65-3.84a.92.92,0,0,1,.56-.13.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.11.79.79,0,0,0,.44-.12.24.24,0,0,0,.12-.26l-.13-.71a2.29,2.29,0,0,0-1-1.64l0,0a2.21,2.21,0,0,0-2.21.14L449,281l0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,279.72a.86.86,0,0,0,.33.35l-.46-.27a.84.84,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M448.12,282.53s.29.08.44.83a25.53,25.53,0,0,0,.53,2.94,5.72,5.72,0,0,0,2.64,3.34,5.43,5.43,0,0,0,.91.42l.07,0a1.9,1.9,0,0,0,.75.1h.19l.07,0,.08,0,.08,0L454,290a1.69,1.69,0,0,0,.61-.66c.41-.7.33-2,1-1.83l.07,0,.08,0c.8.46.69,1.81,1.12,3.06a6.29,6.29,0,0,0,2.92,3.65,1.19,1.19,0,0,0,.22.12l.18.09a3.46,3.46,0,0,0,.43.17l.13,0,.13,0,.08,0a1.5,1.5,0,0,0,.47,0h0l.16,0h0a1.09,1.09,0,0,0,.27-.11h0a1.49,1.49,0,0,0,.54-.62,13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31a3.49,3.49,0,0,0,.07-1.49l-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a25.71,25.71,0,0,1-2.6-2.44,18.33,18.33,0,0,0-4.26-2.6c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,448.12,282.53Zm9.27,5.36a.56.56,0,0,1,.39-.14h.3l.18,0a3.53,3.53,0,0,1,.58.12l.23.07a4.84,4.84,0,0,1,.6.22l.14.07a5.74,5.74,0,0,1,2.39,1.88,4.24,4.24,0,0,1,0,2.37v.1a1.2,1.2,0,0,1-.06.24c0,.05,0,.1,0,.15h0a2.44,2.44,0,0,1-.1.24h0l0,.08,0,0,0,.05,0,.06-.05.07-.05.07-.06.06c-.34.35-.89.49-1.84-.05a5,5,0,0,1-1.91-1.9h0a5.56,5.56,0,0,1-.6-1.75C457.2,289.11,457.13,288.16,457.39,287.89Zm-8.06-5.2a.81.81,0,0,1,.34,0h0l.15,0,.09,0,.08,0h.07l.08,0,.32.12.17.08.11.05.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.17,8.17,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,3.15,3.15,0,0,1-.14.44s0,0,0,0,0,0,0,0l0,0a.08.08,0,0,1,0,.05l-.06.1-.05.08,0,0,0,.05,0,.05h0c-.36.37-1,.51-2.09-.15a4.34,4.34,0,0,1-1-.84,5.63,5.63,0,0,1-1.31-3C449.19,284.3,449,282.83,449.33,282.69Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M454,290h0l.45-.27a1.68,1.68,0,0,0,.64-.68,16.27,16.27,0,0,0,.5-1.55c-.65-.21-.57,1.13-1,1.83A1.69,1.69,0,0,1,454,290Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M462.44,294a13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31l.06,0a.14.14,0,0,0,0,.07,13.94,13.94,0,0,1-.53,2.32,1.45,1.45,0,0,1-.56.63l-.46.27A1.49,1.49,0,0,0,462.44,294Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M463.48,289.88l.47-.27a3.54,3.54,0,0,1-.06,1.48l-.42.25-.06,0A3.49,3.49,0,0,0,463.48,289.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.53,280.71l.85.36a18.57,18.57,0,0,1,4.27,2.59,24.64,24.64,0,0,0,2.59,2.44c.76.44,1.23.21,2.59.55A17.24,17.24,0,0,1,463.1,289l.85.62-.47.27-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a25.71,25.71,0,0,1-2.6-2.44,18.33,18.33,0,0,0-4.26-2.6c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.12,282.53s.29.08.44.83a25.53,25.53,0,0,0,.53,2.94,5.72,5.72,0,0,0,2.64,3.34,5.43,5.43,0,0,0,.91.42l.07,0a1.9,1.9,0,0,0,.75.1h.19l.07,0,.08,0,.08,0L454,290h0a1.69,1.69,0,0,0,.61-.66c.41-.7.33-2,1-1.83l.07,0,.08,0c.8.46.69,1.81,1.12,3.06a6.29,6.29,0,0,0,2.92,3.65,1.19,1.19,0,0,0,.22.12l.18.09a3.46,3.46,0,0,0,.43.17l.13,0,.13,0,.08,0a1.5,1.5,0,0,0,.47,0h0l.16,0h0a1.09,1.09,0,0,0,.27-.11h0a1.49,1.49,0,0,0,.54-.62,13.12,13.12,0,0,0,.53-2.33c.15-.58.44-.31.44-.31a3.49,3.49,0,0,0,.07-1.49l-.86-.62a17,17,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a25.71,25.71,0,0,1-2.6-2.44,18.33,18.33,0,0,0-4.26-2.6c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,448.12,282.53Zm9.27,5.36a.56.56,0,0,1,.39-.14h.3l.18,0a3.53,3.53,0,0,1,.58.12l.23.07a4.84,4.84,0,0,1,.6.22l.14.07a5.74,5.74,0,0,1,2.39,1.88,4.24,4.24,0,0,1,0,2.37v.1a1.2,1.2,0,0,1-.06.24c0,.05,0,.1,0,.15h0a2.44,2.44,0,0,1-.1.24h0l0,.08,0,0,0,.05,0,.06-.05.07-.05.07-.06.06c-.34.35-.89.49-1.84-.05a5,5,0,0,1-1.91-1.9h0a5.56,5.56,0,0,1-.6-1.75C457.2,289.11,457.13,288.16,457.39,287.89Zm-8.06-5.2a.81.81,0,0,1,.34,0h0l.15,0,.09,0,.08,0h.07l.08,0,.32.12.17.08.11.05.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.17,8.17,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,3.15,3.15,0,0,1-.14.44s0,0,0,0,0,0,0,0l0,0a.08.08,0,0,1,0,.05l-.06.1-.05.08,0,0,0,.05,0,.05h0c-.36.37-1,.51-2.09-.15a4.34,4.34,0,0,1-1-.84,5.63,5.63,0,0,1-1.31-3C449.19,284.3,449,282.83,449.33,282.69Z",
    style: {
      fill: "#37474f"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M457.35,290a5.56,5.56,0,0,0,.6,1.75h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.05a1.92,1.92,0,0,1-1.37-.33,4.79,4.79,0,0,1-1.9-1.9h0a5.5,5.5,0,0,1-.61-1.74,4.45,4.45,0,0,1,0-1.95.56.56,0,0,0-.39.14C457.13,288.16,457.2,289.11,457.35,290Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M449.33,285.07a5.63,5.63,0,0,0,1.31,3,4.34,4.34,0,0,0,1,.84c1.11.66,1.73.52,2.09.15a2.16,2.16,0,0,1-1.61-.42,4.44,4.44,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3,8.1,8.1,0,0,1-.13-2.15.81.81,0,0,0-.34,0C449,282.83,449.19,284.3,449.33,285.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.35,290a5.56,5.56,0,0,0,.6,1.75h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.05l.06-.06.05-.07.05-.07,0-.06,0-.05,0,0,0-.08h0a2.44,2.44,0,0,0,.1-.24h0c0-.05,0-.1,0-.15a1.2,1.2,0,0,0,.06-.24v-.1a4.24,4.24,0,0,0,0-2.37,5.74,5.74,0,0,0-2.39-1.88l-.14-.07a4.84,4.84,0,0,0-.6-.22l-.23-.07a3.53,3.53,0,0,0-.58-.12l-.18,0h-.3a.56.56,0,0,0-.39.14C457.13,288.16,457.2,289.11,457.35,290Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.33,285.07a5.63,5.63,0,0,0,1.31,3,4.34,4.34,0,0,0,1,.84c1.11.66,1.73.52,2.09.15h0l0-.05,0-.05,0,0,.05-.08.06-.1a.08.08,0,0,0,0-.05l0,0s0,0,0,0,0,0,0,0a3.15,3.15,0,0,0,.14-.44,3.83,3.83,0,0,0,0-2.13,8.17,8.17,0,0,0-2.28-2.34c-.23-.16-.44-.3-.64-.42l-.08,0-.08-.05-.22-.12-.08,0-.11-.05-.17-.08-.32-.12-.08,0H450l-.08,0-.09,0-.15,0h0a.81.81,0,0,0-.34,0C449,282.83,449.19,284.3,449.33,285.07Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.36,274.65l-13-7.5-8.66,5v1.6l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 272.15 466.36 284.65 466.35 286.25 444.7 273.75 444.7 272.15",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.92,273.67a.41.41,0,0,0,.21-.05l7.59-4.39a1.77,1.77,0,0,1,1.78,0,1.79,1.79,0,0,1,.89,1.54V271a.43.43,0,1,0,.85,0v-.19a2.64,2.64,0,0,0-3.95-2.27l-7.59,4.38a.42.42,0,0,0-.15.58A.42.42,0,0,0,461.92,273.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.79,266.09a.41.41,0,0,0,.21,0l7.59-4.39a1.77,1.77,0,0,1,1.78,0,1.79,1.79,0,0,1,.89,1.54v.19a.43.43,0,1,0,.85,0v-.19a2.64,2.64,0,0,0-3.95-2.27l-7.59,4.38a.42.42,0,0,0-.15.58A.42.42,0,0,0,448.79,266.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.39,264.82a13.27,13.27,0,0,0,.18,3.87c.42,2.41,1.76,4.79,3.44,5.76a2.28,2.28,0,0,0,1.47.34l0,.11.51-.3h0a2.7,2.7,0,0,0,1.05-2.46s.21-.76.68-.49.68,1.28.68,1.28a7.29,7.29,0,0,0,3.05,5.82,2.45,2.45,0,0,0,1.74.37l0,.11.53-.31h0a2.84,2.84,0,0,0,1.2-1.95c.23-1.11.46-3.29,0-4.29-.28-.61-2.54-1.95-3.44-2.32a2.2,2.2,0,0,0-2-.06h0l-.5.29.11,0a2.52,2.52,0,0,0-.51,1.05h0a2.71,2.71,0,0,0-.82-.92.77.77,0,0,0-.82,0h0a7.62,7.62,0,0,0-2.91-4.68c-.88-.65-3.06-1.88-3.41-1.67h0l-.5.29Zm8.73,8.51c0-1.73,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.64,5.64,0,0,1,457.12,273.33Zm-7.46-4.3c0-1.74,1-2.53,2.35-1.78a5.62,5.62,0,0,1,2.35,4.49c0,1.74-1.05,2.53-2.35,1.78A5.62,5.62,0,0,1,449.66,269Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.1,264.67c.37-.21,2.54,1,3.42,1.67a7.14,7.14,0,0,1,1,.9L453,267a7.2,7.2,0,0,0-1-.9c-.88-.65-3.06-1.88-3.41-1.67h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,270.59h0a2.22,2.22,0,0,1,2,.05c.9.38,3.17,1.71,3.44,2.32l.5-.28c-.28-.61-2.54-1.95-3.44-2.32a2.2,2.2,0,0,0-2-.06h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.48,271a.81.81,0,0,1,.77,0,2.43,2.43,0,0,1,.25.2l.5-.29a1.57,1.57,0,0,0-.26-.19.77.77,0,0,0-.82,0h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.5,271.23a2.82,2.82,0,0,1,.56.73h0a3.1,3.1,0,0,1,.24-.67,2.43,2.43,0,0,0-.31-.35Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.23,279.2l.48-.28h0a2.84,2.84,0,0,0,1.2-1.95c.23-1.11.46-3.29,0-4.29l-.5.28c.46,1,.24,3.19,0,4.29A2.85,2.85,0,0,1,461.23,279.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.55,274.87l.46-.27a2.7,2.7,0,0,0,1.05-2.46,1.27,1.27,0,0,1,.1-.24c-.41-.13-.6.53-.6.53A2.75,2.75,0,0,1,453.55,274.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.52,267.24a7.65,7.65,0,0,1,1.9,3.77h0l0,0,.44-.25A7.75,7.75,0,0,0,453,267Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.08,269c.41,2.41,1.75,4.78,3.44,5.75s3-.06,3-2.3c0,0,.22-.76.69-.49s.68,1.28.68,1.28a7.3,7.3,0,0,0,3,5.82c1.69,1,3,.15,3.44-1.79.24-1.1.46-3.28,0-4.29-.28-.61-2.54-1.94-3.44-2.32-1.29-.54-2.19-.24-2.66.65a3.1,3.1,0,0,0-.24.67h0a2.93,2.93,0,0,0-.82-.93.79.79,0,0,0-.83,0h0a7.58,7.58,0,0,0-2.9-4.68c-.9-.66-3.16-1.94-3.44-1.65C447.62,265.16,447.84,267.6,448.08,269Zm8.54,4.64c0-1.74,1.05-2.53,2.35-1.78a5.64,5.64,0,0,1,2.36,4.5c0,1.73-1.06,2.52-2.36,1.77A5.62,5.62,0,0,1,456.62,273.62Zm-7.46-4.31c0-1.73,1.06-2.53,2.36-1.78a5.64,5.64,0,0,1,2.35,4.5c0,1.73-1.05,2.53-2.35,1.78A5.65,5.65,0,0,1,449.16,269.31Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2,273.41a.69.69,0,0,0-.28-.54c-.16-.09-.29,0-.29.21a.69.69,0,0,0,.29.55C462.07,273.72,462.2,273.62,462.2,273.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5,265.5c0-.21.13-.3.29-.21a.69.69,0,0,1,.28.54c0,.21-.13.31-.28.22A.69.69,0,0,1,448.5,265.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.62,273.62a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.64,5.64,0,0,1-2.35-4.5,2.32,2.32,0,0,1,.58-1.73C457.05,271.79,456.62,272.51,456.62,273.62Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.16,269.31a5.65,5.65,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77-.05,1.69,1.69,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C449.59,267.48,449.16,268.21,449.16,269.31Z",
    style: {
      fill: "#26A695",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.62,273.62a5.62,5.62,0,0,0,2.35,4.49,1.42,1.42,0,0,0,1.78-.05,1.64,1.64,0,0,1-1.28-.23,5.64,5.64,0,0,1-2.35-4.5,2.32,2.32,0,0,1,.58-1.73C457.05,271.79,456.62,272.51,456.62,273.62Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.16,269.31a5.65,5.65,0,0,0,2.36,4.5,1.41,1.41,0,0,0,1.77-.05,1.69,1.69,0,0,1-1.28-.24,5.62,5.62,0,0,1-2.35-4.49,2.35,2.35,0,0,1,.58-1.73C449.59,267.48,449.16,268.21,449.16,269.31Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M459,278.11c1.3.75,2.36,0,2.36-1.77a5.64,5.64,0,0,0-2.36-4.5c-1.3-.75-2.35,0-2.35,1.78A5.62,5.62,0,0,0,459,278.11Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.52,273.81c1.3.75,2.35-.05,2.35-1.78a5.64,5.64,0,0,0-2.35-4.5c-1.3-.75-2.36.05-2.36,1.78A5.65,5.65,0,0,0,451.52,273.81Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.36,258l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 255.54 466.36 268.04 466.35 269.65 444.7 257.14 444.7 255.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.42,259.35l.49-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,259.35l.49-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,255.65a.93.93,0,0,1,.18.43l.05.27a.77.77,0,0,0,.15.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,471.1,255.65Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,255.65a.93.93,0,0,1,.18.43l.05.27a.77.77,0,0,0,.15.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,471.1,255.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.89,259.62l6.64-3.84a1,1,0,0,1,.57-.13.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.11.81.81,0,0,0,.44-.12.23.23,0,0,0,.12-.25l-.13-.72a2.28,2.28,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,256.88a.86.86,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,250.72l.49-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,250.72l.49-.29,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.13l-.43-.25a2.16,2.16,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,247a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,456.15,247Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,247a.93.93,0,0,1,.18.43l.05.27a.89.89,0,0,0,.15.36.75.75,0,0,0,.28.25l.46.27a.9.9,0,0,1-.42-.61l-.05-.27A.78.78,0,0,0,456.15,247Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.94,251l6.65-3.83a.87.87,0,0,1,.56-.14.78.78,0,0,1,.65.7l.05.27a.9.9,0,0,0,.42.61h0a.93.93,0,0,0,.44.12.88.88,0,0,0,.44-.12.26.26,0,0,0,.12-.26l-.13-.72a2.25,2.25,0,0,0-1-1.63l0,0a2.19,2.19,0,0,0-2.21.13l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,248.25a.86.86,0,0,0,.33.35l-.46-.27a.75.75,0,0,1-.28-.25l-.06-.1Z",
    style: {
      opacity: 0.15
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M448.12,251.07s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.69,5.69,0,0,0,2.64,3.34,4.73,4.73,0,0,0,.91.42l.07,0a2.13,2.13,0,0,0,.75.11h.19l.07,0,.08,0,.08,0,.15-.07a1.79,1.79,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.8.47.69,1.81,1.12,3.06a6.29,6.29,0,0,0,2.92,3.65l.22.13.18.08a2.39,2.39,0,0,0,.43.17l.13,0,.13,0,.08,0a1.93,1.93,0,0,0,.47,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.46,1.46,0,0,0,.54-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.44,3.44,0,0,0,.07-1.48l-.86-.63a17.3,17.3,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a24.56,24.56,0,0,1-2.6-2.44,18,18,0,0,0-4.26-2.59c-.31-.15-.6-.27-.86-.37A3.85,3.85,0,0,0,448.12,251.07Zm9.27,5.35a.56.56,0,0,1,.39-.14h.3l.18,0a3.53,3.53,0,0,1,.58.12l.23.07c.2.06.4.14.6.22a.61.61,0,0,0,.14.07,5.74,5.74,0,0,1,2.39,1.88,4.27,4.27,0,0,1,0,2.38v.09a1.49,1.49,0,0,1-.06.25s0,.09,0,.14h0a2.44,2.44,0,0,1-.1.24h0l0,.08,0,0,0,.05,0,.07-.05.06-.05.07-.06.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.48,5.48,0,0,1-.6-1.75C457.2,257.64,457.13,256.69,457.39,256.42Zm-8.06-5.2a.69.69,0,0,1,.34,0h0l.15,0,.09,0,.08,0h.07l.08,0,.32.12.17.08.11,0,.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.17,8.17,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2.78,2.78,0,0,1-.14.44v0s0,0,0,.05l0,0a.08.08,0,0,1,0,0l-.06.1a.35.35,0,0,1-.05.08l0,0a.1.1,0,0,0,0,0l0,0h0c-.36.37-1,.51-2.09-.14a4.89,4.89,0,0,1-1-.84,5.69,5.69,0,0,1-1.31-3C449.19,252.83,449,251.36,449.33,251.22Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M454,258.55h0l.45-.27a1.72,1.72,0,0,0,.64-.67c.25-.45.32-1.16.5-1.56-.65-.21-.57,1.13-1,1.83A1.79,1.79,0,0,1,454,258.55Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M462.44,262.54a13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31l.06,0a.14.14,0,0,0,0,.07,14.29,14.29,0,0,1-.53,2.33,1.57,1.57,0,0,1-.56.63l-.46.27A1.46,1.46,0,0,0,462.44,262.54Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M463.48,258.42l.47-.28a3.54,3.54,0,0,1-.06,1.48l-.42.25-.06,0A3.44,3.44,0,0,0,463.48,258.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.53,249.24l.85.36a18.93,18.93,0,0,1,4.27,2.59,24.64,24.64,0,0,0,2.59,2.44c.76.44,1.23.21,2.59.56a16.85,16.85,0,0,1,4.27,2.33l.85.62-.47.28-.86-.63a17.3,17.3,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a24.56,24.56,0,0,1-2.6-2.44,18,18,0,0,0-4.26-2.59c-.31-.15-.6-.27-.86-.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.12,251.07s.29.08.44.82a25.53,25.53,0,0,0,.53,2.94,5.69,5.69,0,0,0,2.64,3.34,4.73,4.73,0,0,0,.91.42l.07,0a2.13,2.13,0,0,0,.75.11h.19l.07,0,.08,0,.08,0,.15-.07h0a1.79,1.79,0,0,0,.61-.67c.41-.7.33-2,1-1.83l.07,0,.08,0c.8.47.69,1.81,1.12,3.06a6.29,6.29,0,0,0,2.92,3.65l.22.13.18.08a2.39,2.39,0,0,0,.43.17l.13,0,.13,0,.08,0a1.93,1.93,0,0,0,.47,0h0l.16,0h0a.81.81,0,0,0,.27-.11h0a1.46,1.46,0,0,0,.54-.63,13.12,13.12,0,0,0,.53-2.33c.15-.57.44-.31.44-.31a3.44,3.44,0,0,0,.07-1.48l-.86-.63a17.3,17.3,0,0,0-4.26-2.33c-1.36-.34-1.84-.12-2.59-.55a24.56,24.56,0,0,1-2.6-2.44,18,18,0,0,0-4.26-2.59c-.31-.15-.6-.27-.86-.37A3.85,3.85,0,0,0,448.12,251.07Zm9.27,5.35a.56.56,0,0,1,.39-.14h.3l.18,0a3.53,3.53,0,0,1,.58.12l.23.07c.2.06.4.14.6.22a.61.61,0,0,0,.14.07,5.74,5.74,0,0,1,2.39,1.88,4.27,4.27,0,0,1,0,2.38v.09a1.49,1.49,0,0,1-.06.25s0,.09,0,.14h0a2.44,2.44,0,0,1-.1.24h0l0,.08,0,0,0,.05,0,.07-.05.06-.05.07-.06.07c-.34.34-.89.48-1.84-.06a5,5,0,0,1-1.91-1.9h0a5.48,5.48,0,0,1-.6-1.75C457.2,257.64,457.13,256.69,457.39,256.42Zm-8.06-5.2a.69.69,0,0,1,.34,0h0l.15,0,.09,0,.08,0h.07l.08,0,.32.12.17.08.11,0,.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.17,8.17,0,0,1,2.28,2.34,3.83,3.83,0,0,1,0,2.13,2.78,2.78,0,0,1-.14.44v0s0,0,0,.05l0,0a.08.08,0,0,1,0,0l-.06.1a.35.35,0,0,1-.05.08l0,0a.1.1,0,0,0,0,0l0,0h0c-.36.37-1,.51-2.09-.14a4.89,4.89,0,0,1-1-.84,5.69,5.69,0,0,1-1.31-3C449.19,252.83,449,251.36,449.33,251.22Z",
    style: {
      fill: "#37474f"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M457.35,258.5a5.48,5.48,0,0,0,.6,1.75h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.06a2,2,0,0,1-1.37-.33,4.88,4.88,0,0,1-1.9-1.91h0a5.5,5.5,0,0,1-.61-1.74,4.45,4.45,0,0,1,0-2,.56.56,0,0,0-.39.14C457.13,256.69,457.2,257.64,457.35,258.5Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M449.33,253.6a5.69,5.69,0,0,0,1.31,3,4.89,4.89,0,0,0,1,.84c1.11.65,1.73.51,2.09.14a2.16,2.16,0,0,1-1.61-.42,4.2,4.2,0,0,1-1-.84,5.84,5.84,0,0,1-1.31-3,8.05,8.05,0,0,1-.13-2.14.69.69,0,0,0-.34,0C449,251.36,449.19,252.83,449.33,253.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.35,258.5a5.48,5.48,0,0,0,.6,1.75h0a5,5,0,0,0,1.91,1.9c.95.54,1.5.4,1.84.06l.06-.07.05-.07.05-.06,0-.07,0-.05,0,0,0-.08h0a2.44,2.44,0,0,0,.1-.24h0s0-.1,0-.14a1.49,1.49,0,0,0,.06-.25V261a4.27,4.27,0,0,0,0-2.38,5.74,5.74,0,0,0-2.39-1.88.61.61,0,0,1-.14-.07c-.2-.08-.4-.16-.6-.22l-.23-.07a3.53,3.53,0,0,0-.58-.12l-.18,0h-.3a.56.56,0,0,0-.39.14C457.13,256.69,457.2,257.64,457.35,258.5Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.33,253.6a5.69,5.69,0,0,0,1.31,3,4.89,4.89,0,0,0,1,.84c1.11.65,1.73.51,2.09.14h0l0,0a.1.1,0,0,1,0,0l0,0a.35.35,0,0,0,.05-.08l.06-.1a.08.08,0,0,0,0,0l0,0s0,0,0-.05v0a2.78,2.78,0,0,0,.14-.44,3.83,3.83,0,0,0,0-2.13,8.17,8.17,0,0,0-2.28-2.34c-.23-.16-.44-.3-.64-.42l-.08,0-.08-.05-.22-.12-.08,0-.11,0-.17-.08-.32-.12-.08,0H450l-.08,0-.09,0-.15,0h0a.69.69,0,0,0-.34,0C449,251.36,449.19,252.83,449.33,253.6Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.35,243l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 240.54 466.36 253.04 466.35 254.65 444.7 242.15 444.7 240.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.58,235.42l7.12-4.11a2.39,2.39,0,0,1,3.58,2.07v.25a.34.34,0,1,1-.68,0v-.25a1.71,1.71,0,0,0-2.56-1.47l-7.12,4.1a.34.34,0,0,1-.17.05.36.36,0,0,1-.3-.17A.34.34,0,0,1,448.58,235.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.54,238.81a1.12,1.12,0,0,1,.55-.12,4.39,4.39,0,0,1,2.14.77,6.14,6.14,0,0,1,3.17,4.82c.15,2.16-.37,3.55-1,3.93l.43-.25c.64-.36,1.18-1.76,1-3.94a6.1,6.1,0,0,0-3.17-4.82,4.26,4.26,0,0,0-2.14-.77,1.13,1.13,0,0,0-.58.13Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.8,242.1l.46-.27a5.56,5.56,0,0,1,.6,2.19c.16,2.18-.38,3.58-1,3.94l-.43.25c.62-.38,1.14-1.77,1-3.93A5.87,5.87,0,0,0,461.8,242.1Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.54,238.81a1.12,1.12,0,0,1,.55-.12,4.39,4.39,0,0,1,2.14.77,6.88,6.88,0,0,1,2.57,2.64l.46-.27a6.84,6.84,0,0,0-2.57-2.63,4.26,4.26,0,0,0-2.14-.77,1.13,1.13,0,0,0-.58.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.74,234.42a1.26,1.26,0,0,1,.67-.17,4.08,4.08,0,0,1,1.79.58,6.52,6.52,0,0,1,3,3,4.12,4.12,0,0,1-1.22,4l-.17.12.4-.24h0l.21-.14a4.11,4.11,0,0,0,1.22-4,6.44,6.44,0,0,0-3-3,4.18,4.18,0,0,0-1.79-.58,1.19,1.19,0,0,0-.65.17l-.45.25Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.17,237.86a3.64,3.64,0,0,0-.16-.36l.46-.27a2.3,2.3,0,0,1,.16.37,4.11,4.11,0,0,1-1.22,4l-.21.14h0l-.4.24.17-.12A4.12,4.12,0,0,0,454.17,237.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.33,240.4a.13.13,0,0,0,.1-.06.12.12,0,0,0,0-.16l-.17-.1V240a.76.76,0,0,0-.32-.61l-.87-.5a.3.3,0,0,0-.29,0,.33.33,0,0,0-.14.3l-.06,0a.1.1,0,0,0-.15,0,.1.1,0,0,0,0,.15l.39.23v-.38c0-.07,0-.11,0-.11s0,0,.06,0l.86.5a.53.53,0,0,1,.21.41v.25l.28.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.85,241.09a11.83,11.83,0,0,0,1.13,3.16,9.17,9.17,0,0,0,2.63,3.24.57.57,0,0,0,.81-.17.56.56,0,0,1-.35-.09,9.12,9.12,0,0,1-2.62-3.25,12.28,12.28,0,0,1-1.14-3.15,5.53,5.53,0,0,1-.12-1.56h-.1c-.21,0-.31,0-.32.07A3.75,3.75,0,0,0,456.85,241.09Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.85,241.09a11.83,11.83,0,0,0,1.13,3.16,9.17,9.17,0,0,0,2.63,3.24.57.57,0,0,0,.81-.17.56.56,0,0,1-.35-.09,9.12,9.12,0,0,1-2.62-3.25,12.28,12.28,0,0,1-1.14-3.15,5.53,5.53,0,0,1-.12-1.56h-.1c-.21,0-.31,0-.32.07A3.75,3.75,0,0,0,456.85,241.09Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,240.91a2.19,2.19,0,0,0,1.81.92,2,2,0,0,0,1.21-.39l.12-.11a.39.39,0,0,1-.1.08,2,2,0,0,1-.77.15,2.18,2.18,0,0,1-1.81-.92,8.73,8.73,0,0,1-1-4.87,2,2,0,0,1,.25-1c-.24,0-.63.13-.72,1.22A8.83,8.83,0,0,0,449.6,240.91Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,240.91a2.19,2.19,0,0,0,1.81.92,2,2,0,0,0,1.21-.39l.12-.11a.39.39,0,0,1-.1.08,2,2,0,0,1-.77.15,2.18,2.18,0,0,1-1.81-.92,8.73,8.73,0,0,1-1-4.87,2,2,0,0,1,.25-1c-.24,0-.63.13-.72,1.22A8.83,8.83,0,0,0,449.6,240.91Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,239.26a3.8,3.8,0,0,1,1.84.69,5.48,5.48,0,0,1,2.9,4.38,6.08,6.08,0,0,1-.37,2.93.58.58,0,0,1-.85.23,9.17,9.17,0,0,1-2.63-3.24,11.83,11.83,0,0,1-1.13-3.16,3.75,3.75,0,0,1-.08-1.75s.11-.08.32-.08Zm0-.57a.86.86,0,0,0-.82.39c-.36.67,0,3.18,1.21,5.43s2.87,3.79,3.64,3.79a.59.59,0,0,0,.2,0c.66-.3,1.24-1.72,1.08-4a6.14,6.14,0,0,0-3.17-4.82,4.39,4.39,0,0,0-2.14-.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,234.82a3.57,3.57,0,0,1,1.52.51,5.93,5.93,0,0,1,2.69,2.71,3.55,3.55,0,0,1-1,3.4,2,2,0,0,1-1.22.39,2.19,2.19,0,0,1-1.8-.92,8.83,8.83,0,0,1-1-4.87c.1-1.22.58-1.22.81-1.22Zm0-.57c-.71,0-1.27.43-1.37,1.74a9.41,9.41,0,0,0,1.07,5.22,2.76,2.76,0,0,0,2.29,1.19,2.6,2.6,0,0,0,1.55-.5,4.09,4.09,0,0,0,1.21-4,6.44,6.44,0,0,0-3-3,4.08,4.08,0,0,0-1.79-.58Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,234.25a1.26,1.26,0,0,0-.67.17l0,0,.45-.25a1.19,1.19,0,0,1,.65-.17,4.18,4.18,0,0,1,1.79.58,6.87,6.87,0,0,1,2.81,2.67l-.46.27a7,7,0,0,0-2.81-2.67A4.08,4.08,0,0,0,449.41,234.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.54,243.41l7.12-4.1a2.39,2.39,0,0,1,3.58,2.07v.25a.34.34,0,0,1-.34.34.35.35,0,0,1-.35-.34v-.25a1.68,1.68,0,0,0-.85-1.48,1.72,1.72,0,0,0-1.7,0L462.88,244a.33.33,0,0,1-.17,0,.34.34,0,0,1-.3-.17A.35.35,0,0,1,462.54,243.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,234.82h0c-.23,0-.71,0-.81,1.22a8.83,8.83,0,0,0,1,4.87,2.19,2.19,0,0,0,1.8.92,2,2,0,0,0,1.22-.39,3.55,3.55,0,0,0,1-3.4,5.93,5.93,0,0,0-2.69-2.71,3.57,3.57,0,0,0-1.52-.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,239.26c-.21,0-.31.06-.32.08a3.75,3.75,0,0,0,.08,1.75,11.83,11.83,0,0,0,1.13,3.16,9.17,9.17,0,0,0,2.63,3.24.58.58,0,0,0,.85-.23,6.08,6.08,0,0,0,.37-2.93,5.48,5.48,0,0,0-2.9-4.38,3.8,3.8,0,0,0-1.84-.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.55,239.5a.12.12,0,0,0,.1-.05.12.12,0,0,0,0-.16,72.26,72.26,0,0,0-8.05-4.64.11.11,0,0,0-.15,0,.11.11,0,0,0,.05.15,73.4,73.4,0,0,1,8,4.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M466.36,228l-13-7.5-8.66,5v1.61l21.65,12.5v-10h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 225.53 466.36 238.04 466.35 239.64 444.7 227.14 444.7 225.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--glasses--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.42,229l.49-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,229l.49-.28,0-.92,5.89-3.4a2.17,2.17,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,225.34a.9.9,0,0,1,.18.42l.05.27a.81.81,0,0,0,.15.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,471.1,225.34Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.1,225.34a.9.9,0,0,1,.18.42l.05.27a.81.81,0,0,0,.15.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,471.1,225.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.89,229.31l6.64-3.84a1,1,0,0,1,.57-.13.77.77,0,0,1,.65.7l.05.27a.86.86,0,0,0,.42.6h0a.83.83,0,0,0,.44.12.91.91,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.13-.71a2.3,2.3,0,0,0-1-1.64l0,0a2.17,2.17,0,0,0-2.21.14l-5.89,3.4,0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,226.57a.9.9,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,220.4l.49-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,220.4l.49-.28,0-.92,5.89-3.4a2.19,2.19,0,0,1,2.21-.14l-.43-.25a2.18,2.18,0,0,0-2.25.11l-5.89,3.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,216.71a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,456.15,216.71Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,216.71a.9.9,0,0,1,.18.42l.05.27a.93.93,0,0,0,.15.37,1,1,0,0,0,.28.25l.46.26a.86.86,0,0,1-.42-.6l-.05-.27A.77.77,0,0,0,456.15,216.71Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.94,220.68l6.65-3.84a.92.92,0,0,1,.56-.13.77.77,0,0,1,.65.7l.05.27a.86.86,0,0,0,.42.6h0a.83.83,0,0,0,.44.12.88.88,0,0,0,.44-.12.25.25,0,0,0,.12-.26l-.13-.71a2.27,2.27,0,0,0-1-1.64l0,0a2.19,2.19,0,0,0-2.21.14L449,219.2l0,.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.94,217.94a.9.9,0,0,0,.33.34l-.46-.26a1,1,0,0,1-.28-.25l-.06-.11Z",
    style: {
      opacity: 0.15
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M448.12,220.75s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.69,5.69,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a1.9,1.9,0,0,0,.75.1h.19l.07,0,.08,0a.13.13,0,0,0,.08,0l.15-.07a1.72,1.72,0,0,0,.61-.67c.41-.7.33-2,1-1.82l.07,0,.08,0c.8.47.69,1.81,1.12,3.06a6.31,6.31,0,0,0,2.92,3.66l.22.12.18.09a3.46,3.46,0,0,0,.43.17l.13,0,.13,0H461a1.27,1.27,0,0,0,.47,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.46,1.46,0,0,0,.54-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.44,3.44,0,0,0,.07-1.48l-.86-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.59-.55a23.51,23.51,0,0,1-2.6-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,448.12,220.75Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.07a5.82,5.82,0,0,1,2.39,1.87,4.27,4.27,0,0,1,0,2.38v.1a1.4,1.4,0,0,1-.06.24c0,.05,0,.1,0,.15h0a2.29,2.29,0,0,1-.1.23h0l0,.07,0,.05,0,0,0,.06-.05.07a.18.18,0,0,0-.05.07l-.06.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C457.2,227.33,457.13,226.38,457.39,226.1Zm-8.06-5.19a.67.67,0,0,1,.34,0h0l.15,0,.09,0,.08,0,.05,0h0l.08,0,.32.12.17.08.11,0,.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.29,8.29,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,3.26,3.26,0,0,1-.14.45v0a.08.08,0,0,0,0,0l0,0s0,0,0,.05l-.06.09a.22.22,0,0,1-.05.08l0,0,0,.05,0,0h0c-.36.37-1,.5-2.09-.15a4.34,4.34,0,0,1-1-.84,5.67,5.67,0,0,1-1.31-3C449.19,222.51,449,221.05,449.33,220.91Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M454,228.23h0l.45-.26a1.75,1.75,0,0,0,.64-.68c.25-.45.32-1.16.5-1.55-.65-.21-.57,1.12-1,1.82A1.72,1.72,0,0,1,454,228.23Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M462.44,232.22a13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32l.06,0a.19.19,0,0,0,0,.07,14.06,14.06,0,0,1-.53,2.33,1.51,1.51,0,0,1-.56.63l-.46.27A1.46,1.46,0,0,0,462.44,232.22Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M463.48,228.1l.47-.27a3.54,3.54,0,0,1-.06,1.48l-.42.24-.06,0A3.44,3.44,0,0,0,463.48,228.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M448.53,218.92l.85.37a18.57,18.57,0,0,1,4.27,2.59,25.8,25.8,0,0,0,2.59,2.44c.76.43,1.23.21,2.59.55a16.92,16.92,0,0,1,4.27,2.34c.31.21.6.42.85.62l-.47.27-.86-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.59-.55a23.51,23.51,0,0,1-2.6-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.12,220.75s.29.08.44.83a25.38,25.38,0,0,0,.53,2.93,5.69,5.69,0,0,0,2.64,3.34,4.84,4.84,0,0,0,.91.43l.07,0a1.9,1.9,0,0,0,.75.1h.19l.07,0,.08,0a.13.13,0,0,0,.08,0l.15-.07h0a1.72,1.72,0,0,0,.61-.67c.41-.7.33-2,1-1.82l.07,0,.08,0c.8.47.69,1.81,1.12,3.06a6.31,6.31,0,0,0,2.92,3.66l.22.12.18.09a3.46,3.46,0,0,0,.43.17l.13,0,.13,0H461a1.27,1.27,0,0,0,.47,0h0l.16,0h0a1.11,1.11,0,0,0,.27-.12h0a1.46,1.46,0,0,0,.54-.63,13,13,0,0,0,.53-2.32c.15-.58.44-.32.44-.32a3.44,3.44,0,0,0,.07-1.48l-.86-.62a17.38,17.38,0,0,0-4.26-2.34c-1.36-.34-1.84-.11-2.59-.55a23.51,23.51,0,0,1-2.6-2.44,18.3,18.3,0,0,0-4.26-2.59c-.31-.14-.6-.26-.86-.36A3.8,3.8,0,0,0,448.12,220.75Zm9.27,5.35a.62.62,0,0,1,.39-.13h.48l.58.12.23.07a4.92,4.92,0,0,1,.6.23l.14.07a5.82,5.82,0,0,1,2.39,1.87,4.27,4.27,0,0,1,0,2.38v.1a1.4,1.4,0,0,1-.06.24c0,.05,0,.1,0,.15h0a2.29,2.29,0,0,1-.1.23h0l0,.07,0,.05,0,0,0,.06-.05.07-.05.07-.06.06c-.34.35-.89.48-1.84,0a4.91,4.91,0,0,1-1.91-1.91h0a5.44,5.44,0,0,1-.6-1.74C457.2,227.33,457.13,226.38,457.39,226.1Zm-8.06-5.19a.67.67,0,0,1,.34,0h0l.15,0,.09,0,.08,0,.05,0h0l.08,0,.32.12.17.08.11,0,.08,0,.22.12.08.05.08,0c.2.12.41.26.64.42a8.29,8.29,0,0,1,2.28,2.33,3.83,3.83,0,0,1,0,2.13,3.26,3.26,0,0,1-.14.45v0a.08.08,0,0,0,0,0l0,0s0,0,0,.05l-.06.09a.22.22,0,0,1-.05.08l0,0,0,.05,0,0h0c-.36.37-1,.5-2.09-.15a4.34,4.34,0,0,1-1-.84,5.67,5.67,0,0,1-1.31-3C449.19,222.51,449,221.05,449.33,220.91Z",
    style: {
      fill: "#37474f"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M457.35,228.19a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.4,1.84,0a1.92,1.92,0,0,1-1.37-.33,4.92,4.92,0,0,1-1.9-1.9h0a5.59,5.59,0,0,1-.61-1.74,4.45,4.45,0,0,1,0-1.95.62.62,0,0,0-.39.13C457.13,226.38,457.2,227.33,457.35,228.19Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M449.33,223.29a5.67,5.67,0,0,0,1.31,3,4.34,4.34,0,0,0,1,.84c1.11.65,1.73.52,2.09.15a2.26,2.26,0,0,1-1.61-.42,4.71,4.71,0,0,1-1-.84,5.83,5.83,0,0,1-1.31-3,8,8,0,0,1-.13-2.14.67.67,0,0,0-.34,0C449,221.05,449.19,222.51,449.33,223.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.35,228.19a5.44,5.44,0,0,0,.6,1.74h0a4.91,4.91,0,0,0,1.91,1.91c.95.53,1.5.4,1.84,0l.06-.06.05-.07.05-.07,0-.06,0,0,0-.05,0-.07h0a2.29,2.29,0,0,0,.1-.23h0c0-.05,0-.1,0-.15a1.4,1.4,0,0,0,.06-.24v-.1a4.27,4.27,0,0,0,0-2.38,5.82,5.82,0,0,0-2.39-1.87l-.14-.07a4.92,4.92,0,0,0-.6-.23l-.23-.07-.58-.12h-.48a.62.62,0,0,0-.39.13C457.13,226.38,457.2,227.33,457.35,228.19Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.33,223.29a5.67,5.67,0,0,0,1.31,3,4.34,4.34,0,0,0,1,.84c1.11.65,1.73.52,2.09.15h0l0,0,0-.05,0,0a.22.22,0,0,0,.05-.08L454,227s0,0,0-.05l0,0a.08.08,0,0,1,0,0v0a3.26,3.26,0,0,0,.14-.45,3.83,3.83,0,0,0,0-2.13,8.29,8.29,0,0,0-2.28-2.33c-.23-.16-.44-.3-.64-.42l-.08,0-.08-.05-.22-.12-.08,0-.11,0-.17-.08-.32-.12-.08,0h0l-.05,0-.08,0-.09,0-.15,0h0a.67.67,0,0,0-.34,0C449,221.05,449.19,222.51,449.33,223.29Z",
    style: {
      fill: "#26A695",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 357.16 479.35 352.15 479.35 157.13 470.68 162.13 470.69 357.16",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 357.16 479.35 352.15 479.35 157.13 470.68 162.13 470.69 357.16",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.86 47.93 281.52 42.93 479.35 157.13 470.68 162.13 272.86 47.93",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,47.93V243l197.82,114.2v-195Zm26,155-21.65-12.51v-75l21.65,12.51Zm26,0-21.64-12.51v-75l21.66,12.51Zm26,30-21.65-12.51v-75l21.65,12.5Zm63.57,36.69-21.65-12.5v-75l21.67,12.49Zm26,0-21.66-12.5v-75l21.67,12.49Zm26,30-21.64-12.5v-75l21.66,12.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 357.16 466.35 354.66 466.35 159.63 470.68 162.13 470.69 357.16",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.69 357.16 466.35 354.66 466.35 159.63 470.68 162.13 470.69 357.16",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 342.15 440.37 339.65 440.37 144.63 444.7 147.13 444.7 342.15",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.7 342.15 440.37 339.65 440.37 144.63 444.7 147.13 444.7 342.15",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 327.15 414.39 324.65 414.39 129.63 418.72 132.13 418.72 327.15",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.72 327.15 414.39 324.65 414.39 129.63 418.72 132.13 418.72 327.15",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.73 312.15 388.4 309.65 388.4 114.63 392.73 117.13 392.73 312.15",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.73 312.15 388.4 309.65 388.4 114.63 392.73 117.13 392.73 312.15",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.15 290.45 350.82 287.96 350.82 92.93 355.15 95.43 355.15 290.45",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.15 290.45 350.82 287.96 350.82 92.93 355.15 95.43 355.15 290.45",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 275.45 324.84 272.95 324.84 77.93 329.17 80.43 329.17 275.45",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.17 275.45 324.84 272.95 324.84 77.93 329.17 80.43 329.17 275.45",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.19 260.45 298.86 257.95 298.86 62.93 303.19 65.43 303.19 260.45",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.19 260.45 298.86 257.95 298.86 62.93 303.19 65.43 303.19 260.45",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 245.45 272.86 242.95 272.86 47.93 277.2 50.43 277.2 245.45",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 245.45 272.86 242.95 272.86 47.93 277.2 50.43 277.2 245.45",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.15 290.45 388.4 309.65 388.39 114.61 355.15 95.43 355.15 290.45",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.77 99.67 357.85 289.31 385.77 305.42 385.78 115.82 357.77 99.67",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,110.55l-18.87,25.34v13.53l25.91-34.8Zm-2.56,188.13L385.77,283V269.45L367,294.61Zm-16.24-9.87,27.93-37.5v-5.16l-27.93,37.5Zm8.82-184-8.89,12v7.62l12.86-17.28Zm-8.87,57.88v5.16l28-37.58v-5.17Zm0,42.29,28-37.55v-22L357.8,183Zm0,20.27,28-37.54v-7.62l-28,37.54Zm0,43.62,27.94-37.52v-5.16l-27.94,37.51Zm0-14.17,27.94-37.52V203.63l-27.95,37.53Z",
    style: {
      fill: "#26A695",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,396.38c-6.9-7.12-11-25-4.22-30.65H76c6.72,5.64,2.68,23.52-4.21,30.64l-.19.19-.24.24c-.19.19-.4.38-.62.56l-.17.13c-.17.14-.33.27-.52.4a7.85,7.85,0,0,1-.89.57c-5.67,3.32-14.87,3.32-20.54,0h0a8.06,8.06,0,0,1-.9-.58c-.17-.12-.33-.24-.48-.37l-.21-.16a7.7,7.7,0,0,1-.6-.54l-.27-.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,363.46c7.81,4.56,7.81,12,0,16.51s-20.47,4.55-28.28,0-7.81-12,0-16.51S65.22,358.9,73,363.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.27,365.65c5.74,3.35,5.74,8.78,0,12.12s-15,3.35-20.76,0-5.74-8.77,0-12.12S63.54,362.3,69.27,365.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.51,371.4c5.73-3.34,15-3.34,20.76,0a9.65,9.65,0,0,1,3.44,3.19,9.63,9.63,0,0,1-3.44,3.18c-5.73,3.35-15,3.35-20.76,0a9.55,9.55,0,0,1-3.44-3.18A9.57,9.57,0,0,1,48.51,371.4Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.59,325.77c-2.63,2.84-9.91,3.62-12.93-4.06-2.83-7.2-5.89-14-6.76-16.67a2.71,2.71,0,0,1,1.74-3.51s.21-4,6.92-1.28S57,307,59.92,313.58,61.08,324.88,56.59,325.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.49,335.92a38.33,38.33,0,0,0-.58-4,54.48,54.48,0,0,0-2.23-7.72,56.27,56.27,0,0,0-7.77-14.34,49.06,49.06,0,0,0-6.1-6.93c-.07-.07-.12.09-.08.14a60.93,60.93,0,0,1,9.57,13.21,61.66,61.66,0,0,1,5.53,15c.33,1.45.64,2.92.91,4.39s.43,3,.68,4.51c0,.15.26.24.27,0A29,29,0,0,0,59.49,335.92Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.49,335.92a38.33,38.33,0,0,0-.58-4,54.48,54.48,0,0,0-2.23-7.72,56.27,56.27,0,0,0-7.77-14.34,49.06,49.06,0,0,0-6.1-6.93c-.07-.07-.12.09-.08.14a60.93,60.93,0,0,1,9.57,13.21,61.66,61.66,0,0,1,5.53,15c.33,1.45.64,2.92.91,4.39s.43,3,.68,4.51c0,.15.26.24.27,0A29,29,0,0,0,59.49,335.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73,323.78c-6,1.86-10.5-2.84-8.95-10.21S62.07,298,65,300.21c1.82-1.83,5.85-1.17,7.74,4.82S72.91,326.39,61.73,323.78Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73,323.78c-6,1.86-10.5-2.84-8.95-10.21S62.07,298,65,300.21c1.82-1.83,5.85-1.17,7.74,4.82S72.91,326.39,61.73,323.78Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.26,304.69a81.55,81.55,0,0,0-4,13.25,129.89,129.89,0,0,0-2.33,13.87A216.19,216.19,0,0,0,57.73,359c0,2.51.05,5,.1,7.53s0,5.19.23,7.76c.08,1,1.48.72,1.5-.18.09-4.52-.16-9-.2-13.57s0-8.93.08-13.39A186.86,186.86,0,0,1,61.88,320c.43-2.5.9-5,1.49-7.46s1.36-5.16,2-7.74C65.44,304.69,65.32,304.56,65.26,304.69Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.26,304.69a81.55,81.55,0,0,0-4,13.25,129.89,129.89,0,0,0-2.33,13.87A216.19,216.19,0,0,0,57.73,359c0,2.51.05,5,.1,7.53s0,5.19.23,7.76c.08,1,1.48.72,1.5-.18.09-4.52-.16-9-.2-13.57s0-8.93.08-13.39A186.86,186.86,0,0,1,61.88,320c.43-2.5.9-5,1.49-7.46s1.36-5.16,2-7.74C65.44,304.69,65.32,304.56,65.26,304.69Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.93,345.39c-2.63,3-8.66,2.72-12.7-2.6s-6.48-25.3-.79-24c1.21-2.67,16.93,3.73,19,16.78C58.86,345,51.93,345.39,51.93,345.39Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.93,345.39c-2.63,3-8.66,2.72-12.7-2.6s-6.48-25.3-.79-24c1.21-2.67,16.93,3.73,19,16.78C58.86,345,51.93,345.39,51.93,345.39Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.63,354.83a28.38,28.38,0,0,0-.77-3.64q-1-3.68-2.34-7.23a75.86,75.86,0,0,0-7-13.79,66.8,66.8,0,0,0-5-7c0-.07-.09.07-.06.12,1.4,2,2.82,4.07,4.09,6.21a76.62,76.62,0,0,1,3.56,6.85,95,95,0,0,1,5.19,13.91c.39,1.36.7,2.73,1.1,4.08s.94,2.77,1.29,4.19c0,.21.32.28.29,0C56.84,357.28,56.79,356.06,56.63,354.83Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.63,354.83a28.38,28.38,0,0,0-.77-3.64q-1-3.68-2.34-7.23a75.86,75.86,0,0,0-7-13.79,66.8,66.8,0,0,0-5-7c0-.07-.09.07-.06.12,1.4,2,2.82,4.07,4.09,6.21a76.62,76.62,0,0,1,3.56,6.85,95,95,0,0,1,5.19,13.91c.39,1.36.7,2.73,1.1,4.08s.94,2.77,1.29,4.19c0,.21.32.28.29,0C56.84,357.28,56.79,356.06,56.63,354.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,342.44c-3.44-.79-3.62-4.92.69-10s15.14-7.29,15.65-5.15c2.41,0,2.41,7.55-2.92,14.48S61.88,347.1,61.56,342.44Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,342.44c-3.44-.79-3.62-4.92.69-10s15.14-7.29,15.65-5.15c2.41,0,2.41,7.55-2.92,14.48S61.88,347.1,61.56,342.44Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,335.06a27.16,27.16,0,0,0-10,12.86c-.11.29.4.73.52.4a31.71,31.71,0,0,1,9.46-13.19S68.34,335,68.3,335.06Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,335.06a27.16,27.16,0,0,0-10,12.86c-.11.29.4.73.52.4a31.71,31.71,0,0,1,9.46-13.19S68.34,335,68.3,335.06Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49,367.62c-4.77,1.93-2.72,7.61,1.93,11.92a21.28,21.28,0,0,0,14.51,5.22,12.22,12.22,0,0,0,4-.67,36.2,36.2,0,0,0,0-7.89,15.25,15.25,0,0,0-11.23-12.1C67.27,362.09,65.49,364.78,65.49,367.62Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,376a38.62,38.62,0,0,0-7.3-6.75c-2.72-1.79-6.34-3.31-9.59-2.2-1.26.43-3.22,1.69-3,3.25,0,.16.3.54.49.33a13.66,13.66,0,0,1,1.71-2,5.19,5.19,0,0,1,2.56-1,11.89,11.89,0,0,1,6.69,1.53c3.22,1.7,5.82,4.36,8.39,6.9C78.68,376.11,78.71,376,78.69,376Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,376a38.62,38.62,0,0,0-7.3-6.75c-2.72-1.79-6.34-3.31-9.59-2.2-1.26.43-3.22,1.69-3,3.25,0,.16.3.54.49.33a13.66,13.66,0,0,1,1.71-2,5.19,5.19,0,0,1,2.56-1,11.89,11.89,0,0,1,6.69,1.53c3.22,1.7,5.82,4.36,8.39,6.9C78.68,376.11,78.71,376,78.69,376Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.34,343.21c.45-2.17-2.68-7.37-12.46-8.37s-17.09,3.15-18.57,5-2.22,3.89-.45,4.39,7.88,1.09,11.89,2.94,12.16,7.29,17.72,5.67S50.1,345.36,47.34,343.21Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.77,350.77c-4.12-8.51-14.75-11.11-23.43-11.06a34.05,34.05,0,0,0-8.47,1.1s-.05.1,0,.1A45.08,45.08,0,0,1,37,340.76a29.3,29.3,0,0,1,12.93,5,17.52,17.52,0,0,1,4.62,5.19C54.69,351.14,54.85,351,54.77,350.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.77,350.77c-4.12-8.51-14.75-11.11-23.43-11.06a34.05,34.05,0,0,0-8.47,1.1s-.05.1,0,.1A45.08,45.08,0,0,1,37,340.76a29.3,29.3,0,0,1,12.93,5,17.52,17.52,0,0,1,4.62,5.19C54.69,351.14,54.85,351,54.77,350.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,331.8c-.13,3.42,4.69,5.4,9.34,2.45S89,328.41,93.3,327.3s6.36-4.63,5-6.34-3.53-6-14.87-4.59-15.36,6.51-16.92,10.12S68.4,332.79,70.11,331.8Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,321a12.41,12.41,0,0,0-4.87.51A24.55,24.55,0,0,0,79.54,323a22.79,22.79,0,0,0-7.09,5.14,19.38,19.38,0,0,0-1.6,1.92,8,8,0,0,0-1.21,2c-.08.22.25.59.45.36.56-.65,1-1.44,1.51-2.12a22.51,22.51,0,0,1,1.82-2.09,23.09,23.09,0,0,1,4.37-3.44,27.42,27.42,0,0,1,4.84-2.36,27.9,27.9,0,0,1,2.83-.85,10.06,10.06,0,0,1,3.08-.43C88.6,321.08,88.62,321,88.57,321Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,321a12.41,12.41,0,0,0-4.87.51A24.55,24.55,0,0,0,79.54,323a22.79,22.79,0,0,0-7.09,5.14,19.38,19.38,0,0,0-1.6,1.92,8,8,0,0,0-1.21,2c-.08.22.25.59.45.36.56-.65,1-1.44,1.51-2.12a22.51,22.51,0,0,1,1.82-2.09,23.09,23.09,0,0,1,4.37-3.44,27.42,27.42,0,0,1,4.84-2.36,27.9,27.9,0,0,1,2.83-.85,10.06,10.06,0,0,1,3.08-.43C88.6,321.08,88.62,321,88.57,321Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,350.25c-1.59-1.59-5.9-1.22-7.95,3.48s2.25,9.83,2.73,11.28c2-1.14,3.5-.46,7-1.14a8.66,8.66,0,0,0,6.65-8.64C70.14,350.93,68.33,348.09,62,350.25Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,349.78a6.36,6.36,0,0,0-2.1,2.18,11.35,11.35,0,0,0-1.37,2.63,11.21,11.21,0,0,0-.6,6c0,.08.08,0,.07,0a12.35,12.35,0,0,1,1-5.91,11.75,11.75,0,0,1,1.43-2.38,12.6,12.6,0,0,1,1-1.1,6.52,6.52,0,0,0,.91-.91C62.34,350.05,62.15,349.66,61.91,349.78Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91,349.78a6.36,6.36,0,0,0-2.1,2.18,11.35,11.35,0,0,0-1.37,2.63,11.21,11.21,0,0,0-.6,6c0,.08.08,0,.07,0a12.35,12.35,0,0,1,1-5.91,11.75,11.75,0,0,1,1.43-2.38,12.6,12.6,0,0,1,1-1.1,6.52,6.52,0,0,0,.91-.91C62.34,350.05,62.15,349.66,61.91,349.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,359.77c-.14-3.5-3.93-6.27-9.32-7.87a14.68,14.68,0,0,0-15.16,4c-3.93,4.28-6,7.92-4.37,8.94s8.75,3.64,13.41,5.1,10.78,1.89,15.44-.88S58.86,361.52,54.49,359.77Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,359.77c-.14-3.5-3.93-6.27-9.32-7.87a14.68,14.68,0,0,0-15.16,4c-3.93,4.28-6,7.92-4.37,8.94s8.75,3.64,13.41,5.1,10.78,1.89,15.44-.88S58.86,361.52,54.49,359.77Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.79,359.38a14.69,14.69,0,0,0-5.86-1.57,26.7,26.7,0,0,0-5.86.07A36.15,36.15,0,0,0,37,359.17c-1,.3-2.06.64-3.08,1a19.22,19.22,0,0,0-2.82,1.16s-.05.13,0,.12c1-.21,1.95-.59,2.91-.89s2.09-.63,3.14-.9a40.79,40.79,0,0,1,6-1.13,26.3,26.3,0,0,1,6.08,0,34.74,34.74,0,0,1,5.52,1.35C55.12,360,55,359.5,54.79,359.38Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.79,359.38a14.69,14.69,0,0,0-5.86-1.57,26.7,26.7,0,0,0-5.86.07A36.15,36.15,0,0,0,37,359.17c-1,.3-2.06.64-3.08,1a19.22,19.22,0,0,0-2.82,1.16s-.05.13,0,.12c1-.21,1.95-.59,2.91-.89s2.09-.63,3.14-.9a40.79,40.79,0,0,1,6-1.13,26.3,26.3,0,0,1,6.08,0,34.74,34.74,0,0,1,5.52,1.35C55.12,360,55,359.5,54.79,359.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,354.56c-3.85-3.06-2.56-10.4,10.92-10.8s23.12,3.13,22.69,7.47c2.17,2.17,1.07,8.25-9.85,10.15S62.83,362.33,65.61,354.56Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,354.56c-3.85-3.06-2.56-10.4,10.92-10.8s23.12,3.13,22.69,7.47c2.17,2.17,1.07,8.25-9.85,10.15S62.83,362.33,65.61,354.56Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.88,351.28a57.84,57.84,0,0,0-12-.71,46.68,46.68,0,0,0-11.12,1.28,16.35,16.35,0,0,0-2.71,1,12.25,12.25,0,0,0-1.19.63c-.3.19-.65.35-.76.71a.38.38,0,0,0,.41.43,14.7,14.7,0,0,0,2.35-1.17,17.67,17.67,0,0,1,2.34-.85,28.69,28.69,0,0,1,4.68-.92,83.38,83.38,0,0,1,11.39-.63c2.21,0,4.42.2,6.63.37C92.92,351.44,92.94,351.29,92.88,351.28Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.88,351.28a57.84,57.84,0,0,0-12-.71,46.68,46.68,0,0,0-11.12,1.28,16.35,16.35,0,0,0-2.71,1,12.25,12.25,0,0,0-1.19.63c-.3.19-.65.35-.76.71a.38.38,0,0,0,.41.43,14.7,14.7,0,0,0,2.35-1.17,17.67,17.67,0,0,1,2.34-.85,28.69,28.69,0,0,1,4.68-.92,83.38,83.38,0,0,1,11.39-.63c2.21,0,4.42.2,6.63.37C92.92,351.44,92.94,351.29,92.88,351.28Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-32"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "283.53 396.82 286.54 395.36 283.58 394.51 283.53 396.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.21,402.58s-35.25-16.3-35.7-13.9a3.49,3.49,0,0,0,0,1.44l-.09-.13.62,4.47a10.51,10.51,0,0,0,5.49,2.36c0-.22,0-1.55.05-2.31a17.46,17.46,0,0,1,3.11,1.69c2.26,1.52,3.7,4.17,6.08,7.25,1.74,2.25,4.86,3.31,9.49,4,5,.74,9.37-.19,10.62-1.53C313.87,404.87,313.39,402.89,313.21,402.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.24,401.74c-.33-.36-1.59-1.77-3.28-3.3a66.58,66.58,0,0,0-5.08-4.41,20.21,20.21,0,0,1-2.52-2.12c-.61-.67-1.2-1.37-1.74-2.09a38.79,38.79,0,0,1-4.22-7.31,16.87,16.87,0,0,1-1.46-3.84,24.17,24.17,0,0,1-.39-4.25c0-6.42.14-7.44.2-12.32l-14.94.39c.47,2.71,1.19,6.42,1.43,9.5.36,4.68.48,5.72-1.37,10.38-.54,1.37-1.35,2.68-1.43,4.15-.13,2.4,1.73,4.48,3.81,5.66,1.73,1,3.72,1.42,5.39,2.46A17.53,17.53,0,0,1,291,399c1.18,1.54,2.12,3.36,3.78,4.45a15.52,15.52,0,0,0,5.75,2,30.89,30.89,0,0,0,7.73.44C312,405.69,314.7,404.37,312.24,401.74Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.23,399.11c-1.51-1.3-3.66-3.16-6.25-5.25a6.6,6.6,0,0,0-5.49.46c-5.27,2.74-6.2,6.67-6.2,6.67a7.58,7.58,0,0,0,4.27,3.81c6.05,2.71,16.92,1.93,17-.88C313.68,402.13,312.07,400.69,310.23,399.11Zm-31-17.76s-.36.92-1.29,2.73a5.1,5.1,0,0,0,0,5.42,8.07,8.07,0,0,0,5.3,3.67C285,387.85,281.31,382.52,279.21,381.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.1,388.51c1,1.61-.25,7.67,0,12,.21,3.92,1.26,10.76.1,14.63-1.37,4.58-4.17,9.9-9.43,5.57-3.26-2.67-5.14-6.13-5.61-11.78-.32-3.92,1.18-9.34,2.47-14.15,1.5-5.61,2.07-8.62,2.07-8.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,359.49c-.38,9.15.68,15.58.75,21.44a42.26,42.26,0,0,1-.84,7.92c-.77,3.74-2.07,8.94-2.62,11.36-.77,3.39-1.35,5.52-.18,9.32a5,5,0,0,0,.38.86c1.64,3.13,5.79,5.49,7.13,5.11a2.29,2.29,0,0,0,2.34.82,2.57,2.57,0,0,0,.44-.11,1.85,1.85,0,0,0,.44-.18,4.53,4.53,0,0,0,2.22-2.87c.08-.26.15-.54.21-.83a34.54,34.54,0,0,0,.43-9.72c0-2.54,0-5,.22-8.44s.73-13.94,1.93-19.09c.88-3.6,2-8.11,3.15-12.92Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,404.62c3.28-1.45,12.78-1.65,14.29,3,0,4.35.07,7.3-2.68,11.09-3.66,5-8.43-.3-10.25-3.69S236.57,407,237,404.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.94,239.94c-4.63,8.3-8.37,15.3-9.57,37.22-1.36,24.74-1.16,34.16-1.28,37.15s-2,8.46-3.68,23.16.09,50.35.09,50.35,1.16,2.4,6.78,2.94a14.25,14.25,0,0,0,8.23-1.32s8.25-46.8,10.28-55.64,8-37.95,8-37.95L275,319.51s-1.65,8.11-.16,21,4.4,39,4.4,39a29.81,29.81,0,0,0,7.86,2,19,19,0,0,0,8.72-1s4.36-52.57,4.47-67.2-1-51.11-5.47-72.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.59,267.76l-4.84,28.09L275,319.51l-1.27-24L278,272.5c3.53-.82,11.58-5,13.83-11C286.38,267.13,276.59,267.76,276.59,267.76ZM260.23,251.2c.64-2.36,1.32-4.7,2.07-7.06a34.62,34.62,0,0,0-3.22,6.69,63.16,63.16,0,0,0-2.17,7.1,71.87,71.87,0,0,0-1.39,7.28,48.13,48.13,0,0,0-.55,7.4c.61-2.41,1.18-4.79,1.74-7.18s1.12-4.76,1.71-7.13S259.6,253.56,260.23,251.2Zm-3.53-1.8c.81-1.43,1.62-2.88,2.36-4.39a25.88,25.88,0,0,0-3.37,3.73,36.54,36.54,0,0,0-2.75,4.2,33.24,33.24,0,0,0-2.1,4.58,20.09,20.09,0,0,0-1.17,4.91L252,258c.78-1.44,1.54-2.89,2.35-4.31S255.9,250.84,256.7,249.4Zm-3.62,93.89q-2.15,11.4-4,22.87,2.73-11.3,5.17-22.63c1.65-7.57,3.2-15.12,4.75-22.73s2.44-15.32,3.24-23,1.44-15.42,2-23.14c-1.12,7.66-2.14,15.33-3.16,23s-2.11,15.31-3.57,22.88S254.48,335.68,253.08,343.29Zm40.27-38.18c.13,3.35.31,6.73.23,10s-.32,6.71-.52,10.06l-.58,10.09q-.59,10.09-1,20.2,1.26-10,2.16-20.11c.6-6.72,1.17-13.42,1.44-20.2,0-6.82-.5-13.52-1.05-20.25s-1.33-13.43-2.32-20.1L292.87,295C293,298.39,293.22,301.75,293.35,305.11Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.66,157.17c-4.52,2.88-4.41,6.92-4.43,16.73s.59,36.59.59,36.59l35.14-.2-.23-40.79s3.21-4.57,2.79-9.25-3.26-10.74-11.7-12.49C270.8,146.31,257.37,147.88,255.66,157.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.13,189.08a4.21,4.21,0,0,0-2.51-.08,27.4,27.4,0,0,0-3.79,1.6c-1.93.78-5.05,2.08-7.15,1.75-.43-.06-1.3-.34-.65-.8a19,19,0,0,0,2.46-1.91,3.76,3.76,0,0,0,1.19-2.78,1.33,1.33,0,0,0-.34-.85c-.33-.31-.59-.17-.89,0a9.26,9.26,0,0,1-1,.47l-2.11.91c-4.09,1.82-8.23,4-10.94,7.7-.39.54-2.88,4.81-4.44,7.21-1.3,2.19-10.07,15.89-10.07,15.89s-10.48-13.61-13.56-17.51c-3.71-4.69-7.46-6.77-12.28-7.16l3.38,20.82s12.36,15.5,14.31,17.27c2.9,2.64,8.45,7.51,12.79,4.09,5.32-4.19,7.9-12,10.31-17.67,2.72-6.34,3.67-9.43,5-11.29s3.24-1.78,4.59-2.05a20.64,20.64,0,0,0,5.42-1.67,19.2,19.2,0,0,0,4.3-2.49,5.9,5.9,0,0,0,1.74-1.67,17.6,17.6,0,0,1,.59-1.92c.39-.68,1.1-1.16,1.41-1.88a7.32,7.32,0,0,0,.33-1.82,3.14,3.14,0,0,1,1.56-2,2.74,2.74,0,0,0,1-.91C351.09,189.67,350.67,189.3,350.13,189.08Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,193.27c5.92,1,7.64.82,14,8.74s12,15.26,12,15.26l6.69-9.57s-.59,2.05,2.82,5.86,6.5,2.91,6.5,2.91-3.84,12.18-9.75,18.23c-4.63,4.75-7.86,2.73-12.79-1-3.09-2.32-16.87-18.35-16.87-18.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.88,217.27c-2.15,3.15-2.4,8.62-2.15,10.29-1.73-5.64-.3-10.33.84-12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.06,193.92a13.67,13.67,0,0,1-5.38,5.4,5.64,5.64,0,0,0,3.71-1.4A5.31,5.31,0,0,0,334.06,193.92Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-32",
    d: "M247.69,251.27c-2.71-2.24-.45-5.32.51-18.91.25-3.51-.92-12.19-.92-12.19s5.07-7.57,3-24.49l11.63-3.4,16,.13,6.27,1.86c2.13,1.91,6,4.92,9.12,9.5,4.46,6.59,5.14,13.76.32,19-.07,1,1,13.09,1.47,17.16.6,5.65,2.75,8.34-.47,11.12C285.26,259.2,260.45,259.77,247.69,251.27Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.91,181.21a5.22,5.22,0,0,1-4.72-1.8c-2.5-2.74-2.73-5.53-1.57-7.38.95-1.53,3.3-2.51,4.95-1.48s1.82,2,2.49,3.25,2.37.28,1.8-4.74c3.42-1.61,2.86-7.34,4.71-9.68,2.9-3.67,7.66-2.72,9.21-1.86a6.24,6.24,0,0,1,6.5-.42c2.3,1.23,3.83,3.82,4.65,12.73.83,9.08-.74,15.13-2.83,17-1.44,1.33-4.12,2.23-7.32,2l0,3.43s9.23,9.62-2.53,8.75a18.47,18.47,0,0,1-13.33-7.55l-.08-13.77S261.67,180.88,259.91,181.21Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.23,179.59a2.63,2.63,0,1,1-5.15-1Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.06,179.43a2.63,2.63,0,0,0,2.08,2.23,2.91,2.91,0,0,0,.93,0A2.66,2.66,0,0,0,274.06,179.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,170.62a1.52,1.52,0,0,1-1.88,1,1.56,1.56,0,1,1,1.88-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,164.81l-3.16-1.69a1.73,1.73,0,0,1,2.37-.78A1.9,1.9,0,0,1,286,164.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,170.23a1.5,1.5,0,1,0,2.81-1,1.5,1.5,0,1,0-2.81,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,163.61l-3.37,1.82a1.84,1.84,0,0,1,.7-2.58A2,2,0,0,1,272,163.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,165.64l-.67,0a20.54,20.54,0,0,0-6.66.51c-2.09.73-2.79,1.46-4,1.52s-2.11-.61-4.42-1.14a23,23,0,0,0-7.15.11l-.71.11a1.09,1.09,0,0,0-.72,1.19,2.66,2.66,0,0,0,.77,1.3,1.62,1.62,0,0,1,.27.53,23.37,23.37,0,0,0,1.12,3.65,5.13,5.13,0,0,0,1,1.29c.16.13.32.25.5.37l.28.16a4.12,4.12,0,0,0,.82.33l.14,0,.22.05.22,0c.22,0,.46.06.72.07h.68c2.93-.12,4.07-1.53,4.7-3s.31-3.4,1.67-3.46h.13l.12,0c1,.18,1,2,1.72,3.27a5.58,5.58,0,0,0,1.06,1.39l.24.21.13.09.13.1.12.08.14.08.1.05.07,0a4.23,4.23,0,0,0,1.2.4l.11,0a6,6,0,0,0,1.44.08,4,4,0,0,0,4-2.75,22.89,22.89,0,0,0,.59-3.73,1.06,1.06,0,0,1,.22-.49,2.53,2.53,0,0,0,.53-1.39A1.17,1.17,0,0,0,289.93,165.64Zm-13.71,5.85a4,4,0,0,1-.88,2h0a4.06,4.06,0,0,1-3.11,1.25,3.72,3.72,0,0,1-3.17-1.28l-.11-.14a1.13,1.13,0,0,0-.1-.13l-.08-.13-.07-.11a790082301810.42,790082301810.42,0,0,1-.1-.18l-.07-.13h0c-.07-.14-.13-.28-.18-.41h0l-.09-.24q-.08-.21-.12-.39l0-.07,0-.08c-.29-1-.69-2.87-.21-3.33s1.77-1,4-.85h.23a8.44,8.44,0,0,1,1,.12l.39.08a8.37,8.37,0,0,1,1,.26l.31.11a2.52,2.52,0,0,1,.33.13l.07,0,.12.06a2.23,2.23,0,0,1,.69.48C276.44,169.12,276.4,170.39,276.22,171.49Zm12.7-1a4.08,4.08,0,0,1-1.85,3.22,3.83,3.83,0,0,1-1.6.42,3.7,3.7,0,0,1-3.36-1.32h0l-.07-.09a.86.86,0,0,0-.07-.1l0-.06-.09-.15-.1-.17-.05-.09s0,0,0,0l0-.07,0-.06a4.55,4.55,0,0,1-.26-.72c-.29-1.07-.5-2.33-.13-2.95s1.94-1.35,3.48-1.61a9.5,9.5,0,0,1,1-.12h.89l.27,0,.51.07.12,0h.12l.12,0,.15,0,.24.08,0,0a1.69,1.69,0,0,1,.56.31C289.2,167.59,289.07,169.52,288.92,170.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,175l-5,2.16-.78-6c.18-.95.34-1.78,1.16-1.86Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,166.87l-7.68,3.68a8.33,8.33,0,0,1,1.19.95l6.69-3Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M277.78,188.92c-4.6-.17-10.76-1.8-12.42-4.77.92,3.2,4.16,4.86,6.75,5.58a26.46,26.46,0,0,0,5.64,1Z",
    style: {
      fill: "#af6152"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.92,190.91s3.62,9.41,3.44,24.6-1.92,60.92-2.86,83.91c-15.41-.92-22.64-7.31-22.64-7.31s1.33-16.35,2.38-30.42c1.08-14.49,3.81-21.77,3.13-31.34-1.92-27.31,4.93-34.67,4.93-34.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.75,190.71l.05,1.64S288.4,200,290.58,211s4.23,87.48,4.23,87.48a20.91,20.91,0,0,0,7.1-3.28c-1.93-28.25-5.85-73-5.85-73a15.68,15.68,0,0,0,2.38-8.7c-.16-5-4.61-12.93-14-20.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.53,236.19c1.6-9.34,2.61-20.35,2.61-20.35l-1.81-2.8h2.25s-3.47-9.87-7.78-15.62a26,26,0,0,0-10-8v3.29s8.73,7.09,11.25,15S292.53,236.19,292.53,236.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.91,188.91a17.35,17.35,0,0,1-3.7,2.94c-2.16,1.25-3.85,2.16-3.85,2.16l5.36,21.28,2.19-.64L260.22,219l4.68,15.34s1.13-16.41.72-26.11a54.18,54.18,0,0,0-3.7-17.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,212.11l-8.65,1.07.35,4.64,8.65-1.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.11,217.61c2.84-2.11,4.27-2.93,5.59-3.31s6-2.31,7.75-2.75c1.13-.28,1.59,1.52.15,2.75a40,40,0,0,1-5.25,2.89c-1.27.69-3.75,3.71-3.75,3.71Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,204.75c2.82-6,5.84-7.39,12-8.31,2.72,6.23,1.21,20.23,1.21,20.23l-3.09,14.69s16.63-2.42,18.56-3.64,7.07-6.77,8.8-8.43c2.35-2.26,3.52-2,4.71-1.78,3.92.59,4.78.92,5.61,1.44a1.78,1.78,0,0,1,.76,1.53c1,.13,2.59.1,2.79,1.81a4.66,4.66,0,0,1,.07,1.36,1.13,1.13,0,0,1,.67.39c.87,1-.62,4.47-1.56,5.32a3.39,3.39,0,0,1-2.84.5c-1.06-.14-.57-1.22-.57-1.22l-1.47.09c-3.19,2.26-3.35,6.75-7.56,7.73a29.55,29.55,0,0,0-5.14,1c-9.06,3-23.92,12.27-32,13-7.88.68-7.65-3.52-7.78-8.35C231.29,237.77,235.4,210.73,238.2,204.75Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.68,229.7l-.33,1.66c-3.59.92-7.81,5.66-8.67,7.62A11.72,11.72,0,0,1,248.68,229.7Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,195.68a30,30,0,0,0-4.4,1.3,10.73,10.73,0,0,0-5.71,4.35c-1.7,2.46-2.53,4.22-4.65,12.14-1.72,6.41-4.84,21.6-5.15,27.22s1.08,7.79,2.48,8.95,4.7,2.06,9.56.53,19.25-7.84,19.25-7.84-2.54-.52-3.13-6,1.33-7,1.33-7l-11.2,1.75,2.71-12.43S254,202.52,250.3,195.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.68,231.06a12.32,12.32,0,0,0-8.82,7.22,11.06,11.06,0,0,1,9.28-9.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.79,220.48l-4.65-.94,4.55.3A1.78,1.78,0,0,1,286.79,220.48Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,223.65l-5.36-.69,5.36.07A2.57,2.57,0,0,1,289.65,223.65Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.94,226a1.7,1.7,0,0,1-.72.63,3.62,3.62,0,0,1-.91.31l.07,0-.45.82-.11-.14a1.11,1.11,0,0,1,.85.21,1.41,1.41,0,0,1,.46.7,1.59,1.59,0,0,0-.54-.58,1.11,1.11,0,0,0-.73-.14l-.2,0,.09-.19c.15-.28.29-.56.45-.83l0,0h0a4.72,4.72,0,0,0,.89-.25A2,2,0,0,0,288.94,226Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.52,226.7a16.88,16.88,0,0,1-1.94.14,2.08,2.08,0,0,1-.66,1,11.32,11.32,0,0,1-1,.87l1.47-.09a2.4,2.4,0,0,1,1.69-.91Z",
    style: {
      fill: "#af6152"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244,102.82a25.33,25.33,0,0,1,7.43,17.06l-.07,2.9a25.31,25.31,0,0,1-50.46.12l-.07-2.9A25.31,25.31,0,0,1,244,102.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.67,101.4a27.47,27.47,0,0,0,35.45,41.73l7.82,3.43a1.6,1.6,0,0,0,2.1-2.11l-3.47-7.8a27.47,27.47,0,0,0-41.9-35.25ZM244,102.82a25.33,25.33,0,0,1,7.43,17.06l-.07,2.9a25.31,25.31,0,0,1-50.46.12l-.07-2.9A25.31,25.31,0,0,1,244,102.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,102.82a25.33,25.33,0,0,1,7.43,17.06l-.07,2.9a25.31,25.31,0,0,1-50.46.12l-.07-2.9A25.31,25.31,0,0,1,244,102.82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Specs--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.14,124.79c1.35,0,1.49,1.72,2.06,3.21.46,1.22,1.56,4.32,8.26,4.32s7.26-3.5,7.82-6.26.92-4.26,1.84-4.26.85-2.14,0-2.14h-9.58c-4.42,0-7.14.14-8.06.79s-.77,1.6-2.34,1.6-1.41-.94-2.33-1.6-3.64-.79-8.06-.79h-9.58c-.85,0-.92,2.14,0,2.14s1.26,1.44,1.84,4.26,1.11,6.26,7.81,6.26,7.8-3.1,8.27-4.32C224.66,126.51,224.8,124.79,226.14,124.79Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,119.66s7.35-8.63,8.63-9.91c.47-.48,1.74-.4,3.76-.4,1.67,0,1.68.54,1.28,1.08a2.07,2.07,0,0,1-2.39.62l-.63-.24a.91.91,0,0,0-1.07.31l-6.28,8.54Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.17,119.66s7.35-8.63,8.63-9.91c.47-.48,1.74-.4,3.76-.4,1.67,0,1.68.54,1.28,1.08a2.07,2.07,0,0,1-2.39.62l-.63-.24a.91.91,0,0,0-1.07.31l-6.28,8.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12,119.66s-7.35-8.63-8.63-9.91c-.47-.48-1.74-.4-3.76-.4-1.67,0-1.69.54-1.28,1.08a2.07,2.07,0,0,0,2.39.62l.63-.24a.89.89,0,0,1,1.06.31l6.28,8.54Z",
    style: {
      fill: "#26A695"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.12,119.66s-7.35-8.63-8.63-9.91c-.47-.48-1.74-.4-3.76-.4-1.67,0-1.69.54-1.28,1.08a2.07,2.07,0,0,0,2.39.62l.63-.24a.89.89,0,0,1,1.06.31l6.28,8.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.19,127.56c-.56,1.71-2.23,3-6.37,2.95a8.19,8.19,0,0,1-3.61-.67,3.93,3.93,0,0,1-2.11-2.59c-.79-2.62-.83-4-.16-4.8.86-1,3-1.24,5.88-1.24a21.15,21.15,0,0,1,4.6.36,3.26,3.26,0,0,1,2.22,1.32C223.13,123.72,222.74,125.85,222.19,127.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.19,127.25c-.58,1.92-2,3.25-5.73,3.26a14.62,14.62,0,0,1-2.56-.2c-2.31-.42-3.37-1.45-3.8-2.75-.55-1.71-.95-3.84-.46-4.67.9-1.53,3.9-1.68,6.82-1.68,2.6,0,4.56.18,5.55.93a1.64,1.64,0,0,1,.33.31C243,123.24,243,124.63,242.19,127.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,122.14l-8.11,8.17c-2.31-.42-3.37-1.45-3.8-2.75-.55-1.71-.95-3.84-.46-4.67.9-1.53,3.9-1.68,6.82-1.68C239.06,121.21,241,121.39,242,122.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.42,121.57l-8.21,8.27a3.93,3.93,0,0,1-2.11-2.59c-.79-2.62-.83-4-.16-4.8.86-1,3-1.24,5.88-1.24A21.15,21.15,0,0,1,220.42,121.57Z",
    style: {
      fill: "#455a64"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpticaImg);
export default __webpack_public_path__ + "static/media/optica_img.af35cb9ef09f5553eee64246b5770c29.svg";
export { ForwardRef as ReactComponent };